// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import {
//   Alert,
//   Box,
//   Button,
//   Chip,
//   CircularProgress,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Fab,
//   Grid,
//   IconButton,
//   Menu,
//   MenuItem,
//   Snackbar,
//   Stack,
//   TextField,
//   Tooltip,
//   Typography,
//   useMediaQuery,
//   useTheme,
//   Tabs,
//   Tab,
//   Paper,
//   FormControlLabel,
//   Checkbox,
//   alpha
// } from '@mui/material';
// import { blue, green, grey, orange, purple, red } from '@mui/material/colors';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { useAppSelector } from 'app/hooks';
// import { AppDispatch, RootState } from 'app/store';
// import ConfirmationDialog from 'commonComponents/ConfirmationDialog';
// import { useWindowSize } from 'hooks/useWindowSize';
// import {
//   MdAssignment,
//   MdCategory,
//   MdCheckCircle,
//   MdClose,
//   MdDelete,
//   MdDownloadForOffline,
//   MdPendingActions,
//   MdRestore,
//   MdSend,
//   MdThumbUp,
//   MdGesture,
//   MdTextFields,
//   MdCheckBox,
//   MdFolder,
//   MdCloudUpload,
//   MdDescription
// } from 'react-icons/md';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';
// import { useDispatch, useSelector } from 'react-redux';
// import SignatureCanvas from 'react-signature-canvas';
// import {
//   acceptDeleteReassignDoc,
//   clearAcceptDeleteReassignError,
//   clearAcceptDeleteReassignSuccess,
//   getAllAssignedDocuments,
//   submitESignDoc
// } from 'slices/payrolslices/documentTemplateSlice';
// import AssignedDocumentCategoriesList from './assignedList/AssignedDocumentCategoriesList';
// import AssignedInputFieldOverlay from './assignedList/AssignedInputFieldOverlay';
// import AssignedList from './assignedList/AssignedList';
// import {
//   buttonStyles,
//   getCategoryColor,
//   getCategoryIcon,
//   typography
// } from './documentHelper/DocumentHelperFunctions';
// import {
//   AcceptDeleteReassignDocPayload,
//   AssignedDocument,
//   AssignedDocumentCategory,
//   InputField
// } from './types';
// import axiosInstance from 'Services/APIService';
// import { useDocumentManagement } from './DocumentManagementContext';

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// type DocumentStatus = 'pending_fill' | 'filled_submitted' | 'approved' | 'rejected';
// type ConfirmActionType = 'approve' | 'delete' | 'reassign';
// type SignatureMode = 'pad' | 'name' | 'standard';

// const statusColors: Record<DocumentStatus, string> = {
//   pending_fill: orange[500],
//   filled_submitted: blue[500],
//   approved: green[500],
//   rejected: red[500]
// };

// const statusIcons = {
//   pending_fill: <MdPendingActions />,
//   filled_submitted: <MdAssignment />,
//   approved: <MdCheckCircle />,
//   rejected: <MdClose />
// };

// const statusLabels = {
//   pending_fill: 'Fill Required',
//   filled_submitted: 'Submitted',
//   approved: 'Approved',
//   rejected: 'Rejected'
// };

// const AssignedDocumentsList: React.FC = () => {
//   const dispatch = useDispatch<AppDispatch>();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const windowSize = useWindowSize();

//   // Redux state
//   const {
//     assignedDocumentsLoading: loading,
//     assignedDocumentsError: error,
//     assignedDocumentCategories: categories,
//     totalAssignedDocuments: totalDocuments,
//     acceptDeleteReassignLoading,
//     acceptDeleteReassignError,
//     acceptDeleteReassignSuccess,
//     acceptDeleteReassignMessage
//   } = useSelector((state: RootState) => state.documentTemplate);

//   // Local state for new nested structure
//   const [categoryData, setCategoryData] = useState<AssignedDocumentCategory[]>([]);
//   const [selectedCategory, setSelectedCategory] = useState<string>('');
//   const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
//   const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());

//   // Fixed: Add states to track selected IDs
//   const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
//   const [selectedSubcategoryId, setSelectedSubcategoryId] = useState<string>('');

//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState<string>('all');
//   const [filteredDocuments, setFilteredDocuments] = useState<AssignedDocument[]>([]);

//   // Preview modal state
//   const [previewModalOpen, setPreviewModalOpen] = useState(false);
//   const [selectedDocument, setSelectedDocument] = useState<AssignedDocument | null>(null);
//   const [documentPreviewUrl, setDocumentPreviewUrl] = useState<string | null>(null);
//   const [previewLoading, setPreviewLoading] = useState(false);
//   const [pdfNumPages, setPdfNumPages] = useState<number>(0);
//   const [currentPdfPage, setCurrentPdfPage] = useState<number>(1);
//   const [scale, setScale] = useState<number>(1.0);

//   // Field editing states
//   const [editingFieldId, setEditingFieldId] = useState<string | null>(null);
//   const [fieldEditValue, setFieldEditValue] = useState<string>('');
//   const [fieldEditAnchor, setFieldEditAnchor] = useState<HTMLElement | null>(null);
//   const [documentModified, setDocumentModified] = useState(false);

//   // Enhanced edit dialog states
//   const [selectedField, setSelectedField] = useState<InputField | null>(null);
//   const [showEditDialog, setShowEditDialog] = useState(false);
//   const [signatureMode, setSignatureMode] = useState<SignatureMode>('pad');
//   const [tempFieldValue, setTempFieldValue] = useState<string>('');
//   const [typedName, setTypedName] = useState<string>('');
//   const [isStandardChecked, setIsStandardChecked] = useState<boolean>(false);
//   const signatureCanvasRef = useRef<SignatureCanvas>(null);
//   const [thumbnailsLoaded, setThumbnailsLoaded] = useState<Set<number>>(new Set());

//   // NEW: Upload states for empty templates
//   const [uploadedFileData, setUploadedFileData] = useState<{
//     fileName: string;
//     fileSize: number;
//     fileType: string;
//     base64Data: string;
//     originalFileName: string;
//   } | null>(null);
//   const [uploadLoading, setUploadLoading] = useState(false);

//   // Legacy states for compatibility
//   const [signaturePadOpen, setSignaturePadOpen] = useState(false);
//   const [datePickerOpen, setDatePickerOpen] = useState(false);
//   const [signatureFieldId, setSignatureFieldId] = useState<string | null>(null);
//   const [dateFieldId, setDateFieldId] = useState<string | null>(null);
//   const [tempDate, setTempDate] = useState<Date | null>(null);
//   const sigPadRef = useRef<SignatureCanvas>(null);

//   // Action states
//   const [actionLoading, setActionLoading] = useState<string | null>(null);
//   const [successMessage, setSuccessMessage] = useState<string | null>(null);
//   const [errorMessage, setErrorMessage] = useState<string | null>(null);

//   // Confirmation dialog state
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [confirmDocument, setConfirmDocument] = useState<AssignedDocument | null>(null);
//   const [confirmAction, setConfirmAction] = useState<ConfirmActionType | null>(null);

//   // Mobile menu states
//   const [categoryMenuAnchor, setCategoryMenuAnchor] = useState<null | HTMLElement>(null);
//   const [actionMenuAnchor, setActionMenuAnchor] = useState<null | HTMLElement>(null);
//   const [currentActionDoc, setCurrentActionDoc] = useState<AssignedDocument | null>(null);

//   // PDF container reference
//   const pdfContainerRef = useRef<HTMLDivElement>(null);
//   const [pdfRenderTrigger, setPdfRenderTrigger] = useState(0);

//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector(
//     (state) => state.serviceSelected.selectedServiceTitle
//   );

//   const { isAdminLogin } = useDocumentManagement();

//   // Helper function to show messages
//   const showMessage = useCallback((message: string, isError: boolean = false) => {
//     if (isError) {
//       setErrorMessage(message);
//       setSuccessMessage(null);
//     } else {
//       setSuccessMessage(message);
//       setErrorMessage(null);
//     }
//   }, []);

//   // Effect to handle success/error messages from Redux
//   useEffect(() => {
//     if (acceptDeleteReassignSuccess && acceptDeleteReassignMessage) {
//       showMessage(acceptDeleteReassignMessage);
//       dispatch(clearAcceptDeleteReassignSuccess());
//     }

//     if (acceptDeleteReassignError) {
//       showMessage(acceptDeleteReassignError, true);
//       dispatch(clearAcceptDeleteReassignError());
//     }
//   }, [
//     acceptDeleteReassignSuccess,
//     acceptDeleteReassignMessage,
//     acceptDeleteReassignError,
//     dispatch,
//     showMessage
//   ]);

//   // Calculate PDF width dynamically
//   const calculatePdfWidth = () => {
//     const padding = isMobile ? 32 : 48;
//     const availableWidth = windowSize.width - padding;
//     return Math.max(Math.min(availableWidth * 0.95, isMobile ? 350 : 700), 280);
//   };

//   // Enhanced validation function
//   const validateRequiredFields = (): {
//     isValid: boolean;
//     missingFields: string[];
//     missingFieldLabels: string[];
//   } => {
//     if (!selectedDocument?.inputFields) {
//       return { isValid: true, missingFields: [], missingFieldLabels: [] };
//     }

//     const missingFields: string[] = [];
//     const missingFieldLabels: string[] = [];

//     selectedDocument.inputFields.forEach((field) => {
//       if (field.isRequired) {
//         const hasValue = field.value && field.value.toString().trim() !== '';
//         if (!hasValue) {
//           missingFields.push(field.type);
//           missingFieldLabels.push(field.fieldLabel || field.type);
//         }
//       }
//     });

//     return {
//       isValid: missingFields.length === 0,
//       missingFields,
//       missingFieldLabels
//     };
//   };

//   // Main update field value function
//   const updateFieldValue = useCallback(
//     (fieldId: string, value: string) => {
//       if (!selectedDocument) return;

//       const updatedDocument = {
//         ...selectedDocument,
//         inputFields: selectedDocument.inputFields.map((field) =>
//           field.id === fieldId ? { ...field, value } : field
//         )
//       };

//       setSelectedDocument(updatedDocument);
//       setDocumentModified(true);
//       setPdfRenderTrigger((prev) => prev + 1);
//       setSuccessMessage('Field updated successfully');
//     },
//     [selectedDocument]
//   );

//   // NEW: File upload handler for empty templates
//   const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (!file) return;

//     // Validate file
//     const maxSize = 10 * 1024 * 1024; // 10MB
//     const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

//     if (file.size > maxSize) {
//       setErrorMessage('File size must be less than 10MB');
//       return;
//     }

//     if (!allowedTypes.includes(file.type)) {
//       setErrorMessage('Only PDF, JPG, and PNG files are allowed');
//       return;
//     }

//     setUploadLoading(true);
//     try {
//       // Convert file to base64
//       const reader = new FileReader();
//       reader.onload = () => {
//         const base64String = reader.result as string;
//         const base64Data = base64String.split(',')[1]; // Remove data:image/jpeg;base64, prefix

//         // Get the exact file extension from the file name or MIME type
//         const getFileExtension = (fileName: string, mimeType: string): string => {
//           // First try to get extension from filename
//           const extensionFromName = fileName.split('.').pop()?.toLowerCase();

//           if (extensionFromName) {
//             return extensionFromName;
//           }

//           // Fallback: map MIME type to extension
//           const mimeToExtension: { [key: string]: string } = {
//             'application/pdf': 'pdf',
//             'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
//             'application/msword': 'doc',
//             'image/png': 'png',
//             'image/jpeg': 'jpg',
//             'image/jpg': 'jpg'
//           };

//           return mimeToExtension[mimeType] || 'unknown';
//         };

//         const fileExtension = getFileExtension(file.name, file.type);

//         const fileData = {
//           fileName: file.name,
//           fileSize: file.size,
//           fileType: fileExtension, // Use exact file extension instead of generic 'image' or 'pdf'
//           base64Data: base64Data,
//           originalFileName: file.name
//         };

//         setUploadedFileData(fileData);

//         // Create blob URL for preview
//         const blobUrl = URL.createObjectURL(file);
//         setDocumentPreviewUrl(blobUrl);

//         // Update selected document for consistent state
//         if (selectedDocument) {
//           const updatedDocument = {
//             ...selectedDocument,
//             uploadedFile: {
//               fileName: file.name,
//               fileSize: file.size,
//               fileType: fileExtension, // Use exact extension here too
//               originalFileName: file.name,
//               storedFilePath: base64Data // Store base64 temporarily
//             }
//           };
//           setSelectedDocument(updatedDocument);
//         }

//         // Reset PDF pages for new document
//         if (file.type.includes('pdf')) {
//           setPdfNumPages(0);
//           setCurrentPdfPage(1);
//           setPdfRenderTrigger(0);
//         } else {
//           setPdfRenderTrigger((prev) => prev + 1);
//         }

//         setSuccessMessage('Document uploaded successfully');
//         setUploadLoading(false);
//       };

//       reader.onerror = () => {
//         setErrorMessage('Failed to read file');
//         setUploadLoading(false);
//       };

//       reader.readAsDataURL(file);
//     } catch (error) {
//       console.error('Upload failed:', error);
//       setErrorMessage('Failed to process document. Please try again.');
//       setUploadLoading(false);
//     }
//   };

//   // Load assigned documents on component mount
//   useEffect(() => {
//     const loadAssignedDocuments = async () => {
//       if (selectedProjectId && selectedServiceTitle) {
//         try {
//           await dispatch(
//             getAllAssignedDocuments({
//               group_id: selectedProjectId,
//               service_id: selectedServiceTitle,
//               isAdmin: isAdminLogin
//             })
//           ).unwrap();
//         } catch (error) {
//           console.error('Failed to load assigned documents:', error);
//         }
//       }
//     };

//     loadAssignedDocuments();
//   }, [dispatch, selectedProjectId, selectedServiceTitle]);

//   // Process new nested categories structure
//   useEffect(() => {
//     if (categories.length > 0) {
//       setCategoryData(categories);

//       // Auto-select first category and subcategory
//       console.log('Categories loaded:', categories);
//       if (!selectedCategory) {
//         const firstCategory = categories[0];
//         setSelectedCategory(firstCategory?.categoryName);
//         setSelectedCategoryId(firstCategory?.categoryId);
//         setExpandedCategories(new Set([firstCategory?.categoryName]));

//         if (
//           firstCategory?.subcategories &&
//           firstCategory.subcategories.length > 0 &&
//           !selectedSubcategory
//         ) {
//           setSelectedSubcategory(firstCategory?.subcategories[0]?.subcategoryName);
//           setSelectedSubcategoryId(firstCategory?.subcategories[0]?.subcategoryId);
//         }
//       }
//     }
//   }, [categories, loading, selectedCategory, selectedSubcategory]);

//   // Filter documents by selected category and subcategory
//   useEffect(() => {
//     let docs: AssignedDocument[] = [];

//     if (selectedCategory && selectedSubcategory) {
//       const categoryItem = categoryData.find((cat) => cat.categoryName === selectedCategory);
//       if (categoryItem) {
//         const subcategoryItem = categoryItem.subcategories.find(
//           (sub) => sub.subcategoryName === selectedSubcategory
//         );
//         if (subcategoryItem) {
//           docs = [...subcategoryItem.assignedDocuments];
//         }
//       }
//     }

//     // Apply search filter
//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       docs = docs.filter(
//         (doc) =>
//           doc.documentName.toLowerCase().includes(term) ||
//           doc.assignedEmpName.toLowerCase().includes(term) ||
//           doc.assignedEmployeeMailId.toLowerCase().includes(term)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== 'all') {
//       if (statusFilter === 'pending') {
//         docs = docs.filter((doc) => !doc.isSubmitted);
//       } else if (statusFilter === 'submitted') {
//         docs = docs.filter((doc) => doc.isSubmitted);
//       }
//     }

//     setFilteredDocuments(docs);
//   }, [selectedCategory, selectedSubcategory, categoryData, searchTerm, statusFilter]);

//   // Effect to handle PDF loading and overlay rendering
//   useEffect(() => {
//     if (documentPreviewUrl && pdfNumPages > 0) {
//       const timer = setTimeout(() => {
//         setPdfRenderTrigger((prev) => prev + 1);
//       }, 300);
//       return () => clearTimeout(timer);
//     }
//   }, [documentPreviewUrl, pdfNumPages, currentPdfPage, scale]);

//   // Category handlers for new nested structure
//   const handleCategoryToggle = useCallback((categoryName: string) => {
//     setExpandedCategories((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(categoryName)) {
//         newSet.delete(categoryName);
//       } else {
//         newSet.add(categoryName);
//       }
//       return newSet;
//     });
//   }, []);

//   // Fixed: Update subcategory selection to include IDs
//   const handleSubcategorySelect = useCallback(
//     (categoryName: string, subcategoryName: string) => {
//       // Find the category and subcategory to get their IDs
//       const categoryItem = categoryData.find((cat) => cat.categoryName === categoryName);
//       const subcategoryItem = categoryItem?.subcategories.find(
//         (sub) => sub.subcategoryName === subcategoryName
//       );

//       setSelectedCategory(categoryName);
//       setSelectedSubcategory(subcategoryName);
//       setSelectedCategoryId(categoryItem?.categoryId || '');
//       setSelectedSubcategoryId(subcategoryItem?.subcategoryId || '');
//       setCategoryMenuAnchor(null);
//     },
//     [categoryData]
//   );

//   const getDocumentStatus = (document: AssignedDocument): DocumentStatus => {
//     if (document.isApproved) {
//       return 'approved';
//     }
//     if (document.isSubmitted) {
//       return 'filled_submitted';
//     }
//     return 'pending_fill';
//   };

//   const formatDate = (dateString: string) => {
//     try {
//       return new Date(dateString).toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric'
//       });
//     } catch {
//       return dateString;
//     }
//   };

//   // Event handlers
//   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleStatusFilterChange = (e: any) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setStatusFilter('all');
//   };

//   // Document preview functions
//   const fetchDocumentPreview = async (document: AssignedDocument) => {
//     if (!document.uploadedFile?.storedFilePath) {
//       return null;
//     }

//     try {
//       setPreviewLoading(true);
//       const encodedPath = encodeURIComponent(document.uploadedFile.storedFilePath);
//       const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
//         responseType: 'blob'
//       });

//       const blobUrl = URL.createObjectURL(response.data);
//       setDocumentPreviewUrl(blobUrl);
//       return blobUrl;
//     } catch (error) {
//       console.error('Error fetching document preview:', error);
//       return null;
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   const handlePreviewDocument = async (document: AssignedDocument) => {
//     setSelectedDocument(document);
//     setPreviewModalOpen(true);
//     setCurrentPdfPage(1);
//     setDocumentModified(false);
//     setPdfRenderTrigger(0);
//     setUploadedFileData(null); // Reset upload state
//     await fetchDocumentPreview(document);
//   };

//   const handleClosePreview = () => {
//     setPreviewModalOpen(false);
//     setSelectedDocument(null);
//     setDocumentModified(false);
//     setEditingFieldId(null);
//     setFieldEditAnchor(null);
//     setSignaturePadOpen(false);
//     setDatePickerOpen(false);
//     setSignatureFieldId(null);
//     setDateFieldId(null);
//     setShowEditDialog(false);
//     setSelectedField(null);
//     setPdfRenderTrigger(0);
//     setUploadedFileData(null); // Reset upload state
//     if (documentPreviewUrl) {
//       URL.revokeObjectURL(documentPreviewUrl);
//       setDocumentPreviewUrl(null);
//     }
//     setPdfNumPages(0);
//   };

//   const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
//     setPdfNumPages(numPages);
//     setTimeout(() => {
//       setPdfRenderTrigger((prev) => prev + 1);
//     }, 100);
//   };

//   // Enhanced field click handler
//   const handleFieldClick = useCallback(
//     (field: InputField, mode?: 'sign' | 'type') => {
//       if (!field.isEmpEdit || selectedDocument?.isApproved) {
//         return;
//       }

//       setSelectedField(field);
//       setTempFieldValue(field.value?.toString() || '');

//       if (field.type.toLowerCase() === 'signature') {
//         setSignatureMode('pad');
//         setShowEditDialog(true);
//       } else if (field.type.toLowerCase() === 'date' || field.type.toLowerCase() === 'expiry') {
//         setDateFieldId(field.id);
//         const currentValue = field.value?.toString();
//         setTempDate(currentValue ? new Date(currentValue) : null);
//         setDatePickerOpen(true);
//       } else {
//         setShowEditDialog(true);
//       }
//     },
//     [selectedDocument]
//   );

//   // Enhanced signature save handler
//   const handleSignatureSave = () => {
//     if (!selectedField) return;

//     let signatureValue = '';

//     switch (signatureMode) {
//       case 'pad':
//         if (signatureCanvasRef.current && !signatureCanvasRef.current.isEmpty()) {
//           signatureValue = signatureCanvasRef.current.toDataURL();
//         }
//         break;
//       case 'name':
//         signatureValue = typedName.trim();
//         break;
//       case 'standard':
//         signatureValue = isStandardChecked ? 'checked' : '';
//         break;
//     }

//     if (signatureValue) {
//       updateFieldValue(selectedField.id, signatureValue);
//       setShowEditDialog(false);
//       setTypedName('');
//       setIsStandardChecked(false);
//       if (signatureCanvasRef.current) {
//         signatureCanvasRef.current.clear();
//       }
//     } else {
//       setErrorMessage('Please provide a signature before saving.');
//     }
//   };

//   // Enhanced field save handler
//   const handleFieldSaveDialog = () => {
//     if (!selectedField || !tempFieldValue.trim()) return;

//     updateFieldValue(selectedField.id, tempFieldValue.trim());
//     setShowEditDialog(false);
//     setTempFieldValue('');
//   };

//   // Legacy signature pad handlers
//   const handleSaveSignature = () => {
//     if (!sigPadRef.current || !signatureFieldId) return;

//     if (sigPadRef.current.isEmpty()) {
//       setErrorMessage('Please provide a signature first.');
//       return;
//     }

//     const dataURL = sigPadRef.current.toDataURL();
//     updateFieldValue(signatureFieldId, dataURL);
//     setSignaturePadOpen(false);
//     setSignatureFieldId(null);
//   };

//   const handleClearSignature = () => {
//     if (sigPadRef.current) {
//       sigPadRef.current.clear();
//     }
//   };

//   const handleCloseSignaturePad = () => {
//     setSignaturePadOpen(false);
//     setSignatureFieldId(null);
//   };

//   // Date picker handlers
//   const handleSaveDate = () => {
//     if (!dateFieldId) return;

//     const dateValue = tempDate ? tempDate.toISOString().split('T')[0] : '';
//     updateFieldValue(dateFieldId, dateValue);

//     setDatePickerOpen(false);
//     setDateFieldId(null);
//     setTempDate(null);
//   };

//   const handleCloseDatePicker = () => {
//     setDatePickerOpen(false);
//     setDateFieldId(null);
//     setTempDate(null);
//   };

//   // UPDATED: Enhanced submit function with proper file handling
//   const handleSubmitDocument = async () => {
//     if (!selectedDocument || !selectedProjectId || !selectedServiceTitle) return;

//     const validation = validateRequiredFields();
//     const editableValidation = selectedDocument.inputFields.filter(
//       (field) =>
//         field.isRequired &&
//         field.isEmpEdit &&
//         (!field.value || field.value.toString().trim() === '')
//     );

//     if (!validation.isValid) {
//       const fieldsList = validation.missingFieldLabels.join(', ');
//       setErrorMessage(`Please fill in all required fields before submitting: ${fieldsList}`);
//       return;
//     }

//     if (editableValidation.length > 0) {
//       const editableFields = editableValidation.map((f) => f.fieldLabel || f.type).join(', ');
//       setErrorMessage(`Please fill in all required editable fields: ${editableFields}`);
//       return;
//     }

//     // Check if document upload is required for empty template
//     const isEmptyTemplate =
//       !selectedDocument.uploadedFile?.storedFilePath ||
//       selectedDocument.uploadedFile?.storedFilePath === '';
//     const hasUploadedFile = uploadedFileData !== null;

//     if (isEmptyTemplate && !hasUploadedFile) {
//       setErrorMessage('Please upload a document before submitting');
//       return;
//     }

//     setActionLoading('submit');

//     try {
//       const processedInputFields = selectedDocument.inputFields.map((field) => ({
//         ...field,
//         value: field.value || '',
//         ...(field.isRequired &&
//           !field.value && {
//             value: field.type === 'signature' ? '' : field.fieldLabel || ''
//           })
//       }));

//       // Handle file path based on template type
//       let uploadedFileForPayload;

//       if (isEmptyTemplate && hasUploadedFile) {
//         // For empty templates, send base64 data as storedFilePath
//         uploadedFileForPayload = {
//           fileName: uploadedFileData.fileName,
//           fileSize: uploadedFileData.fileSize,
//           fileType: uploadedFileData.fileType,
//           originalFileName: uploadedFileData.originalFileName,
//           storedFilePath: uploadedFileData.base64Data // Send base64 as path
//         };
//       } else {
//         // For existing templates, use existing file data as is
//         uploadedFileForPayload = selectedDocument.uploadedFile;
//       }

//       const payload = {
//         group_id: selectedProjectId,
//         assignedId: selectedDocument.assignedId,
//         service_id: selectedServiceTitle,
//         documentId: selectedDocument.documentId,
//         documentName: selectedDocument.documentName,
//         documentDate: selectedDocument.documentDate,
//         categoryId: selectedCategoryId,
//         subCategoryId: selectedSubcategoryId,
//         inputFields: processedInputFields,
//         uploadedFile: uploadedFileForPayload,
//         assignedEmployeeMailId: selectedDocument.assignedEmployeeMailId,
//         assignedEmpName: selectedDocument.assignedEmpName
//       };

//       await dispatch(submitESignDoc(payload)).unwrap();
//       setSuccessMessage('Document submitted successfully');
//       handleClosePreview();

//       // Reload documents
//       await dispatch(
//         getAllAssignedDocuments({
//           group_id: selectedProjectId,
//           service_id: selectedServiceTitle,
//           isAdmin: isAdminLogin
//         })
//       ).unwrap();
//     } catch (error: any) {
//       if (error.includes('Missing values for required fields')) {
//         const backendError = error.split(': ')[1] || 'unknown fields';
//         setErrorMessage(
//           `Backend validation failed. Missing required fields: ${backendError}. Please check all required fields are properly filled.`
//         );
//       } else {
//         setErrorMessage(error || 'Failed to submit document');
//       }
//     } finally {
//       setActionLoading(null);
//     }
//   };

//   // Confirmation dialog handlers
//   const handleOpenConfirmDialog = (document: AssignedDocument, action: ConfirmActionType) => {
//     setConfirmDocument(document);
//     setConfirmAction(action);
//     setConfirmDialogOpen(true);
//     setActionMenuAnchor(null);
//     setCurrentActionDoc(null);
//   };

//   const handleCloseConfirmDialog = () => {
//     setConfirmDialogOpen(false);
//     setConfirmDocument(null);
//     setConfirmAction(null);
//   };

//   // Fixed: Updated to use correct categoryId and subcategoryId
//   const handleConfirmAction = async () => {
//     if (!confirmDocument || !confirmAction || !selectedProjectId || !selectedServiceTitle) return;

//     try {
//       const mappedAction: 'accept' | 'delete' | 'reassign' =
//         confirmAction === 'approve' ? 'accept' : (confirmAction as 'delete' | 'reassign');

//       const payload: AcceptDeleteReassignDocPayload = {
//         group_id: selectedProjectId,
//         service_id: selectedServiceTitle,
//         employeeMailId: confirmDocument.assignedEmployeeMailId,
//         assignedId: confirmDocument.assignedId!,
//         action: mappedAction,
//         categoryId: selectedCategoryId,
//         subcategoryId: selectedSubcategoryId
//       };

//       await dispatch(acceptDeleteReassignDoc(payload)).unwrap();
//       handleCloseConfirmDialog();

//       // Reload documents
//       await dispatch(
//         getAllAssignedDocuments({
//           group_id: selectedProjectId,
//           service_id: selectedServiceTitle,
//           isAdmin: isAdminLogin
//         })
//       ).unwrap();
//     } catch (error: any) {
//       console.error('Action failed:', error);
//     }
//   };

//   const handleDocumentAction = async (
//     document: AssignedDocument,
//     action: 'approve' | 'delete' | 'reassign'
//   ) => {
//     handleOpenConfirmDialog(document, action);
//   };

//   const handleActionMenuOpen = (
//     event: React.MouseEvent<HTMLElement>,
//     document: AssignedDocument
//   ) => {
//     event.stopPropagation();
//     setActionMenuAnchor(event.currentTarget);
//     setCurrentActionDoc(document);
//   };

//   const handleActionMenuClose = () => {
//     setActionMenuAnchor(null);
//     setCurrentActionDoc(null);
//   };

//   // Helper functions for ConfirmationDialog
//   const getDialogTitle = () => {
//     if (!confirmAction) return 'Confirm Action';
//     switch (confirmAction) {
//       case 'approve':
//         return 'Confirm Approval';
//       case 'delete':
//         return 'Confirm Deletion';
//       case 'reassign':
//         return 'Confirm Reassignment';
//       default:
//         return 'Confirm Action';
//     }
//   };

//   const getDialogMessage = () => {
//     if (!confirmAction || !confirmDocument) return '';

//     switch (confirmAction) {
//       case 'approve':
//         return `Are you sure you want to approve the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}?`;
//       case 'delete':
//         return `Are you sure you want to delete the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}? This action cannot be undone.`;
//       case 'reassign':
//         return `Are you sure you want to reassign the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}?`;
//       default:
//         return '';
//     }
//   };

//   const getDialogButtonText = () => {
//     if (!confirmAction) return 'Confirm';
//     switch (confirmAction) {
//       case 'approve':
//         return 'Approve';
//       case 'delete':
//         return 'Delete';
//       case 'reassign':
//         return 'Reassign';
//       default:
//         return 'Confirm';
//     }
//   };

//   const getDialogButtonColor = (): 'primary' | 'error' | 'success' => {
//     if (!confirmAction) return 'primary';
//     switch (confirmAction) {
//       case 'approve':
//         return 'success';
//       case 'delete':
//         return 'error';
//       case 'reassign':
//         return 'primary';
//       default:
//         return 'primary';
//     }
//   };

//   // UPDATED: Empty template canvas renderer
//   const renderEmptyTemplateCanvas = () => {
//     return (
//       <Box
//         ref={pdfContainerRef}
//         sx={{
//           position: 'relative',
//           width: '100%',
//           height: 'calc(60vh - 80px)',
//           border: `1px solid ${theme.palette.divider}`,
//           borderRadius: 1.5,
//           bgcolor: '#fafafa',
//           overflow: 'auto',
//           backgroundImage: `
//             linear-gradient(rgba(156, 163, 175, 0.1) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(156, 163, 175, 0.1) 1px, transparent 1px)
//           `,
//           backgroundSize: '20px 20px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}
//       >
//         {/* Empty state message */}
//         {(!selectedDocument?.inputFields || selectedDocument.inputFields.length === 0) && (
//           <Box sx={{ textAlign: 'center', opacity: 0.6, zIndex: 1 }}>
//             <MdDescription
//               style={{ fontSize: isMobile ? 36 : 48, color: grey[400], marginBottom: 8 }}
//             />
//             <Typography
//               variant="body2"
//               color="text.secondary"
//               sx={{ fontSize: '0.75rem', mb: 0.5 }}
//             >
//               Empty Template Canvas
//             </Typography>
//             <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.675rem' }}>
//               Field overlays will appear here when positioned
//             </Typography>
//           </Box>
//         )}

//         {/* Upload area - only show when no document is uploaded */}
//         {!documentPreviewUrl && (
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 16,
//               right: 16,
//               zIndex: 2
//             }}
//           >
//             <Tooltip title="Upload Document">
//               <IconButton
//                 onClick={() => document.getElementById('file-upload-input')?.click()}
//                 sx={{
//                   bgcolor: theme.palette.primary.main,
//                   color: 'white',
//                   '&:hover': {
//                     bgcolor: theme.palette.primary.dark
//                   },
//                   boxShadow: 2
//                 }}
//                 disabled={uploadLoading}
//               >
//                 {uploadLoading ? (
//                   <CircularProgress size={20} sx={{ color: 'white' }} />
//                 ) : (
//                   <MdCloudUpload />
//                 )}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         )}

//         {/* Render field overlays for empty template */}
//         {selectedDocument?.inputFields &&
//           selectedDocument.inputFields.length > 0 &&
//           selectedDocument.inputFields
//             .filter((field) => field.pageNumber === 1)
//             .map((field) => (
//               <AssignedInputFieldOverlay
//                 key={field.id}
//                 field={field}
//                 selectedDocument={selectedDocument}
//                 pdfContainerRef={pdfContainerRef}
//                 handleFieldClick={handleFieldClick}
//                 updateFieldValue={updateFieldValue}
//                 isMobile={isMobile}
//               />
//             ))}
//       </Box>
//     );
//   };

//   // Add these state variables with your existing states

//   // Enhanced thumbnail rendering function
//   const renderThumbnail = (pageNumber: number) => {
//     const isSelected = currentPdfPage === pageNumber;
//     const fieldsOnPage =
//       selectedDocument?.inputFields?.filter((field) => field.pageNumber === pageNumber) ?? [];

//     return (
//       <Box
//         key={`thumbnail-${pageNumber}`}
//         onClick={() => setCurrentPdfPage(pageNumber)}
//         sx={{
//           position: 'relative',
//           cursor: 'pointer',
//           border: isSelected ? '2px solid #1976d2' : '1px solid #ddd',
//           borderRadius: 1,
//           bgcolor: isSelected ? '#e3f2fd' : 'white',
//           overflow: 'hidden',
//           transition: 'all 0.2s ease',
//           '&:hover': {
//             borderColor: '#1976d2',
//             transform: 'scale(1.02)',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//           },
//           width: isMobile ? 60 : 80,
//           height: isMobile ? 84 : 112,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           mx: 'auto',
//           mb: 1,
//           flexShrink: 0
//         }}
//       >
//         <Document file={documentPreviewUrl} loading={null} error={null}>
//           <Page
//             pageNumber={pageNumber}
//             width={isMobile ? 50 : 70}
//             height={isMobile ? 70 : 98}
//             renderTextLayer={false}
//             renderAnnotationLayer={false}
//             loading={
//               <Box
//                 sx={{
//                   width: isMobile ? 50 : 70,
//                   height: isMobile ? 70 : 98,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   bgcolor: grey[50]
//                 }}
//               >
//                 <CircularProgress size={16} />
//               </Box>
//             }
//             onRenderSuccess={() => {
//               setThumbnailsLoaded((prev) => new Set([...Array.from(prev), pageNumber]));
//             }}
//           />
//         </Document>

//         <Box
//           sx={{
//             position: 'absolute',
//             bottom: 2,
//             left: 2,
//             bgcolor: isSelected ? '#1976d2' : 'rgba(0,0,0,0.7)',
//             color: 'white',
//             px: 0.5,
//             py: 0.25,
//             borderRadius: 0.5,
//             fontSize: isMobile ? '8px' : '10px',
//             fontWeight: 600,
//             lineHeight: 1,
//             minWidth: 16,
//             textAlign: 'center'
//           }}
//         >
//           {pageNumber}
//         </Box>

//         {fieldsOnPage.length > 0 && (
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 2,
//               right: 2,
//               bgcolor: '#ff9800',
//               color: 'white',
//               minWidth: 16,
//               height: 16,
//               borderRadius: '50%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: isMobile ? '8px' : '9px',
//               fontWeight: 600,
//               lineHeight: 1
//             }}
//           >
//             {fieldsOnPage.length}
//           </Box>
//         )}
//       </Box>
//     );
//   };
//   // UPDATED: Enhanced PDF and Image preview with upload support and field tags

//   // Update your renderPdfPreviewWithTags function to include thumbnails
//   const renderPdfPreviewWithTags = () => {
//     const validation = validateRequiredFields();
//     const requiredFieldsCount =
//       selectedDocument?.inputFields?.filter((f) => f.isRequired && f.isEmpEdit).length || 0;
//     const filledRequiredFieldsCount =
//       selectedDocument?.inputFields?.filter(
//         (f) => f.isRequired && f.isEmpEdit && f.value && f.value.toString().trim() !== ''
//       ).length || 0;

//     if (!selectedDocument) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography color="text.secondary">No document selected</Typography>
//         </Box>
//       );
//     }

//     const isImageDocument = selectedDocument.uploadedFile?.fileType !== 'pdf';
//     const isEmptyTemplate = !documentPreviewUrl;

//     return (
//       <Box
//         sx={{
//           height: '70vh',
//           border: `1px solid ${theme.palette.divider}`,
//           borderRadius: 1.5,
//           position: 'relative',
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//       >
//         {/* Existing Toolbar - keep as is */}
//         <Box
//           sx={{
//             borderBottom: `1px solid ${theme.palette.divider}`,
//             p: 1,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             bgcolor: grey[50],
//             flexShrink: 0
//           }}
//         >
//           {/* Your existing toolbar content */}
//           {/* Toolbar */}
//           <Box
//             sx={{
//               borderBottom: `1px solid ${theme.palette.divider}`,
//               p: 1,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               bgcolor: grey[50],
//               flexShrink: 0
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               {isEmptyTemplate ? (
//                 <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                   Empty Template - Upload document required
//                 </Typography>
//               ) : isImageDocument ? (
//                 <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                   Image Document
//                 </Typography>
//               ) : (
//                 <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                   Page {currentPdfPage} of {pdfNumPages}
//                 </Typography>
//               )}

//               {uploadedFileData && (
//                 <Chip
//                   label="Uploaded"
//                   size="small"
//                   sx={{
//                     height: 20,
//                     fontSize: '0.65rem',
//                     bgcolor: `${blue[500]}15`,
//                     color: blue[500]
//                   }}
//                 />
//               )}

//               {selectedDocument?.inputFields && (
//                 <>
//                   <Chip
//                     label={`${selectedDocument.inputFields.length} fields`}
//                     size="small"
//                     sx={{
//                       height: 20,
//                       fontSize: '0.65rem',
//                       bgcolor: `${purple[500]}15`,
//                       color: purple[500]
//                     }}
//                   />
//                   <Chip
//                     label={`${selectedDocument.inputFields.filter((f) => f.value).length} filled`}
//                     size="small"
//                     sx={{
//                       height: 20,
//                       fontSize: '0.65rem',
//                       bgcolor: `${green[500]}15`,
//                       color: green[500]
//                     }}
//                   />
//                   {requiredFieldsCount > 0 && (
//                     <Chip
//                       label={`${filledRequiredFieldsCount}/${requiredFieldsCount} required`}
//                       size="small"
//                       sx={{
//                         height: 20,
//                         fontSize: '0.65rem',
//                         bgcolor: validation.isValid ? `${green[500]}15` : `${red[500]}15`,
//                         color: validation.isValid ? green[600] : red[600],
//                         animation: !validation.isValid ? 'pulse 2s infinite' : 'none'
//                       }}
//                     />
//                   )}
//                 </>
//               )}

//               {documentModified && (
//                 <Chip
//                   label="Modified"
//                   size="small"
//                   sx={{
//                     height: 20,
//                     fontSize: '0.65rem',
//                     bgcolor: `${orange[500]}15`,
//                     color: orange[500]
//                   }}
//                 />
//               )}

//               {/* Upload button - only show for empty templates */}
//               {isEmptyTemplate && (
//                 <Tooltip title="Upload Document">
//                   <IconButton
//                     size="small"
//                     onClick={() => document.getElementById('file-upload-input')?.click()}
//                     disabled={uploadLoading}
//                     sx={{
//                       bgcolor: theme.palette.primary.main,
//                       color: 'white',
//                       width: 28,
//                       height: 28,
//                       '&:hover': {
//                         bgcolor: theme.palette.primary.dark
//                       }
//                     }}
//                   >
//                     {uploadLoading ? (
//                       <CircularProgress size={16} sx={{ color: 'white' }} />
//                     ) : (
//                       <MdCloudUpload style={{ fontSize: 16 }} />
//                     )}
//                   </IconButton>
//                 </Tooltip>
//               )}
//             </Box>

//             {!isImageDocument && !isEmptyTemplate && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 {/* Zoom controls */}
//                 <IconButton
//                   onClick={() => setScale(Math.max(0.5, scale - 0.1))}
//                   disabled={scale <= 0.5}
//                   size="small"
//                   sx={{ bgcolor: 'white', border: '1px solid #e0e0e0' }}
//                 >
//                   -
//                 </IconButton>
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     minWidth: '40px',
//                     textAlign: 'center',
//                     fontSize: '10px'
//                   }}
//                 >
//                   {Math.round(scale * 100)}%
//                 </Typography>
//                 <IconButton
//                   onClick={() => setScale(Math.min(2.0, scale + 0.1))}
//                   disabled={scale >= 2.0}
//                   size="small"
//                   sx={{ bgcolor: 'white', border: '1px solid #e0e0e0' }}
//                 >
//                   +
//                 </IconButton>

//                 {/* Page navigation */}
//                 {pdfNumPages > 1 && (
//                   <Box sx={{ display: 'flex', gap: 0.5, ml: 1 }}>
//                     <Button
//                       onClick={() => setCurrentPdfPage(Math.max(1, currentPdfPage - 1))}
//                       disabled={currentPdfPage <= 1}
//                       size="small"
//                       sx={{
//                         ...buttonStyles.base,
//                         ...buttonStyles.sizes.small,
//                         ...buttonStyles.variants.outlined,
//                         minWidth: 40
//                       }}
//                     >
//                       ←
//                     </Button>
//                     <Button
//                       onClick={() => setCurrentPdfPage(Math.min(pdfNumPages, currentPdfPage + 1))}
//                       disabled={currentPdfPage >= pdfNumPages}
//                       size="small"
//                       sx={{
//                         ...buttonStyles.base,
//                         ...buttonStyles.sizes.small,
//                         ...buttonStyles.variants.outlined,
//                         minWidth: 40
//                       }}
//                     >
//                       →
//                     </Button>
//                   </Box>
//                 )}
//               </Box>
//             )}
//           </Box>
//         </Box>

//         {/* Updated Main Display Area with Thumbnails */}
//         <Box
//           sx={{
//             flex: 1,
//             overflow: 'hidden',
//             position: 'relative',
//             display: 'flex'
//           }}
//         >
//           {/* Thumbnails Panel - Only show for PDF documents with multiple pages */}
//           {!isEmptyTemplate && !isImageDocument && pdfNumPages > 1 && (
//             <Box
//               sx={{
//                 width: isMobile ? 80 : 100,
//                 borderRight: `1px solid ${theme.palette.divider}`,
//                 // bgcolor: grey[25],
//                 overflowY: 'auto',
//                 overflowX: 'hidden',
//                 p: 1,
//                 flexShrink: 0
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontSize: '0.65rem',
//                   fontWeight: 600,
//                   color: 'text.secondary',
//                   textAlign: 'center',
//                   mb: 1
//                 }}
//               >
//                 Pages ({pdfNumPages})
//               </Typography>
//               {Array.from({ length: pdfNumPages }, (_, i) => i + 1).map((pageNum) =>
//                 renderThumbnail(pageNum)
//               )}
//             </Box>
//           )}

//           {/* Document Display Area */}
//           <Box
//             sx={{
//               flex: 1,
//               overflow: 'auto',
//               position: 'relative'
//             }}
//           >
//             {isEmptyTemplate ? (
//               renderEmptyTemplateCanvas()
//             ) : (
//               // Document display with field overlays
//               <Box
//                 ref={pdfContainerRef}
//                 sx={{
//                   flex: 1,
//                   overflowY: 'auto',
//                   overflowX: 'auto',
//                   p: 1,
//                   bgcolor: grey[50],
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'flex-start',
//                   minHeight: 0,
//                   position: 'relative'
//                 }}
//               >
//                 <Box sx={{ position: 'relative', width: 'fit-content', isolation: 'isolate' }}>
//                   {isImageDocument ? (
//                     <img
//                       src={documentPreviewUrl || ''}
//                       alt={selectedDocument.documentName}
//                       style={{
//                         maxWidth: '100%',
//                         maxHeight: '100%',
//                         objectFit: 'contain'
//                       }}
//                       onLoad={() => {
//                         setPreviewLoading(false);
//                         setPdfRenderTrigger((prev) => prev + 1);
//                       }}
//                     />
//                   ) : (
//                     <Document
//                       file={documentPreviewUrl}
//                       onLoadSuccess={onDocumentLoadSuccess}
//                       onLoadError={() => console.error('PDF load error')}
//                       loading={
//                         <Box sx={{ p: 4, textAlign: 'center' }}>
//                           <CircularProgress size={24} />
//                           <Typography sx={{ mt: 1 }}>Loading PDF...</Typography>
//                         </Box>
//                       }
//                       error={
//                         <Box sx={{ p: 4, textAlign: 'center' }}>
//                           <Typography color="error">
//                             Failed to load PDF. Please try again.
//                           </Typography>
//                         </Box>
//                       }
//                     >
//                       <Page
//                         pageNumber={currentPdfPage}
//                         scale={scale}
//                         width={calculatePdfWidth()}
//                         renderTextLayer={false}
//                         renderAnnotationLayer={false}
//                         loading={<CircularProgress size={20} />}
//                         onRenderSuccess={() => {
//                           setTimeout(() => {
//                             setPdfRenderTrigger((prev) => prev + 1);
//                           }, 100);
//                         }}
//                       />
//                     </Document>
//                   )}

//                   {/* Field Overlays - Show on uploaded documents too */}
//                   {selectedDocument?.inputFields
//                     ?.filter((field) => field.pageNumber === (isImageDocument ? 1 : currentPdfPage))
//                     .map((field) => (
//                       <AssignedInputFieldOverlay
//                         key={field.id}
//                         field={field}
//                         selectedDocument={selectedDocument}
//                         pdfContainerRef={pdfContainerRef}
//                         handleFieldClick={handleFieldClick}
//                         updateFieldValue={updateFieldValue}
//                         isMobile={isMobile}
//                       />
//                     ))}
//                 </Box>
//               </Box>
//             )}
//           </Box>
//         </Box>

//         {/* Hidden file input */}
//         <input
//           id="file-upload-input"
//           type="file"
//           accept=".pdf,.jpg,.jpeg,.png"
//           style={{ display: 'none' }}
//           onChange={handleFileUpload}
//           disabled={uploadLoading}
//         />
//       </Box>
//     );
//   };

//   // UPDATED: Enhanced Dialog Actions with upload validation
//   const renderDialogActions = () => {
//     const validation = validateRequiredFields();
//     const editableRequiredFields =
//       selectedDocument?.inputFields?.filter((f) => f.isRequired && f.isEmpEdit) || [];
//     const editableRequiredFieldsEmpty = editableRequiredFields.filter(
//       (f) => !f.value || f.value.toString().trim() === ''
//     );

//     // Check if document upload is required
//     const isEmptyTemplate =
//       !selectedDocument?.uploadedFile?.storedFilePath ||
//       selectedDocument?.uploadedFile?.storedFilePath === '';
//     const uploadRequired = isEmptyTemplate && !uploadedFileData;

//     const canSubmit =
//       selectedDocument &&
//       !selectedDocument.isApproved &&
//       validation.isValid &&
//       editableRequiredFieldsEmpty.length === 0 &&
//       !uploadRequired;

//     return (
//       <DialogActions sx={{ justifyContent: 'space-between', px: 2 }}>
//         <Button onClick={handleClosePreview}>Close</Button>

//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//           {/* Enhanced validation warnings */}
//           {selectedDocument && !selectedDocument.isApproved && (
//             <>
//               {uploadRequired && (
//                 <Alert
//                   severity="error"
//                   sx={{
//                     py: 0.5,
//                     px: 1,
//                     fontSize: '0.75rem',
//                     '& .MuiAlert-message': { py: 0 }
//                   }}
//                 >
//                   Document upload required
//                 </Alert>
//               )}

//               {!validation.isValid && (
//                 <Alert
//                   severity="error"
//                   sx={{
//                     py: 0.5,
//                     px: 1,
//                     fontSize: '0.75rem',
//                     '& .MuiAlert-message': { py: 0 }
//                   }}
//                 >
//                   Missing required fields: {validation.missingFieldLabels.join(', ')}
//                 </Alert>
//               )}

//               {validation.isValid && editableRequiredFieldsEmpty.length > 0 && (
//                 <Alert
//                   severity="warning"
//                   sx={{
//                     py: 0.5,
//                     px: 1,
//                     fontSize: '0.75rem',
//                     '& .MuiAlert-message': { py: 0 }
//                   }}
//                 >
//                   Please fill: {editableRequiredFieldsEmpty.map((f) => f.fieldLabel).join(', ')}
//                 </Alert>
//               )}
//             </>
//           )}

//           {selectedDocument && getDocumentStatus(selectedDocument) === 'filled_submitted' && (
//             <Button
//               variant="contained"
//               color="success"
//               onClick={() => handleDocumentAction(selectedDocument, 'approve')}
//               disabled={actionLoading?.includes(selectedDocument.documentId)}
//               startIcon={<MdThumbUp />}
//               sx={buttonStyles.base}
//             >
//               Approve
//             </Button>
//           )}

//           {selectedDocument && !selectedDocument.isApproved && (
//             <Tooltip
//               title={
//                 !canSubmit
//                   ? uploadRequired
//                     ? 'Please upload a document first'
//                     : !validation.isValid
//                     ? `Missing required fields: ${validation.missingFieldLabels.join(', ')}`
//                     : editableRequiredFieldsEmpty.length > 0
//                     ? `Please fill: ${editableRequiredFieldsEmpty
//                         .map((f) => f.fieldLabel)
//                         .join(', ')}`
//                     : 'Unknown validation error'
//                   : 'Submit document for review'
//               }
//             >
//               <span>
//                 <Button
//                   variant="contained"
//                   onClick={handleSubmitDocument}
//                   disabled={actionLoading === 'submit' || !canSubmit}
//                   startIcon={
//                     actionLoading === 'submit' ? <CircularProgress size={16} /> : <MdSend />
//                   }
//                   sx={{
//                     ...buttonStyles.base,
//                     ...buttonStyles.variants.contained,
//                     ...(!canSubmit && {
//                       bgcolor: red[500],
//                       '&:hover': {
//                         bgcolor: red[600]
//                       }
//                     })
//                   }}
//                 >
//                   {actionLoading === 'submit' ? 'Submitting...' : 'Submit Document'}
//                 </Button>
//               </span>
//             </Tooltip>
//           )}
//         </Box>
//       </DialogActions>
//     );
//   };

//   if (loading) {
//     return (
//       <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
//         <Stack
//           direction="row"
//           spacing={1.5}
//           justifyContent="center"
//           alignItems="center"
//           sx={{ minHeight: '30vh' }}
//         >
//           <CircularProgress size={24} />
//           <Typography sx={{ ...typography.bodyText }} color="text.secondary">
//             Loading assigned documents...
//           </Typography>
//         </Stack>
//       </Container>
//     );
//   }

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box sx={{ position: 'relative' }}>
//         {/* Success Snackbar */}
//         <Snackbar
//           open={Boolean(successMessage)}
//           autoHideDuration={4000}
//           onClose={() => setSuccessMessage(null)}
//           anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         >
//           <Alert onClose={() => setSuccessMessage(null)} severity="success" sx={{ width: '100%' }}>
//             {successMessage}
//           </Alert>
//         </Snackbar>

//         {/* Error Snackbar */}
//         <Snackbar
//           open={Boolean(errorMessage)}
//           autoHideDuration={6000}
//           onClose={() => setErrorMessage(null)}
//           anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         >
//           <Alert onClose={() => setErrorMessage(null)} severity="error" sx={{ width: '100%' }}>
//             {errorMessage}
//           </Alert>
//         </Snackbar>

//         <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
//           {/* Page Header */}
//           <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
//             <Typography
//               sx={{
//                 ...typography.mainTitle,
//                 fontWeight: 'bold',
//                 color: 'primary.main',
//                 mb: 0.5
//               }}
//             >
//               Assigned Documents Review
//             </Typography>
//             <Typography
//               sx={{
//                 ...typography.smallText,
//                 color: 'text.secondary'
//               }}
//             >
//               Review and manage document assignments by category • {totalDocuments} total documents
//             </Typography>
//           </Box>

//           {error && (
//             <Alert severity="error" sx={{ mb: { xs: 1.5, md: 2 }, borderRadius: 1.5 }}>
//               <Typography sx={{ ...typography.smallText }}>Error: {error}</Typography>
//             </Alert>
//           )}

//           {/* Two Column Layout */}
//           <Grid container spacing={isMobile ? 1 : 1.5}>
//             {/* Categories Panel (Left) */}
//             {!isMobile && categoryData.length > 0 && (
//               <Grid item sm={3}>
//                 <AssignedDocumentCategoriesList
//                   categoryData={categoryData}
//                   selectedCategory={selectedCategory}
//                   selectedSubcategory={selectedSubcategory}
//                   expandedCategories={expandedCategories}
//                   getCategoryColor={getCategoryColor}
//                   getCategoryIcon={getCategoryIcon}
//                   handleCategoryToggle={handleCategoryToggle}
//                   handleSubcategorySelect={handleSubcategorySelect}
//                   typography={typography}
//                 />
//               </Grid>
//             )}

//             {/* Documents Panel (Right) */}
//             <Grid item xs={12} sm={isMobile ? 12 : 9}>
//               <AssignedList
//                 filteredDocuments={filteredDocuments}
//                 selectedCategory={selectedCategory}
//                 selectedSubcategory={selectedSubcategory}
//                 searchTerm={searchTerm}
//                 statusFilter={statusFilter}
//                 isMobile={isMobile}
//                 actionLoading={actionLoading}
//                 acceptDeleteReassignLoading={acceptDeleteReassignLoading ?? false}
//                 getCategoryColor={getCategoryColor}
//                 getDocumentStatus={getDocumentStatus}
//                 formatDate={formatDate}
//                 handleSearch={handleSearch}
//                 handleStatusFilterChange={handleStatusFilterChange}
//                 handleClearFilters={handleClearFilters}
//                 handlePreviewDocument={handlePreviewDocument}
//                 handleDocumentAction={handleDocumentAction}
//                 handleActionMenuOpen={handleActionMenuOpen}
//                 statusColors={statusColors}
//                 statusIcons={statusIcons}
//                 statusLabels={statusLabels}
//                 typography={typography}
//               />
//             </Grid>
//           </Grid>
//         </Container>

//         {/* Mobile Category Selector */}
//         {isMobile && categoryData.length > 0 && (
//           <>
//             <Fab
//               onClick={(e) => setCategoryMenuAnchor(e.currentTarget)}
//               sx={{
//                 position: 'fixed',
//                 bottom: 16,
//                 right: 16,
//                 bgcolor: purple[500],
//                 color: 'white',
//                 width: 44,
//                 height: 44,
//                 '&:hover': {
//                   bgcolor: purple[600]
//                 }
//               }}
//             >
//               <MdCategory style={{ fontSize: 18 }} />
//             </Fab>

//             {/* Enhanced Category Menu with Subcategories */}
//             <Menu
//               anchorEl={categoryMenuAnchor}
//               open={Boolean(categoryMenuAnchor)}
//               onClose={() => setCategoryMenuAnchor(null)}
//               transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//               anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
//               PaperProps={{
//                 sx: {
//                   maxHeight: '70vh',
//                   width: '280px',
//                   borderRadius: 1.5
//                 }
//               }}
//             >
//               {categoryData.map((category) => (
//                 <Box key={category.categoryId}>
//                   <MenuItem
//                     sx={{
//                       flexDirection: 'column',
//                       alignItems: 'stretch',
//                       p: 0
//                     }}
//                   >
//                     {/* Category Header */}
//                     <Box
//                       sx={{
//                         p: 1.5,
//                         width: '100%',
//                         bgcolor:
//                           selectedCategory === category.categoryName
//                             ? `${getCategoryColor(category.categoryName)}08`
//                             : 'transparent'
//                       }}
//                       onClick={() => handleCategoryToggle(category.categoryName)}
//                     >
//                       <Stack direction="row" alignItems="center" spacing={1}>
//                         {React.cloneElement(getCategoryIcon(category.categoryName), {
//                           style: { fontSize: 16, color: getCategoryColor(category.categoryName) }
//                         })}
//                         <Typography sx={{ ...typography.bodyText, fontWeight: 600 }}>
//                           {category.categoryName}
//                         </Typography>
//                         <Chip
//                           label={category.totalDocuments}
//                           size="small"
//                           sx={{
//                             height: 16,
//                             fontSize: '0.625rem',
//                             bgcolor: `${getCategoryColor(category.categoryName)}15`,
//                             color: getCategoryColor(category.categoryName)
//                           }}
//                         />
//                       </Stack>
//                     </Box>

//                     {/* Subcategories */}
//                     {expandedCategories.has(category.categoryName) && (
//                       <Box sx={{ pl: 2, pb: 1 }}>
//                         {category.subcategories.map((subcategory) => (
//                           <Box
//                             key={subcategory.subcategoryId}
//                             sx={{
//                               p: 1,
//                               cursor: 'pointer',
//                               borderRadius: 1,
//                               bgcolor:
//                                 selectedCategory === category.categoryName &&
//                                 selectedSubcategory === subcategory.subcategoryName
//                                   ? `${getCategoryColor(category.categoryName)}12`
//                                   : 'transparent',
//                               '&:hover': {
//                                 bgcolor: `${getCategoryColor(category.categoryName)}08`
//                               }
//                             }}
//                             onClick={() =>
//                               handleSubcategorySelect(
//                                 category.categoryName,
//                                 subcategory.subcategoryName
//                               )
//                             }
//                           >
//                             <Stack direction="row" alignItems="center" spacing={1}>
//                               <MdFolder
//                                 style={{
//                                   fontSize: 12,
//                                   color: getCategoryColor(category.categoryName)
//                                 }}
//                               />
//                               <Typography sx={{ ...typography.bodyText }}>
//                                 {subcategory.subcategoryName}
//                               </Typography>
//                               <Chip
//                                 label={subcategory.totalDocuments}
//                                 size="small"
//                                 sx={{
//                                   height: 14,
//                                   fontSize: '0.5625rem',
//                                   bgcolor: `${getCategoryColor(category.categoryName)}10`,
//                                   color: getCategoryColor(category.categoryName)
//                                 }}
//                               />
//                             </Stack>
//                           </Box>
//                         ))}
//                       </Box>
//                     )}
//                   </MenuItem>
//                 </Box>
//               ))}
//             </Menu>
//           </>
//         )}

//         {/* Action Menu */}
//         <Menu
//           anchorEl={actionMenuAnchor}
//           open={Boolean(actionMenuAnchor)}
//           onClose={handleActionMenuClose}
//         >
//           <MenuItem
//             onClick={() => currentActionDoc && handleDocumentAction(currentActionDoc, 'approve')}
//             disabled={acceptDeleteReassignLoading}
//           >
//             <MdCheckCircle style={{ marginRight: 8, fontSize: 16, color: green[600] }} />
//             <Typography sx={{ ...typography.bodyText, color: green[600] }}>
//               Approve Document
//             </Typography>
//           </MenuItem>
//           <MenuItem
//             onClick={() => currentActionDoc && handleDocumentAction(currentActionDoc, 'reassign')}
//             disabled={acceptDeleteReassignLoading}
//           >
//             <MdRestore style={{ marginRight: 8, fontSize: 16, color: orange[600] }} />
//             <Typography sx={{ ...typography.bodyText, color: orange[600] }}>
//               Reassign Document
//             </Typography>
//           </MenuItem>
//           <MenuItem onClick={handleActionMenuClose}>
//             <MdDownloadForOffline style={{ marginRight: 8, fontSize: 16 }} />
//             <Typography sx={{ ...typography.bodyText }}>Download</Typography>
//           </MenuItem>
//           <MenuItem
//             onClick={() => currentActionDoc && handleDocumentAction(currentActionDoc, 'delete')}
//             disabled={acceptDeleteReassignLoading}
//           >
//             <MdDelete style={{ marginRight: 8, fontSize: 16, color: red[600] }} />
//             <Typography sx={{ ...typography.bodyText, color: red[600] }}>Delete</Typography>
//           </MenuItem>
//         </Menu>

//         {/* Fixed: Updated Confirmation Dialog */}
//         <ConfirmationDialog
//           open={confirmDialogOpen}
//           title={getDialogTitle()}
//           message={getDialogMessage()}
//           confirmButtonText={getDialogButtonText()}
//           confirmButtonColor={getDialogButtonColor()}
//           onConfirm={handleConfirmAction}
//           onCancel={handleCloseConfirmDialog}
//           loading={acceptDeleteReassignLoading}
//         />

//         {/* Preview Modal */}
//         <Dialog
//           open={previewModalOpen}
//           onClose={handleClosePreview}
//           maxWidth="xl"
//           fullWidth
//           fullScreen={isMobile}
//           PaperProps={{
//             sx: {
//               maxHeight: '95vh',
//               height: isMobile ? '100vh' : '90vh'
//             }
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}
//           >
//             <Box>
//               <Typography sx={{ ...typography.sectionTitle, fontWeight: 600 }}>
//                 {selectedDocument?.documentName}
//               </Typography>
//               <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                 {selectedDocument?.assignedEmpName} • {selectedCategory} → {selectedSubcategory}
//                 {selectedDocument?.isApproved && ' • Approved (Read Only)'}
//               </Typography>
//             </Box>
//             <IconButton onClick={handleClosePreview}>
//               <MdClose />
//             </IconButton>
//           </DialogTitle>

//           <DialogContent sx={{ p: 1 }}>
//             {previewLoading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               renderPdfPreviewWithTags()
//             )}
//           </DialogContent>

//           {renderDialogActions()}
//         </Dialog>

//         {/* Enhanced Edit Dialog */}
//         <Dialog
//           open={showEditDialog}
//           onClose={() => setShowEditDialog(false)}
//           maxWidth="xs"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 1.5,
//               minHeight:
//                 selectedField?.type.toLowerCase() === 'signature'
//                   ? isMobile
//                     ? 320
//                     : 380
//                   : isMobile
//                   ? 180
//                   : 220,
//               width:
//                 selectedField?.type.toLowerCase() === 'signature' ? undefined : isMobile ? 280 : 320
//             }
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               pb: 1,
//               fontSize: isMobile ? '1rem' : '1.1rem'
//             }}
//           >
//             {selectedField?.type.toLowerCase() === 'signature'
//               ? 'Add Signature'
//               : `Edit ${selectedField?.type || 'Field'}`}
//             <IconButton
//               onClick={() => setShowEditDialog(false)}
//               size="small"
//               sx={{ color: 'text.secondary' }}
//             >
//               <MdClose size={16} />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent sx={{ p: isMobile ? 1.5 : 2 }}>
//             {selectedField?.type.toLowerCase() === 'signature' ? (
//               <>
//                 <Tabs
//                   value={signatureMode}
//                   onChange={(_, newValue) => setSignatureMode(newValue)}
//                   variant="fullWidth"
//                   sx={{
//                     mb: 2,
//                     '& .MuiTab-root': {
//                       minHeight: 32,
//                       fontSize: '0.75rem',
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       px: 1
//                     },
//                     '& .MuiTabs-indicator': { height: 2 }
//                   }}
//                 >
//                   <Tab
//                     icon={<MdGesture size={14} />}
//                     label="Draw"
//                     value="pad"
//                     iconPosition="start"
//                   />
//                   <Tab
//                     icon={<MdTextFields size={14} />}
//                     label="Type"
//                     value="name"
//                     iconPosition="start"
//                   />
//                   <Tab
//                     icon={<MdCheckBox size={14} />}
//                     label="Check"
//                     value="standard"
//                     iconPosition="start"
//                   />
//                 </Tabs>
//                 <Box
//                   sx={{
//                     minHeight: isMobile ? 140 : 180,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                 >
//                   {signatureMode === 'pad' && (
//                     <Paper
//                       elevation={2}
//                       sx={{
//                         p: 1,
//                         borderRadius: 1,
//                         border: (theme) => `1px solid ${theme.palette.primary.main}20`
//                       }}
//                     >
//                       <SignatureCanvas
//                         ref={signatureCanvasRef}
//                         canvasProps={{
//                           width: isMobile ? 260 : 340,
//                           height: isMobile ? 100 : 140,
//                           style: {
//                             backgroundColor: '#fff',
//                             borderRadius: '4px',
//                             cursor: 'crosshair'
//                           }
//                         }}
//                         penColor="black"
//                         minWidth={1}
//                         maxWidth={2.5}
//                       />
//                     </Paper>
//                   )}
//                   {signatureMode === 'name' && (
//                     <Box sx={{ width: '100%', maxWidth: 320 }}>
//                       <TextField
//                         fullWidth
//                         size="small"
//                         label="Your Full Name"
//                         value={typedName}
//                         onChange={(e) => setTypedName(e.target.value)}
//                         placeholder="Enter your full name"
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-input': {
//                             fontSize: '0.9rem',
//                             textAlign: 'center',
//                             fontFamily: 'cursive'
//                           }
//                         }}
//                       />
//                       {typedName && (
//                         <Paper
//                           elevation={1}
//                           sx={{
//                             p: 2,
//                             bgcolor: '#f8f9fa',
//                             border: (theme) => `1px solid ${theme.palette.primary.main}20`,
//                             textAlign: 'center'
//                           }}
//                         >
//                           <Typography
//                             sx={{
//                               fontFamily: 'cursive',
//                               color: 'text.primary',
//                               fontSize: '1.1rem'
//                             }}
//                           >
//                             {typedName}
//                           </Typography>
//                         </Paper>
//                       )}
//                     </Box>
//                   )}
//                   {signatureMode === 'standard' && (
//                     <Paper
//                       elevation={1}
//                       sx={{
//                         p: 2,
//                         bgcolor: '#f8f9fa',
//                         border: (theme) => `1px solid ${theme.palette.primary.main}20`,
//                         minWidth: 160
//                       }}
//                     >
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isStandardChecked}
//                             onChange={(e) => setIsStandardChecked(e.target.checked)}
//                             sx={{
//                               transform: 'scale(1.5)',
//                               color: 'success.main',
//                               '&.Mui-checked': { color: 'success.main' }
//                             }}
//                           />
//                         }
//                         label={
//                           <Typography sx={{ ml: 1, fontSize: '0.9rem' }}>
//                             Standard Checkmark
//                           </Typography>
//                         }
//                       />
//                     </Paper>
//                   )}
//                 </Box>
//               </>
//             ) : (
//               <Box sx={{ py: 1 }}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   value={tempFieldValue}
//                   onChange={(e) => setTempFieldValue(e.target.value)}
//                   type={
//                     selectedField?.type === 'date'
//                       ? 'date'
//                       : selectedField?.type === 'email'
//                       ? 'email'
//                       : 'text'
//                   }
//                   autoFocus
//                   placeholder={`Enter ${selectedField?.type}`}
//                   sx={{
//                     mb: 1.5,
//                     '& .MuiInputBase-input': { fontSize: '0.8rem' }
//                   }}
//                   InputLabelProps={selectedField?.type === 'date' ? { shrink: true } : {}}
//                   helperText={
//                     selectedField?.type === 'email'
//                       ? 'Valid email address'
//                       : selectedField?.type === 'date'
//                       ? 'Select date'
//                       : `Enter ${selectedField?.type} information`
//                   }
//                   FormHelperTextProps={{ sx: { fontSize: '0.65rem', mt: 0.5 } }}
//                 />
//               </Box>
//             )}
//           </DialogContent>
//           <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
//             <Button
//               onClick={() => {
//                 if (selectedField?.type.toLowerCase() === 'signature') {
//                   if (signatureMode === 'pad' && signatureCanvasRef.current)
//                     signatureCanvasRef.current.clear();
//                   else if (signatureMode === 'name') setTypedName('');
//                   else setIsStandardChecked(false);
//                 } else {
//                   setTempFieldValue('');
//                 }
//               }}
//               color="secondary"
//               size="small"
//               variant="outlined"
//               sx={{ fontSize: '0.75rem' }}
//             >
//               Clear
//             </Button>
//             <Stack direction="row" spacing={1}>
//               <Button
//                 onClick={() => setShowEditDialog(false)}
//                 color="primary"
//                 size="small"
//                 variant="outlined"
//                 sx={{ fontSize: '0.75rem' }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 onClick={
//                   selectedField?.type.toLowerCase() === 'signature'
//                     ? handleSignatureSave
//                     : handleFieldSaveDialog
//                 }
//                 color="primary"
//                 size="small"
//                 variant="contained"
//                 disabled={
//                   selectedField?.type.toLowerCase() === 'signature'
//                     ? (signatureMode === 'pad' && signatureCanvasRef.current?.isEmpty()) ||
//                       (signatureMode === 'name' && !typedName.trim()) ||
//                       (signatureMode === 'standard' && !isStandardChecked)
//                     : !tempFieldValue.trim()
//                 }
//                 sx={{ fontSize: '0.75rem' }}
//               >
//                 Save
//               </Button>
//             </Stack>
//           </DialogActions>
//         </Dialog>

//         {/* Legacy Signature Pad Dialog */}
//         <Dialog
//           open={signaturePadOpen}
//           onClose={handleCloseSignaturePad}
//           maxWidth="sm"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 1.5
//             }
//           }}
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Digital Signature
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Please sign in the area below
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box
//               sx={{
//                 border: '2px dashed #ccc',
//                 borderRadius: 1,
//                 p: 1,
//                 bgcolor: '#fafafa'
//               }}
//             >
//               <SignatureCanvas
//                 ref={sigPadRef}
//                 canvasProps={{
//                   width: 400,
//                   height: 200,
//                   style: {
//                     width: '100%',
//                     height: '200px',
//                     border: 'none',
//                     borderRadius: '4px',
//                     backgroundColor: 'white'
//                   }
//                 }}
//                 backgroundColor="white"
//                 penColor="black"
//               />
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ p: 2, gap: 1 }}>
//             <Button onClick={handleCloseSignaturePad} color="inherit">
//               Cancel
//             </Button>
//             <Button onClick={handleClearSignature} color="warning" variant="outlined">
//               Clear
//             </Button>
//             <Button onClick={handleSaveSignature} variant="contained" color="primary">
//               Save Signature
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Date Picker Dialog */}
//         <Dialog
//           open={datePickerOpen}
//           onClose={handleCloseDatePicker}
//           maxWidth="xs"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 1.5
//             }
//           }}
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Select Date
//             </Typography>
//           </DialogTitle>
//           <DialogContent sx={{ p: 3 }}>
//             <DatePicker
//               value={tempDate}
//               onChange={(newValue) => setTempDate(newValue)}
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   size: 'small',
//                   sx: { mt: 1 }
//                 },
//                 openPickerButton: {
//                   sx: {
//                     color: 'primary.main'
//                   }
//                 }
//               }}
//             />
//           </DialogContent>
//           <DialogActions sx={{ p: 2, gap: 1 }}>
//             <Button onClick={handleCloseDatePicker} color="inherit">
//               Cancel
//             </Button>
//             <Button onClick={handleSaveDate} variant="contained" color="primary">
//               Save Date
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default AssignedDocumentsList;






// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import {
//   Alert,
//   Box,
//   Button,
//   Chip,
//   CircularProgress,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Fab,
//   Grid,
//   IconButton,
//   Menu,
//   MenuItem,
//   Snackbar,
//   Stack,
//   TextField,
//   Tooltip,
//   Typography,
//   useMediaQuery,
//   useTheme,
//   Tabs,
//   Tab,
//   Paper,
//   FormControlLabel,
//   Checkbox,
//   alpha
// } from '@mui/material';
// import { blue, green, grey, orange, purple, red } from '@mui/material/colors';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { useAppSelector } from 'app/hooks';
// import { AppDispatch, RootState } from 'app/store';
// import ConfirmationDialog from 'commonComponents/ConfirmationDialog';
// import { useWindowSize } from 'hooks/useWindowSize';
// import {
//   MdAssignment,
//   MdCategory,
//   MdCheckCircle,
//   MdClose,
//   MdDelete,
//   MdDownload,
//   MdDownloadForOffline,
//   MdPendingActions,
//   MdRestore,
//   MdSend,
//   MdThumbUp,
//   MdGesture,
//   MdTextFields,
//   MdCheckBox,
//   MdFolder,
//   MdCloudUpload,
//   MdDescription,
//   MdLock
// } from 'react-icons/md';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';
// import { useDispatch, useSelector } from 'react-redux';
// import SignatureCanvas from 'react-signature-canvas';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import {
//   acceptDeleteReassignDoc,
//   clearAcceptDeleteReassignError,
//   clearAcceptDeleteReassignSuccess,
//   getAllAssignedDocuments,
//   submitESignDoc
// } from 'slices/payrolslices/documentTemplateSlice';
// import AssignedDocumentCategoriesList from './assignedList/AssignedDocumentCategoriesList';
// import AssignedInputFieldOverlay from './assignedList/AssignedInputFieldOverlay';
// import AssignedList from './assignedList/AssignedList';
// import {
//   buttonStyles,
//   getCategoryColor,
//   getCategoryIcon,
//   typography
// } from './documentHelper/DocumentHelperFunctions';
// import {
//   AcceptDeleteReassignDocPayload,
//   AssignedDocument,
//   AssignedDocumentCategory,
//   InputField
// } from './types';
// import axiosInstance from 'Services/APIService';
// import { useDocumentManagement } from './DocumentManagementContext';

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// type DocumentStatus = 'pending_fill' | 'filled_submitted' | 'approved' | 'rejected';
// type ConfirmActionType = 'approve' | 'delete' | 'reassign';
// type SignatureMode = 'pad' | 'name' | 'standard';

// const statusColors: Record<DocumentStatus, string> = {
//   pending_fill: orange[500],
//   filled_submitted: blue[500],
//   approved: green[500],
//   rejected: red[500]
// };

// const statusIcons = {
//   pending_fill: <MdPendingActions />,
//   filled_submitted: <MdAssignment />,
//   approved: <MdCheckCircle />,
//   rejected: <MdClose />
// };

// const statusLabels = {
//   pending_fill: 'Fill Required',
//   filled_submitted: 'Submitted',
//   approved: 'Approved',
//   rejected: 'Rejected'
// };

// const AssignedDocumentsList: React.FC = () => {
//   const dispatch = useDispatch<AppDispatch>();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const windowSize = useWindowSize();

//   // Redux state
//   const {
//     assignedDocumentsLoading: loading,
//     assignedDocumentsError: error,
//     assignedDocumentCategories: categories,
//     totalAssignedDocuments: totalDocuments,
//     acceptDeleteReassignLoading,
//     acceptDeleteReassignError,
//     acceptDeleteReassignSuccess,
//     acceptDeleteReassignMessage
//   } = useSelector((state: RootState) => state.documentTemplate);

//   // Local state for new nested structure
//   const [categoryData, setCategoryData] = useState<AssignedDocumentCategory[]>([]);
//   const [selectedCategory, setSelectedCategory] = useState<string>('');
//   const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
//   const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());

//   // Fixed: Add states to track selected IDs
//   const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
//   const [selectedSubcategoryId, setSelectedSubcategoryId] = useState<string>('');

//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState<string>('all');
//   const [filteredDocuments, setFilteredDocuments] = useState<AssignedDocument[]>([]);

//   // Preview modal state
//   const [previewModalOpen, setPreviewModalOpen] = useState(false);
//   const [selectedDocument, setSelectedDocument] = useState<AssignedDocument | null>(null);
//   const [documentPreviewUrl, setDocumentPreviewUrl] = useState<string | null>(null);
//   const [previewLoading, setPreviewLoading] = useState(false);
//   const [pdfNumPages, setPdfNumPages] = useState<number>(0);
//   const [currentPdfPage, setCurrentPdfPage] = useState<number>(1);
//   const [scale, setScale] = useState<number>(1.0);

//   // Field editing states
//   const [editingFieldId, setEditingFieldId] = useState<string | null>(null);
//   const [fieldEditValue, setFieldEditValue] = useState<string>('');
//   const [fieldEditAnchor, setFieldEditAnchor] = useState<HTMLElement | null>(null);
//   const [documentModified, setDocumentModified] = useState(false);

//   // Enhanced edit dialog states
//   const [selectedField, setSelectedField] = useState<InputField | null>(null);
//   const [showEditDialog, setShowEditDialog] = useState(false);
//   const [signatureMode, setSignatureMode] = useState<SignatureMode>('pad');
//   const [tempFieldValue, setTempFieldValue] = useState<string>('');
//   const [typedName, setTypedName] = useState<string>('');
//   const [isStandardChecked, setIsStandardChecked] = useState<boolean>(false);
//   const signatureCanvasRef = useRef<SignatureCanvas>(null);
//   const [thumbnailsLoaded, setThumbnailsLoaded] = useState<Set<number>>(new Set());

//   // NEW: Upload states for empty templates
//   const [uploadedFileData, setUploadedFileData] = useState<{
//     fileName: string;
//     fileSize: number;
//     fileType: string;
//     base64Data: string;
//     originalFileName: string;
//   } | null>(null);
//   const [uploadLoading, setUploadLoading] = useState(false);

//   // NEW: Download states
//   const [downloadLoading, setDownloadLoading] = useState<string | null>(null);

//   // Legacy states for compatibility
//   const [signaturePadOpen, setSignaturePadOpen] = useState(false);
//   const [datePickerOpen, setDatePickerOpen] = useState(false);
//   const [signatureFieldId, setSignatureFieldId] = useState<string | null>(null);
//   const [dateFieldId, setDateFieldId] = useState<string | null>(null);
//   const [tempDate, setTempDate] = useState<Date | null>(null);
//   const sigPadRef = useRef<SignatureCanvas>(null);

//   // Action states
//   const [actionLoading, setActionLoading] = useState<string | null>(null);
//   const [successMessage, setSuccessMessage] = useState<string | null>(null);
//   const [errorMessage, setErrorMessage] = useState<string | null>(null);

//   // Confirmation dialog state
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [confirmDocument, setConfirmDocument] = useState<AssignedDocument | null>(null);
//   const [confirmAction, setConfirmAction] = useState<ConfirmActionType | null>(null);

//   // Mobile menu states
//   const [categoryMenuAnchor, setCategoryMenuAnchor] = useState<null | HTMLElement>(null);
//   const [actionMenuAnchor, setActionMenuAnchor] = useState<null | HTMLElement>(null);
//   const [currentActionDoc, setCurrentActionDoc] = useState<AssignedDocument | null>(null);

//   // PDF container reference
//   const pdfContainerRef = useRef<HTMLDivElement>(null);
//   const [pdfRenderTrigger, setPdfRenderTrigger] = useState(0);

//   const loginInfo = localStorage.getItem('user-details');
//   const userEmail = loginInfo ? JSON.parse(loginInfo).email : '';

//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector(
//     (state) => state.serviceSelected.selectedServiceTitle
//   );

//   const { isAdminLogin } = useDocumentManagement();

//   // Helper function to show messages
//   const showMessage = useCallback((message: string, isError: boolean = false) => {
//     if (isError) {
//       setErrorMessage(message);
//       setSuccessMessage(null);
//     } else {
//       setSuccessMessage(message);
//       setErrorMessage(null);
//     }
//   }, []);

//   // NEW: Document download functionality using html2canvas and jsPDF
//   const handleDownloadDocument = async (document: AssignedDocument) => {
//     if (!pdfContainerRef.current || !document) {
//       showMessage('Unable to download document', true);
//       return;
//     }

//     const downloadKey = `download-${document.documentId}`;
//     setDownloadLoading(downloadKey);

//     try {
//       // Create a temporary container for rendering
//       const originalContainer = pdfContainerRef.current;
//       const tempContainer = originalContainer.cloneNode(true) as HTMLDivElement;

//       // Style the temporary container for A4 size
//       tempContainer.style.position = 'absolute';
//       tempContainer.style.left = '-9999px';
//       tempContainer.style.top = '0';
//       tempContainer.style.width = '794px'; // A4 width at 96 DPI
//       tempContainer.style.height = '1123px'; // A4 height at 96 DPI
//       tempContainer.style.backgroundColor = 'white';
//       tempContainer.style.padding = '20px';
//       tempContainer.style.boxSizing = 'border-box';

//       window.document.body.appendChild(tempContainer);

//       // Capture the container as canvas
//       const canvas = await html2canvas(tempContainer, {
//         scale: 2, // Higher resolution
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//         width: 794,
//         height: 1123,
//         scrollX: 0,
//         scrollY: 0
//       });

//       // Remove temporary container
//       window.document.body.removeChild(tempContainer);

//       // Create PDF
//       const imgData = canvas.toDataURL('image/png');
//       const pdf = new jsPDF({
//         orientation: 'portrait',
//         unit: 'px',
//         format: [794, 1123]
//       });

//       pdf.addImage(imgData, 'PNG', 0, 0, 794, 1123);

//       // Download the PDF
//       const fileName = `${document.documentName}_${document.assignedEmpName}.pdf`;
//       pdf.save(fileName);

//       showMessage(`Document "${document.documentName}" downloaded successfully!`);
//     } catch (error: any) {
//       console.error('Download error:', error);
//       showMessage(`Failed to download document: ${error.message}`, true);
//     } finally {
//       setDownloadLoading(null);
//     }
//   };

//   // Alternative method for image documents
//   const handleDownloadImageDocument = async (document: AssignedDocument) => {
//     if (!documentPreviewUrl || !document) {
//       showMessage('No document available for download', true);
//       return;
//     }

//     const downloadKey = `download-${document.documentId}`;
//     setDownloadLoading(downloadKey);

//     try {
//       // For image documents, we can directly download the image with overlays
//       if (pdfContainerRef.current) {
//         const canvas = await html2canvas(pdfContainerRef.current, {
//           scale: 2,
//           useCORS: true,
//           allowTaint: true,
//           backgroundColor: '#ffffff'
//         });

//         // Convert canvas to blob and download
//         canvas.toBlob((blob) => {
//           if (blob) {
//             const url = URL.createObjectURL(blob);
//             const link = window.document.createElement('a');
//             link.href = url;
//             link.download = `${document.documentName}_${document.assignedEmpName}.png`;
//             window.document.body.appendChild(link);
//             link.click();
//             window.document.body.removeChild(link);
//             URL.revokeObjectURL(url);

//             showMessage(`Document "${document.documentName}" downloaded successfully!`);
//           }
//         }, 'image/png');
//       }
//     } catch (error: any) {
//       console.error('Download error:', error);
//       showMessage(`Failed to download document: ${error.message}`, true);
//     } finally {
//       setDownloadLoading(null);
//     }
//   };

//   // Effect to handle success/error messages from Redux
//   useEffect(() => {
//     if (acceptDeleteReassignSuccess && acceptDeleteReassignMessage) {
//       showMessage(acceptDeleteReassignMessage);
//       dispatch(clearAcceptDeleteReassignSuccess());
//     }

//     if (acceptDeleteReassignError) {
//       showMessage(acceptDeleteReassignError, true);
//       dispatch(clearAcceptDeleteReassignError());
//     }
//   }, [
//     acceptDeleteReassignSuccess,
//     acceptDeleteReassignMessage,
//     acceptDeleteReassignError,
//     dispatch,
//     showMessage
//   ]);

//   // Calculate PDF width dynamically
//   const calculatePdfWidth = () => {
//     const padding = isMobile ? 32 : 48;
//     const availableWidth = windowSize.width - padding;
//     return Math.max(Math.min(availableWidth * 0.95, isMobile ? 350 : 700), 280);
//   };

//   // Enhanced validation function
//   const validateRequiredFields = (): {
//     isValid: boolean;
//     missingFields: string[];
//     missingFieldLabels: string[];
//   } => {
//     if (!selectedDocument?.inputFields) {
//       return { isValid: true, missingFields: [], missingFieldLabels: [] };
//     }

//     const missingFields: string[] = [];
//     const missingFieldLabels: string[] = [];

//     selectedDocument.inputFields.forEach((field) => {
//       if (field.isRequired) {
//         const hasValue = field.value && field.value.toString().trim() !== '';
//         if (!hasValue) {
//           missingFields.push(field.type);
//           missingFieldLabels.push(field.fieldLabel || field.type);
//         }
//       }
//     });

//     return {
//       isValid: missingFields.length === 0,
//       missingFields,
//       missingFieldLabels
//     };
//   };

//   // Main update field value function
//   const updateFieldValue = useCallback(
//     (fieldId: string, value: string) => {
//       if (!selectedDocument) return;

//       const updatedDocument = {
//         ...selectedDocument,
//         inputFields: selectedDocument.inputFields.map((field) =>
//           field.id === fieldId ? { ...field, value } : field
//         )
//       };

//       setSelectedDocument(updatedDocument);
//       setDocumentModified(true);
//       setPdfRenderTrigger((prev) => prev + 1);
//       setSuccessMessage('Field updated successfully');
//     },
//     [selectedDocument]
//   );

//   // NEW: File upload handler for empty templates
//   const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (!file) return;

//     // Validate file
//     const maxSize = 10 * 1024 * 1024; // 10MB
//     const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

//     if (file.size > maxSize) {
//       setErrorMessage('File size must be less than 10MB');
//       return;
//     }

//     if (!allowedTypes.includes(file.type)) {
//       setErrorMessage('Only PDF, JPG, and PNG files are allowed');
//       return;
//     }

//     setUploadLoading(true);
//     try {
//       // Convert file to base64
//       const reader = new FileReader();
//       reader.onload = () => {
//         const base64String = reader.result as string;
//         const base64Data = base64String.split(',')[1]; // Remove data:image/jpeg;base64, prefix

//         // Get the exact file extension from the file name or MIME type
//         const getFileExtension = (fileName: string, mimeType: string): string => {
//           // First try to get extension from filename
//           const extensionFromName = fileName.split('.').pop()?.toLowerCase();

//           if (extensionFromName) {
//             return extensionFromName;
//           }

//           // Fallback: map MIME type to extension
//           const mimeToExtension: { [key: string]: string } = {
//             'application/pdf': 'pdf',
//             'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
//             'application/msword': 'doc',
//             'image/png': 'png',
//             'image/jpeg': 'jpg',
//             'image/jpg': 'jpg'
//           };

//           return mimeToExtension[mimeType] || 'unknown';
//         };

//         const fileExtension = getFileExtension(file.name, file.type);

//         const fileData = {
//           fileName: file.name,
//           fileSize: file.size,
//           fileType: fileExtension, // Use exact file extension instead of generic 'image' or 'pdf'
//           base64Data: base64Data,
//           originalFileName: file.name
//         };

//         setUploadedFileData(fileData);

//         // Create blob URL for preview
//         const blobUrl = URL.createObjectURL(file);
//         setDocumentPreviewUrl(blobUrl);

//         // Update selected document for consistent state
//         if (selectedDocument) {
//           const updatedDocument = {
//             ...selectedDocument,
//             uploadedFile: {
//               fileName: file.name,
//               fileSize: file.size,
//               fileType: fileExtension, // Use exact extension here too
//               originalFileName: file.name,
//               storedFilePath: base64Data // Store base64 temporarily
//             }
//           };
//           setSelectedDocument(updatedDocument);
//         }

//         // Reset PDF pages for new document
//         if (file.type.includes('pdf')) {
//           setPdfNumPages(0);
//           setCurrentPdfPage(1);
//           setPdfRenderTrigger(0);
//         } else {
//           setPdfRenderTrigger((prev) => prev + 1);
//         }

//         setSuccessMessage('Document uploaded successfully');
//         setUploadLoading(false);
//       };

//       reader.onerror = () => {
//         setErrorMessage('Failed to read file');
//         setUploadLoading(false);
//       };

//       reader.readAsDataURL(file);
//     } catch (error) {
//       console.error('Upload failed:', error);
//       setErrorMessage('Failed to process document. Please try again.');
//       setUploadLoading(false);
//     }
//   };

//   // Load assigned documents on component mount
//   useEffect(() => {
//     const loadAssignedDocuments = async () => {
//       if (selectedProjectId && selectedServiceTitle) {
//         try {
//           await dispatch(
//             getAllAssignedDocuments({
//               group_id: selectedProjectId,
//               service_id: selectedServiceTitle,
//               isAdmin: isAdminLogin,
//               userEmail: userEmail
//             })
//           ).unwrap();
//         } catch (error) {
//           console.error('Failed to load assigned documents:', error);
//         }
//       }
//     };

//     loadAssignedDocuments();
//   }, [dispatch, selectedProjectId, selectedServiceTitle, isAdminLogin]);

//   // Process new nested categories structure
//   useEffect(() => {
//     if (categories.length > 0) {
//       setCategoryData(categories);

//       // Auto-select first category and subcategory
//       console.log('Categories loaded:', categories);
//       if (!selectedCategory) {
//         const firstCategory = categories[0];
//         setSelectedCategory(firstCategory?.categoryName);
//         setSelectedCategoryId(firstCategory?.categoryId);
//         setExpandedCategories(new Set([firstCategory?.categoryName]));

//         if (
//           firstCategory?.subcategories &&
//           firstCategory.subcategories.length > 0 &&
//           !selectedSubcategory
//         ) {
//           setSelectedSubcategory(firstCategory?.subcategories[0]?.subcategoryName);
//           setSelectedSubcategoryId(firstCategory?.subcategories[0]?.subcategoryId);
//         }
//       }
//     }
//   }, [categories, loading, selectedCategory, selectedSubcategory]);

//   // Filter documents by selected category and subcategory
//   useEffect(() => {
//     let docs: AssignedDocument[] = [];

//     if (selectedCategory && selectedSubcategory) {
//       const categoryItem = categoryData.find((cat) => cat.categoryName === selectedCategory);
//       if (categoryItem) {
//         const subcategoryItem = categoryItem.subcategories.find(
//           (sub) => sub.subcategoryName === selectedSubcategory
//         );
//         if (subcategoryItem) {
//           docs = [...subcategoryItem.assignedDocuments];
//         }
//       }
//     }

//     // Apply search filter
//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       docs = docs.filter(
//         (doc) =>
//           doc.documentName.toLowerCase().includes(term) ||
//           doc.assignedEmpName.toLowerCase().includes(term) ||
//           doc.assignedEmployeeMailId.toLowerCase().includes(term)
//       );
//     }

//     // Apply status filter
//     if (statusFilter !== 'all') {
//       if (statusFilter === 'not_submitted') {
//         docs = docs.filter((doc) => !doc.isSubmitted);
//       } else if (statusFilter === 'submitted') {
//         docs = docs.filter((doc) => doc.isSubmitted && !doc.isAccepted);
//       } else if (statusFilter === 'approved') {
//         docs = docs.filter((doc) => doc.isAccepted);
//       }
//     }

//     setFilteredDocuments(docs);
//   }, [selectedCategory, selectedSubcategory, categoryData, searchTerm, statusFilter]);

//   // Effect to handle PDF loading and overlay rendering
//   useEffect(() => {
//     if (documentPreviewUrl && pdfNumPages > 0) {
//       const timer = setTimeout(() => {
//         setPdfRenderTrigger((prev) => prev + 1);
//       }, 300);
//       return () => clearTimeout(timer);
//     }
//   }, [documentPreviewUrl, pdfNumPages, currentPdfPage, scale]);

//   // Category handlers for new nested structure
//   const handleCategoryToggle = useCallback((categoryName: string) => {
//     setExpandedCategories((prev) => {
//       const newSet = new Set(prev);
//       if (newSet.has(categoryName)) {
//         newSet.delete(categoryName);
//       } else {
//         newSet.add(categoryName);
//       }
//       return newSet;
//     });
//   }, []);

//   // Fixed: Update subcategory selection to include IDs
//   const handleSubcategorySelect = useCallback(
//     (categoryName: string, subcategoryName: string) => {
//       // Find the category and subcategory to get their IDs
//       const categoryItem = categoryData.find((cat) => cat.categoryName === categoryName);
//       const subcategoryItem = categoryItem?.subcategories.find(
//         (sub) => sub.subcategoryName === subcategoryName
//       );

//       setSelectedCategory(categoryName);
//       setSelectedSubcategory(subcategoryName);
//       setSelectedCategoryId(categoryItem?.categoryId || '');
//       setSelectedSubcategoryId(subcategoryItem?.subcategoryId || '');
//       setCategoryMenuAnchor(null);
//     },
//     [categoryData]
//   );

//   const getDocumentStatus = (document: AssignedDocument): DocumentStatus => {
//     if (document.isAccepted || document.isApproved) {
//       return 'approved';
//     }
//     if (document.isSubmitted) {
//       return 'filled_submitted';
//     }
//     return 'pending_fill';
//   };

//   const formatDate = (dateString: string) => {
//     try {
//       return new Date(dateString).toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric'
//       });
//     } catch {
//       return dateString;
//     }
//   };

//   // Event handlers
//   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleStatusFilterChange = (e: any) => {
//     setStatusFilter(e.target.value);
//   };

//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setStatusFilter('all');
//   };

//   // Document preview functions
//   const fetchDocumentPreview = async (document: AssignedDocument) => {
//     if (!document.uploadedFile?.storedFilePath) {
//       return null;
//     }

//     try {
//       setPreviewLoading(true);
//       const encodedPath = encodeURIComponent(document.uploadedFile.storedFilePath);
//       const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
//         responseType: 'blob'
//       });

//       const blobUrl = URL.createObjectURL(response.data);
//       setDocumentPreviewUrl(blobUrl);
//       return blobUrl;
//     } catch (error) {
//       console.error('Error fetching document preview:', error);
//       return null;
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   const handlePreviewDocument = async (document: AssignedDocument) => {
//     setSelectedDocument(document);
//     setPreviewModalOpen(true);
//     setCurrentPdfPage(1);
//     setDocumentModified(false);
//     setPdfRenderTrigger(0);
//     setUploadedFileData(null); // Reset upload state
//     await fetchDocumentPreview(document);
//   };

//   const handleClosePreview = () => {
//     setPreviewModalOpen(false);
//     setSelectedDocument(null);
//     setDocumentModified(false);
//     setEditingFieldId(null);
//     setFieldEditAnchor(null);
//     setSignaturePadOpen(false);
//     setDatePickerOpen(false);
//     setSignatureFieldId(null);
//     setDateFieldId(null);
//     setShowEditDialog(false);
//     setSelectedField(null);
//     setPdfRenderTrigger(0);
//     setUploadedFileData(null); // Reset upload state
//     if (documentPreviewUrl) {
//       URL.revokeObjectURL(documentPreviewUrl);
//       setDocumentPreviewUrl(null);
//     }
//     setPdfNumPages(0);
//   };

//   const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
//     setPdfNumPages(numPages);
//     setTimeout(() => {
//       setPdfRenderTrigger((prev) => prev + 1);
//     }, 100);
//   };

//   // Enhanced field click handler
//   const handleFieldClick = useCallback(
//     (field: InputField, mode?: 'sign' | 'type') => {
//       if (!field.isEmpEdit || selectedDocument?.isApproved || selectedDocument?.isAccepted) {
//         return;
//       }

//       setSelectedField(field);
//       setTempFieldValue(field.value?.toString() || '');

//       if (field.type.toLowerCase() === 'signature') {
//         setSignatureMode('pad');
//         setShowEditDialog(true);
//       } else if (field.type.toLowerCase() === 'date' || field.type.toLowerCase() === 'expiry') {
//         setDateFieldId(field.id);
//         const currentValue = field.value?.toString();
//         setTempDate(currentValue ? new Date(currentValue) : null);
//         setDatePickerOpen(true);
//       } else {
//         setShowEditDialog(true);
//       }
//     },
//     [selectedDocument]
//   );

//   // Enhanced signature save handler
//   const handleSignatureSave = () => {
//     if (!selectedField) return;

//     let signatureValue = '';

//     switch (signatureMode) {
//       case 'pad':
//         if (signatureCanvasRef.current && !signatureCanvasRef.current.isEmpty()) {
//           signatureValue = signatureCanvasRef.current.toDataURL();
//         }
//         break;
//       case 'name':
//         signatureValue = typedName.trim();
//         break;
//       case 'standard':
//         signatureValue = isStandardChecked ? 'checked' : '';
//         break;
//     }

//     if (signatureValue) {
//       updateFieldValue(selectedField.id, signatureValue);
//       setShowEditDialog(false);
//       setTypedName('');
//       setIsStandardChecked(false);
//       if (signatureCanvasRef.current) {
//         signatureCanvasRef.current.clear();
//       }
//     } else {
//       setErrorMessage('Please provide a signature before saving.');
//     }
//   };

//   // Enhanced field save handler
//   const handleFieldSaveDialog = () => {
//     if (!selectedField || !tempFieldValue.trim()) return;

//     updateFieldValue(selectedField.id, tempFieldValue.trim());
//     setShowEditDialog(false);
//     setTempFieldValue('');
//   };

//   // Legacy signature pad handlers
//   const handleSaveSignature = () => {
//     if (!sigPadRef.current || !signatureFieldId) return;

//     if (sigPadRef.current.isEmpty()) {
//       setErrorMessage('Please provide a signature first.');
//       return;
//     }

//     const dataURL = sigPadRef.current.toDataURL();
//     updateFieldValue(signatureFieldId, dataURL);
//     setSignaturePadOpen(false);
//     setSignatureFieldId(null);
//   };

//   const handleClearSignature = () => {
//     if (sigPadRef.current) {
//       sigPadRef.current.clear();
//     }
//   };

//   const handleCloseSignaturePad = () => {
//     setSignaturePadOpen(false);
//     setSignatureFieldId(null);
//   };

//   // Date picker handlers
//   const handleSaveDate = () => {
//     if (!dateFieldId) return;

//     const dateValue = tempDate ? tempDate.toISOString().split('T')[0] : '';
//     updateFieldValue(dateFieldId, dateValue);

//     setDatePickerOpen(false);
//     setDateFieldId(null);
//     setTempDate(null);
//   };

//   const handleCloseDatePicker = () => {
//     setDatePickerOpen(false);
//     setDateFieldId(null);
//     setTempDate(null);
//   };

//   // UPDATED: Enhanced submit function with proper file handling and approval check
//   const handleSubmitDocument = async () => {
//     if (!selectedDocument || !selectedProjectId || !selectedServiceTitle) return;

//     // Prevent submission if already approved
//     if (selectedDocument.isApproved || selectedDocument.isAccepted) {
//       setErrorMessage('Cannot submit an already approved document');
//       return;
//     }

//     const validation = validateRequiredFields();
//     const editableValidation = selectedDocument.inputFields.filter(
//       (field) =>
//         field.isRequired &&
//         field.isEmpEdit &&
//         (!field.value || field.value.toString().trim() === '')
//     );

//     if (!validation.isValid) {
//       const fieldsList = validation.missingFieldLabels.join(', ');
//       setErrorMessage(`Please fill in all required fields before submitting: ${fieldsList}`);
//       return;
//     }

//     if (editableValidation.length > 0) {
//       const editableFields = editableValidation.map((f) => f.fieldLabel || f.type).join(', ');
//       setErrorMessage(`Please fill in all required editable fields: ${editableFields}`);
//       return;
//     }

//     // Check if document upload is required for empty template
//     const isEmptyTemplate =
//       !selectedDocument.uploadedFile?.storedFilePath ||
//       selectedDocument.uploadedFile?.storedFilePath === '';
//     const hasUploadedFile = uploadedFileData !== null;

//     if (isEmptyTemplate && !hasUploadedFile) {
//       setErrorMessage('Please upload a document before submitting');
//       return;
//     }

//     setActionLoading('submit');

//     try {
//       const processedInputFields = selectedDocument.inputFields.map((field) => ({
//         ...field,
//         value: field.value || '',
//         ...(field.isRequired &&
//           !field.value && {
//             value: field.type === 'signature' ? '' : field.fieldLabel || ''
//           })
//       }));

//       // Handle file path based on template type
//       let uploadedFileForPayload;

//       if (isEmptyTemplate && hasUploadedFile) {
//         // For empty templates, send base64 data as storedFilePath
//         uploadedFileForPayload = {
//           fileName: uploadedFileData.fileName,
//           fileSize: uploadedFileData.fileSize,
//           fileType: uploadedFileData.fileType,
//           originalFileName: uploadedFileData.originalFileName,
//           storedFilePath: uploadedFileData.base64Data // Send base64 as path
//         };
//       } else {
//         // For existing templates, use existing file data as is
//         uploadedFileForPayload = selectedDocument.uploadedFile;
//       }

//       const payload = {
//         group_id: selectedProjectId,
//         assignedId: selectedDocument.assignedId,
//         service_id: selectedServiceTitle,
//         documentId: selectedDocument.documentId,
//         documentName: selectedDocument.documentName,
//         documentDate: selectedDocument.documentDate,
//         categoryId: selectedCategoryId,
//         subCategoryId: selectedSubcategoryId,
//         inputFields: processedInputFields,
//         uploadedFile: uploadedFileForPayload,
//         assignedEmployeeMailId: selectedDocument.assignedEmployeeMailId,
//         assignedEmpName: selectedDocument.assignedEmpName
//       };

//       await dispatch(submitESignDoc(payload)).unwrap();
//       setSuccessMessage('Document submitted successfully');
//       handleClosePreview();

//       // Reload documents
//       await dispatch(
//         getAllAssignedDocuments({
//           group_id: selectedProjectId,
//           service_id: selectedServiceTitle,
//           isAdmin: isAdminLogin
//         })
//       ).unwrap();
//     } catch (error: any) {
//       if (error.includes('Missing values for required fields')) {
//         const backendError = error.split(': ')[1] || 'unknown fields';
//         setErrorMessage(
//           `Backend validation failed. Missing required fields: ${backendError}. Please check all required fields are properly filled.`
//         );
//       } else {
//         setErrorMessage(error || 'Failed to submit document');
//       }
//     } finally {
//       setActionLoading(null);
//     }
//   };

//   // Confirmation dialog handlers
//   const handleOpenConfirmDialog = (document: AssignedDocument, action: ConfirmActionType) => {
//     // Admin permission check
//     if (!isAdminLogin) {
//       showMessage('Only administrators can perform this action', true);
//       return;
//     }

//     setConfirmDocument(document);
//     setConfirmAction(action);
//     setConfirmDialogOpen(true);
//     setActionMenuAnchor(null);
//     setCurrentActionDoc(null);
//   };

//   const handleCloseConfirmDialog = () => {
//     setConfirmDialogOpen(false);
//     setConfirmDocument(null);
//     setConfirmAction(null);
//   };

//   // Fixed: Updated to use correct categoryId and subcategoryId
//   const handleConfirmAction = async () => {
//     if (!confirmDocument || !confirmAction || !selectedProjectId || !selectedServiceTitle) return;

//     try {
//       const mappedAction: 'accept' | 'delete' | 'reassign' =
//         confirmAction === 'approve' ? 'accept' : (confirmAction as 'delete' | 'reassign');

//       const payload: AcceptDeleteReassignDocPayload = {
//         group_id: selectedProjectId,
//         service_id: selectedServiceTitle,
//         employeeMailId: confirmDocument.assignedEmployeeMailId,
//         assignedId: confirmDocument.assignedId!,
//         action: mappedAction,
//         categoryId: selectedCategoryId,
//         subcategoryId: selectedSubcategoryId
//       };

//       await dispatch(acceptDeleteReassignDoc(payload)).unwrap();
//       handleCloseConfirmDialog();

//       // Reload documents
//       await dispatch(
//         getAllAssignedDocuments({
//           group_id: selectedProjectId,
//           service_id: selectedServiceTitle,
//           isAdmin: isAdminLogin,
//           userEmail: userEmail
//         })
//       ).unwrap();
//     } catch (error: any) {
//       console.error('Action failed:', error);
//     }
//   };

//   const handleDocumentAction = async (
//     document: AssignedDocument,
//     action: 'approve' | 'delete' | 'reassign'
//   ) => {
//     handleOpenConfirmDialog(document, action);
//   };

//   const handleActionMenuOpen = (
//     event: React.MouseEvent<HTMLElement>,
//     document: AssignedDocument
//   ) => {
//     event.stopPropagation();
//     setActionMenuAnchor(event.currentTarget);
//     setCurrentActionDoc(document);
//   };

//   const handleActionMenuClose = () => {
//     setActionMenuAnchor(null);
//     setCurrentActionDoc(null);
//   };

//   // Helper functions for ConfirmationDialog
//   const getDialogTitle = () => {
//     if (!confirmAction) return 'Confirm Action';
//     switch (confirmAction) {
//       case 'approve':
//         return 'Confirm Approval';
//       case 'delete':
//         return 'Confirm Deletion';
//       case 'reassign':
//         return 'Confirm Reassignment';
//       default:
//         return 'Confirm Action';
//     }
//   };

//   const getDialogMessage = () => {
//     if (!confirmAction || !confirmDocument) return '';

//     switch (confirmAction) {
//       case 'approve':
//         return `Are you sure you want to approve the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}?`;
//       case 'delete':
//         return `Are you sure you want to delete the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}? This action cannot be undone.`;
//       case 'reassign':
//         return `Are you sure you want to reassign the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}?`;
//       default:
//         return '';
//     }
//   };

//   const getDialogButtonText = () => {
//     if (!confirmAction) return 'Confirm';
//     switch (confirmAction) {
//       case 'approve':
//         return 'Approve';
//       case 'delete':
//         return 'Delete';
//       case 'reassign':
//         return 'Reassign';
//       default:
//         return 'Confirm';
//     }
//   };

//   const getDialogButtonColor = (): 'primary' | 'error' | 'success' => {
//     if (!confirmAction) return 'primary';
//     switch (confirmAction) {
//       case 'approve':
//         return 'success';
//       case 'delete':
//         return 'error';
//       case 'reassign':
//         return 'primary';
//       default:
//         return 'primary';
//     }
//   };

//   // UPDATED: Empty template canvas renderer
//   const renderEmptyTemplateCanvas = () => {
//     return (
//       <Box
//         ref={pdfContainerRef}
//         sx={{
//           position: 'relative',
//           width: '100%',
//           height: 'calc(60vh - 80px)',
//           border: `1px solid ${theme.palette.divider}`,
//           borderRadius: 1.5,
//           bgcolor: '#fafafa',
//           overflow: 'auto',
//           backgroundImage: `
//             linear-gradient(rgba(156, 163, 175, 0.1) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(156, 163, 175, 0.1) 1px, transparent 1px)
//           `,
//           backgroundSize: '20px 20px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}
//       >
//         {/* Empty state message */}
//         {(!selectedDocument?.inputFields || selectedDocument.inputFields.length === 0) && (
//           <Box sx={{ textAlign: 'center', opacity: 0.6, zIndex: 1 }}>
//             <MdDescription
//               style={{ fontSize: isMobile ? 36 : 48, color: grey[400], marginBottom: 8 }}
//             />
//             <Typography
//               variant="body2"
//               color="text.secondary"
//               sx={{ fontSize: '0.75rem', mb: 0.5 }}
//             >
//               Empty Template Canvas
//             </Typography>
//             <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.675rem' }}>
//               Field overlays will appear here when positioned
//             </Typography>
//           </Box>
//         )}

//         {/* Upload area - only show when no document is uploaded */}
//         {!documentPreviewUrl && (
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 16,
//               right: 16,
//               zIndex: 2
//             }}
//           >
//             <Tooltip title="Upload Document">
//               <IconButton
//                 onClick={() => window.document.getElementById('file-upload-input')?.click()}
//                 sx={{
//                   bgcolor: theme.palette.primary.main,
//                   color: 'white',
//                   '&:hover': {
//                     bgcolor: theme.palette.primary.dark
//                   },
//                   boxShadow: 2
//                 }}
//                 disabled={uploadLoading}
//               >
//                 {uploadLoading ? (
//                   <CircularProgress size={20} sx={{ color: 'white' }} />
//                 ) : (
//                   <MdCloudUpload />
//                 )}
//               </IconButton>
//             </Tooltip>
//           </Box>
//         )}

//         {/* Render field overlays for empty template */}
//         {selectedDocument?.inputFields &&
//           selectedDocument.inputFields.length > 0 &&
//           selectedDocument.inputFields
//             .filter((field) => field.pageNumber === 1)
//             .map((field) => (
//               <AssignedInputFieldOverlay
//                 key={field.id}
//                 field={field}
//                 selectedDocument={selectedDocument}
//                 pdfContainerRef={pdfContainerRef}
//                 handleFieldClick={handleFieldClick}
//                 updateFieldValue={updateFieldValue}
//                 isMobile={isMobile}
//               />
//             ))}
//       </Box>
//     );
//   };

//   // Enhanced thumbnail rendering function
//   const renderThumbnail = (pageNumber: number) => {
//     const isSelected = currentPdfPage === pageNumber;
//     const fieldsOnPage =
//       selectedDocument?.inputFields?.filter((field) => field.pageNumber === pageNumber) ?? [];

//     return (
//       <Box
//         key={`thumbnail-${pageNumber}`}
//         onClick={() => setCurrentPdfPage(pageNumber)}
//         sx={{
//           position: 'relative',
//           cursor: 'pointer',
//           border: isSelected ? '2px solid #1976d2' : '1px solid #ddd',
//           borderRadius: 1,
//           bgcolor: isSelected ? '#e3f2fd' : 'white',
//           overflow: 'hidden',
//           transition: 'all 0.2s ease',
//           '&:hover': {
//             borderColor: '#1976d2',
//             transform: 'scale(1.02)',
//             boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//           },
//           width: isMobile ? 60 : 80,
//           height: isMobile ? 84 : 112,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           mx: 'auto',
//           mb: 1,
//           flexShrink: 0
//         }}
//       >
//         <Document file={documentPreviewUrl} loading={null} error={null}>
//           <Page
//             pageNumber={pageNumber}
//             width={isMobile ? 50 : 70}
//             height={isMobile ? 70 : 98}
//             renderTextLayer={false}
//             renderAnnotationLayer={false}
//             loading={
//               <Box
//                 sx={{
//                   width: isMobile ? 50 : 70,
//                   height: isMobile ? 70 : 98,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   bgcolor: grey[50]
//                 }}
//               >
//                 <CircularProgress size={16} />
//               </Box>
//             }
//             onRenderSuccess={() => {
//               setThumbnailsLoaded((prev) => new Set([...Array.from(prev), pageNumber]));
//             }}
//           />
//         </Document>

//         <Box
//           sx={{
//             position: 'absolute',
//             bottom: 2,
//             left: 2,
//             bgcolor: isSelected ? '#1976d2' : 'rgba(0,0,0,0.7)',
//             color: 'white',
//             px: 0.5,
//             py: 0.25,
//             borderRadius: 0.5,
//             fontSize: isMobile ? '8px' : '10px',
//             fontWeight: 600,
//             lineHeight: 1,
//             minWidth: 16,
//             textAlign: 'center'
//           }}
//         >
//           {pageNumber}
//         </Box>

//         {fieldsOnPage.length > 0 && (
//           <Box
//             sx={{
//               position: 'absolute',
//               top: 2,
//               right: 2,
//               bgcolor: '#ff9800',
//               color: 'white',
//               minWidth: 16,
//               height: 16,
//               borderRadius: '50%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: isMobile ? '8px' : '9px',
//               fontWeight: 600,
//               lineHeight: 1
//             }}
//           >
//             {fieldsOnPage.length}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   // UPDATED: Enhanced PDF and Image preview with upload support and field tags
//   const renderPdfPreviewWithTags = () => {
//     const validation = validateRequiredFields();
//     const requiredFieldsCount =
//       selectedDocument?.inputFields?.filter((f) => f.isRequired && f.isEmpEdit).length || 0;
//     const filledRequiredFieldsCount =
//       selectedDocument?.inputFields?.filter(
//         (f) => f.isRequired && f.isEmpEdit && f.value && f.value.toString().trim() !== ''
//       ).length || 0;

//     if (!selectedDocument) {
//       return (
//         <Box sx={{ p: 3, textAlign: 'center' }}>
//           <Typography color="text.secondary">No document selected</Typography>
//         </Box>
//       );
//     }

//     const isImageDocument = selectedDocument.uploadedFile?.fileType !== 'pdf';
//     const isEmptyTemplate = !documentPreviewUrl;
//     const isApproved = selectedDocument.isApproved || selectedDocument.isAccepted;

//     return (
//       <Box
//         sx={{
//           height: '70vh',
//           border: `1px solid ${theme.palette.divider}`,
//           borderRadius: 1.5,
//           position: 'relative',
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//       >
//         {/* Toolbar */}
//         <Box
//           sx={{
//             borderBottom: `1px solid ${theme.palette.divider}`,
//             p: 1,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             bgcolor: grey[50],
//             flexShrink: 0
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             {isEmptyTemplate ? (
//               <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                 Empty Template - Upload document required
//               </Typography>
//             ) : isImageDocument ? (
//               <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                 Image Document
//               </Typography>
//             ) : (
//               <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                 Page {currentPdfPage} of {pdfNumPages}
//               </Typography>
//             )}

//             {uploadedFileData && (
//               <Chip
//                 label="Uploaded"
//                 size="small"
//                 sx={{
//                   height: 20,
//                   fontSize: '0.65rem',
//                   bgcolor: `${blue[500]}15`,
//                   color: blue[500]
//                 }}
//               />
//             )}

//             {isApproved && (
//               <Chip
//                 icon={<MdLock style={{ fontSize: 12 }} />}
//                 label="Approved (Read Only)"
//                 size="small"
//                 sx={{
//                   height: 20,
//                   fontSize: '0.65rem',
//                   bgcolor: `${green[500]}15`,
//                   color: green[500]
//                 }}
//               />
//             )}

//             {selectedDocument?.inputFields && (
//               <>
//                 <Chip
//                   label={`${selectedDocument.inputFields.length} fields`}
//                   size="small"
//                   sx={{
//                     height: 20,
//                     fontSize: '0.65rem',
//                     bgcolor: `${purple[500]}15`,
//                     color: purple[500]
//                   }}
//                 />
//                 <Chip
//                   label={`${selectedDocument.inputFields.filter((f) => f.value).length} filled`}
//                   size="small"
//                   sx={{
//                     height: 20,
//                     fontSize: '0.65rem',
//                     bgcolor: `${green[500]}15`,
//                     color: green[500]
//                   }}
//                 />
//                 {requiredFieldsCount > 0 && (
//                   <Chip
//                     label={`${filledRequiredFieldsCount}/${requiredFieldsCount} required`}
//                     size="small"
//                     sx={{
//                       height: 20,
//                       fontSize: '0.65rem',
//                       bgcolor: validation.isValid ? `${green[500]}15` : `${red[500]}15`,
//                       color: validation.isValid ? green[600] : red[600],
//                       animation: !validation.isValid ? 'pulse 2s infinite' : 'none'
//                     }}
//                   />
//                 )}
//               </>
//             )}

//             {documentModified && (
//               <Chip
//                 label="Modified"
//                 size="small"
//                 sx={{
//                   height: 20,
//                   fontSize: '0.65rem',
//                   bgcolor: `${orange[500]}15`,
//                   color: orange[500]
//                 }}
//               />
//             )}

//             {/* Upload button - only show for empty templates */}
//             {isEmptyTemplate && !isApproved && (
//               <Tooltip title="Upload Document">
//                 <IconButton
//                   size="small"
//                   onClick={() => window.document.getElementById('file-upload-input')?.click()}
//                   disabled={uploadLoading}
//                   sx={{
//                     bgcolor: theme.palette.primary.main,
//                     color: 'white',
//                     width: 28,
//                     height: 28,
//                     '&:hover': {
//                       bgcolor: theme.palette.primary.dark
//                     }
//                   }}
//                 >
//                   {uploadLoading ? (
//                     <CircularProgress size={16} sx={{ color: 'white' }} />
//                   ) : (
//                     <MdCloudUpload style={{ fontSize: 16 }} />
//                   )}
//                 </IconButton>
//               </Tooltip>
//             )}

//             {/* Download button */}
//             {documentPreviewUrl && (
//               <Tooltip title="Download Document">
//                 <IconButton
//                   size="small"
//                   onClick={() => {
//                     if (isImageDocument) {
//                       handleDownloadImageDocument(selectedDocument);
//                     } else {
//                       handleDownloadDocument(selectedDocument);
//                     }
//                   }}
//                   disabled={downloadLoading === `download-${selectedDocument.documentId}`}
//                   sx={{
//                     bgcolor: purple[500],
//                     color: 'white',
//                     width: 28,
//                     height: 28,
//                     '&:hover': {
//                       bgcolor: purple[600]
//                     }
//                   }}
//                 >
//                   {downloadLoading === `download-${selectedDocument.documentId}` ? (
//                     <CircularProgress size={16} sx={{ color: 'white' }} />
//                   ) : (
//                     <MdDownload style={{ fontSize: 16 }} />
//                   )}
//                 </IconButton>
//               </Tooltip>
//             )}
//           </Box>

//           {!isImageDocument && !isEmptyTemplate && (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//               {/* Zoom controls */}
//               <IconButton
//                 onClick={() => setScale(Math.max(0.5, scale - 0.1))}
//                 disabled={scale <= 0.5}
//                 size="small"
//                 sx={{ bgcolor: 'white', border: '1px solid #e0e0e0' }}
//               >
//                 -
//               </IconButton>
//               <Typography
//                 variant="caption"
//                 sx={{
//                   minWidth: '40px',
//                   textAlign: 'center',
//                   fontSize: '10px'
//                 }}
//               >
//                 {Math.round(scale * 100)}%
//               </Typography>
//               <IconButton
//                 onClick={() => setScale(Math.min(2.0, scale + 0.1))}
//                 disabled={scale >= 2.0}
//                 size="small"
//                 sx={{ bgcolor: 'white', border: '1px solid #e0e0e0' }}
//               >
//                 +
//               </IconButton>

//               {/* Page navigation */}
//               {pdfNumPages > 1 && (
//                 <Box sx={{ display: 'flex', gap: 0.5, ml: 1 }}>
//                   <Button
//                     onClick={() => setCurrentPdfPage(Math.max(1, currentPdfPage - 1))}
//                     disabled={currentPdfPage <= 1}
//                     size="small"
//                     sx={{
//                       ...buttonStyles.base,
//                       ...buttonStyles.sizes.small,
//                       ...buttonStyles.variants.outlined,
//                       minWidth: 40
//                     }}
//                   >
//                     ←
//                   </Button>
//                   <Button
//                     onClick={() => setCurrentPdfPage(Math.min(pdfNumPages, currentPdfPage + 1))}
//                     disabled={currentPdfPage >= pdfNumPages}
//                     size="small"
//                     sx={{
//                       ...buttonStyles.base,
//                       ...buttonStyles.sizes.small,
//                       ...buttonStyles.variants.outlined,
//                       minWidth: 40
//                     }}
//                   >
//                     →
//                   </Button>
//                 </Box>
//               )}
//             </Box>
//           )}
//         </Box>

//         {/* Main Display Area with Thumbnails */}
//         <Box
//           sx={{
//             flex: 1,
//             overflow: 'hidden',
//             position: 'relative',
//             display: 'flex'
//           }}
//         >
//           {/* Thumbnails Panel - Only show for PDF documents with multiple pages */}
//           {!isEmptyTemplate && !isImageDocument && pdfNumPages > 1 && (
//             <Box
//               sx={{
//                 width: isMobile ? 80 : 100,
//                 borderRight: `1px solid ${theme.palette.divider}`,
//                 overflowY: 'auto',
//                 overflowX: 'hidden',
//                 p: 1,
//                 flexShrink: 0
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontSize: '0.65rem',
//                   fontWeight: 600,
//                   color: 'text.secondary',
//                   textAlign: 'center',
//                   mb: 1
//                 }}
//               >
//                 Pages ({pdfNumPages})
//               </Typography>
//               {Array.from({ length: pdfNumPages }, (_, i) => i + 1).map((pageNum) =>
//                 renderThumbnail(pageNum)
//               )}
//             </Box>
//           )}

//           {/* Document Display Area */}
//           <Box
//             sx={{
//               flex: 1,
//               overflow: 'auto',
//               position: 'relative'
//             }}
//           >
//             {isEmptyTemplate ? (
//               renderEmptyTemplateCanvas()
//             ) : (
//               // Document display with field overlays
//               <Box
//                 ref={pdfContainerRef}
//                 sx={{
//                   flex: 1,
//                   overflowY: 'auto',
//                   overflowX: 'auto',
//                   p: 1,
//                   bgcolor: grey[50],
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'flex-start',
//                   minHeight: 0,
//                   position: 'relative'
//                 }}
//               >
//                 <Box sx={{ position: 'relative', width: 'fit-content', isolation: 'isolate' }}>
//                   {isImageDocument ? (
//                     <img
//                       src={documentPreviewUrl || ''}
//                       alt={selectedDocument.documentName}
//                       style={{
//                         maxWidth: '100%',
//                         maxHeight: '100%',
//                         objectFit: 'contain'
//                       }}
//                       onLoad={() => {
//                         setPreviewLoading(false);
//                         setPdfRenderTrigger((prev) => prev + 1);
//                       }}
//                     />
//                   ) : (
//                     <Document
//                       file={documentPreviewUrl}
//                       onLoadSuccess={onDocumentLoadSuccess}
//                       onLoadError={() => console.error('PDF load error')}
//                       loading={
//                         <Box sx={{ p: 4, textAlign: 'center' }}>
//                           <CircularProgress size={24} />
//                           <Typography sx={{ mt: 1 }}>Loading PDF...</Typography>
//                         </Box>
//                       }
//                       error={
//                         <Box sx={{ p: 4, textAlign: 'center' }}>
//                           <Typography color="error">
//                             Failed to load PDF. Please try again.
//                           </Typography>
//                         </Box>
//                       }
//                     >
//                       <Page
//                         pageNumber={currentPdfPage}
//                         scale={scale}
//                         width={calculatePdfWidth()}
//                         renderTextLayer={false}
//                         renderAnnotationLayer={false}
//                         loading={<CircularProgress size={20} />}
//                         onRenderSuccess={() => {
//                           setTimeout(() => {
//                             setPdfRenderTrigger((prev) => prev + 1);
//                           }, 100);
//                         }}
//                       />
//                     </Document>
//                   )}

//                   {/* Field Overlays - Show on uploaded documents too */}
//                   {selectedDocument?.inputFields
//                     ?.filter((field) => field.pageNumber === (isImageDocument ? 1 : currentPdfPage))
//                     .map((field) => (
//                       <AssignedInputFieldOverlay
//                         key={field.id}
//                         field={field}
//                         selectedDocument={selectedDocument}
//                         pdfContainerRef={pdfContainerRef}
//                         handleFieldClick={handleFieldClick}
//                         updateFieldValue={updateFieldValue}
//                         isMobile={isMobile}
//                       />
//                     ))}
//                 </Box>
//               </Box>
//             )}
//           </Box>
//         </Box>

//         {/* Hidden file input */}
//         <input
//           id="file-upload-input"
//           type="file"
//           accept=".pdf,.jpg,.jpeg,.png"
//           style={{ display: 'none' }}
//           onChange={handleFileUpload}
//           disabled={uploadLoading || isApproved || false}
//         />
//       </Box>
//     );
//   };

//   // UPDATED: Enhanced Dialog Actions with upload validation and approval check
//   const renderDialogActions = () => {
//     const validation = validateRequiredFields();
//     const editableRequiredFields =
//       selectedDocument?.inputFields?.filter((f) => f.isRequired && f.isEmpEdit) || [];
//     const editableRequiredFieldsEmpty = editableRequiredFields.filter(
//       (f) => !f.value || f.value.toString().trim() === ''
//     );

//     // Check if document upload is required
//     const isEmptyTemplate =
//       !selectedDocument?.uploadedFile?.storedFilePath ||
//       selectedDocument?.uploadedFile?.storedFilePath === '';
//     const uploadRequired = isEmptyTemplate && !uploadedFileData;
//     const isApproved = selectedDocument?.isApproved || selectedDocument?.isAccepted;

//     const canSubmit =
//       selectedDocument &&
//       !isApproved &&
//       validation.isValid &&
//       editableRequiredFieldsEmpty.length === 0 &&
//       !uploadRequired;

//     return (
//       <DialogActions sx={{ justifyContent: 'space-between', px: 2 }}>
//         <Button onClick={handleClosePreview}>Close</Button>

//         <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//           {/* Enhanced validation warnings */}
//           {selectedDocument && !isApproved && (
//             <>
//               {uploadRequired && (
//                 <Alert
//                   severity="error"
//                   sx={{
//                     py: 0.5,
//                     px: 1,
//                     fontSize: '0.75rem',
//                     '& .MuiAlert-message': { py: 0 }
//                   }}
//                 >
//                   Document upload required
//                 </Alert>
//               )}

//               {!validation.isValid && (
//                 <Alert
//                   severity="error"
//                   sx={{
//                     py: 0.5,
//                     px: 1,
//                     fontSize: '0.75rem',
//                     '& .MuiAlert-message': { py: 0 }
//                   }}
//                 >
//                   Missing required fields: {validation.missingFieldLabels.join(', ')}
//                 </Alert>
//               )}

//               {validation.isValid && editableRequiredFieldsEmpty.length > 0 && (
//                 <Alert
//                   severity="warning"
//                   sx={{
//                     py: 0.5,
//                     px: 1,
//                     fontSize: '0.75rem',
//                     '& .MuiAlert-message': { py: 0 }
//                   }}
//                 >
//                   Please fill: {editableRequiredFieldsEmpty.map((f) => f.fieldLabel).join(', ')}
//                 </Alert>
//               )}
//             </>
//           )}

//           {/* Approve button - only show to admin if submitted but not yet approved */}
//           {isAdminLogin &&
//             selectedDocument &&
//             getDocumentStatus(selectedDocument) === 'filled_submitted' &&
//             !isApproved && (
//               <Button
//                 variant="contained"
//                 color="success"
//                 onClick={() => handleDocumentAction(selectedDocument, 'approve')}
//                 disabled={actionLoading?.includes(selectedDocument.documentId)}
//                 startIcon={<MdThumbUp />}
//                 sx={buttonStyles.base}
//               >
//                 Approve
//               </Button>
//             )}

//           {/* Submit button - only show if not approved */}
//           {selectedDocument && !isApproved && (
//             <Tooltip
//               title={
//                 !canSubmit
//                   ? uploadRequired
//                     ? 'Please upload a document first'
//                     : !validation.isValid
//                     ? `Missing required fields: ${validation.missingFieldLabels.join(', ')}`
//                     : editableRequiredFieldsEmpty.length > 0
//                     ? `Please fill: ${editableRequiredFieldsEmpty
//                         .map((f) => f.fieldLabel)
//                         .join(', ')}`
//                     : 'Unknown validation error'
//                   : 'Submit document for review'
//               }
//             >
//               <span>
//                 <Button
//                   variant="contained"
//                   onClick={handleSubmitDocument}
//                   disabled={actionLoading === 'submit' || !canSubmit}
//                   startIcon={
//                     actionLoading === 'submit' ? <CircularProgress size={16} /> : <MdSend />
//                   }
//                   sx={{
//                     ...buttonStyles.base,
//                     ...buttonStyles.variants.contained,
//                     ...(!canSubmit && {
//                       bgcolor: red[500],
//                       '&:hover': {
//                         bgcolor: red[600]
//                       }
//                     })
//                   }}
//                 >
//                   {actionLoading === 'submit' ? 'Submitting...' : 'Submit Document'}
//                 </Button>
//               </span>
//             </Tooltip>
//           )}

//           {/* Read only indicator for approved documents */}
//           {isApproved && (
//             <Chip
//               icon={<MdLock />}
//               label="Document Approved - Read Only"
//               sx={{
//                 bgcolor: `${green[500]}15`,
//                 color: green[600],
//                 fontWeight: 500
//               }}
//             />
//           )}
//         </Box>
//       </DialogActions>
//     );
//   };

//   if (loading) {
//     return (
//       <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
//         <Stack
//           direction="row"
//           spacing={1.5}
//           justifyContent="center"
//           alignItems="center"
//           sx={{ minHeight: '30vh' }}
//         >
//           <CircularProgress size={24} />
//           <Typography sx={{ ...typography.bodyText }} color="text.secondary">
//             Loading assigned documents...
//           </Typography>
//         </Stack>
//       </Container>
//     );
//   }

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Box sx={{ position: 'relative' }}>
//         {/* Success Snackbar */}
//         <Snackbar
//           open={Boolean(successMessage)}
//           autoHideDuration={4000}
//           onClose={() => setSuccessMessage(null)}
//           anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         >
//           <Alert onClose={() => setSuccessMessage(null)} severity="success" sx={{ width: '100%' }}>
//             {successMessage}
//           </Alert>
//         </Snackbar>

//         {/* Error Snackbar */}
//         <Snackbar
//           open={Boolean(errorMessage)}
//           autoHideDuration={6000}
//           onClose={() => setErrorMessage(null)}
//           anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         >
//           <Alert onClose={() => setErrorMessage(null)} severity="error" sx={{ width: '100%' }}>
//             {errorMessage}
//           </Alert>
//         </Snackbar>

//         <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
//           {/* Page Header */}
//           <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
//             <Typography
//               sx={{
//                 ...typography.mainTitle,
//                 fontWeight: 'bold',
//                 color: 'primary.main',
//                 mb: 0.5
//               }}
//             >
//               Assigned Documents Review
//             </Typography>
//             <Typography
//               sx={{
//                 ...typography.smallText,
//                 color: 'text.secondary'
//               }}
//             >
//               Review and manage document assignments by category • {totalDocuments} total documents
//             </Typography>
//           </Box>

//           {error && (
//             <Alert severity="error" sx={{ mb: { xs: 1.5, md: 2 }, borderRadius: 1.5 }}>
//               <Typography sx={{ ...typography.smallText }}>Error: {error}</Typography>
//             </Alert>
//           )}

//           {/* Two Column Layout */}
//           <Grid container spacing={isMobile ? 1 : 1.5}>
//             {/* Categories Panel (Left) */}
//             {!isMobile && categoryData.length > 0 && (
//               <Grid item sm={3}>
//                 <AssignedDocumentCategoriesList
//                   categoryData={categoryData}
//                   selectedCategory={selectedCategory}
//                   selectedSubcategory={selectedSubcategory}
//                   expandedCategories={expandedCategories}
//                   getCategoryColor={getCategoryColor}
//                   getCategoryIcon={getCategoryIcon}
//                   handleCategoryToggle={handleCategoryToggle}
//                   handleSubcategorySelect={handleSubcategorySelect}
//                   typography={typography}
//                 />
//               </Grid>
//             )}

//             {/* Documents Panel (Right) */}
//             <Grid item xs={12} sm={isMobile ? 12 : 9}>
//               <AssignedList
//                 filteredDocuments={filteredDocuments}
//                 selectedCategory={selectedCategory}
//                 selectedSubcategory={selectedSubcategory}
//                 searchTerm={searchTerm}
//                 statusFilter={statusFilter}
//                 isMobile={isMobile}
//                 actionLoading={actionLoading}
//                 acceptDeleteReassignLoading={acceptDeleteReassignLoading ?? false}
//                 getCategoryColor={getCategoryColor}
//                 getDocumentStatus={getDocumentStatus}
//                 formatDate={formatDate}
//                 handleSearch={handleSearch}
//                 handleStatusFilterChange={handleStatusFilterChange}
//                 handleClearFilters={handleClearFilters}
//                 handlePreviewDocument={handlePreviewDocument}
//                 handleDocumentAction={handleDocumentAction}
//                 handleActionMenuOpen={handleActionMenuOpen}
//                 statusColors={statusColors}
//                 statusIcons={statusIcons}
//                 statusLabels={statusLabels}
//                 typography={typography}
//               />
//             </Grid>
//           </Grid>
//         </Container>

//         {/* Mobile Category Selector */}
//         {isMobile && categoryData.length > 0 && (
//           <>
//             <Fab
//               onClick={(e) => setCategoryMenuAnchor(e.currentTarget)}
//               sx={{
//                 position: 'fixed',
//                 bottom: 16,
//                 right: 16,
//                 bgcolor: purple[500],
//                 color: 'white',
//                 width: 44,
//                 height: 44,
//                 '&:hover': {
//                   bgcolor: purple[600]
//                 }
//               }}
//             >
//               <MdCategory style={{ fontSize: 18 }} />
//             </Fab>

//             {/* Enhanced Category Menu with Subcategories */}
//             <Menu
//               anchorEl={categoryMenuAnchor}
//               open={Boolean(categoryMenuAnchor)}
//               onClose={() => setCategoryMenuAnchor(null)}
//               transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
//               anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
//               PaperProps={{
//                 sx: {
//                   maxHeight: '70vh',
//                   width: '280px',
//                   borderRadius: 1.5
//                 }
//               }}
//             >
//               {categoryData.map((category) => (
//                 <Box key={category.categoryId}>
//                   <MenuItem
//                     sx={{
//                       flexDirection: 'column',
//                       alignItems: 'stretch',
//                       p: 0
//                     }}
//                   >
//                     {/* Category Header */}
//                     <Box
//                       sx={{
//                         p: 1.5,
//                         width: '100%',
//                         bgcolor:
//                           selectedCategory === category.categoryName
//                             ? `${getCategoryColor(category.categoryName)}08`
//                             : 'transparent'
//                       }}
//                       onClick={() => handleCategoryToggle(category.categoryName)}
//                     >
//                       <Stack direction="row" alignItems="center" spacing={1}>
//                         {React.cloneElement(getCategoryIcon(category.categoryName), {
//                           style: { fontSize: 16, color: getCategoryColor(category.categoryName) }
//                         })}
//                         <Typography sx={{ ...typography.bodyText, fontWeight: 600 }}>
//                           {category.categoryName}
//                         </Typography>
//                         <Chip
//                           label={category.totalDocuments}
//                           size="small"
//                           sx={{
//                             height: 16,
//                             fontSize: '0.625rem',
//                             bgcolor: `${getCategoryColor(category.categoryName)}15`,
//                             color: getCategoryColor(category.categoryName)
//                           }}
//                         />
//                       </Stack>
//                     </Box>

//                     {/* Subcategories */}
//                     {expandedCategories.has(category.categoryName) && (
//                       <Box sx={{ pl: 2, pb: 1 }}>
//                         {category.subcategories.map((subcategory) => (
//                           <Box
//                             key={subcategory.subcategoryId}
//                             sx={{
//                               p: 1,
//                               cursor: 'pointer',
//                               borderRadius: 1,
//                               bgcolor:
//                                 selectedCategory === category.categoryName &&
//                                 selectedSubcategory === subcategory.subcategoryName
//                                   ? `${getCategoryColor(category.categoryName)}12`
//                                   : 'transparent',
//                               '&:hover': {
//                                 bgcolor: `${getCategoryColor(category.categoryName)}08`
//                               }
//                             }}
//                             onClick={() =>
//                               handleSubcategorySelect(
//                                 category.categoryName,
//                                 subcategory.subcategoryName
//                               )
//                             }
//                           >
//                             <Stack direction="row" alignItems="center" spacing={1}>
//                               <MdFolder
//                                 style={{
//                                   fontSize: 12,
//                                   color: getCategoryColor(category.categoryName)
//                                 }}
//                               />
//                               <Typography sx={{ ...typography.bodyText }}>
//                                 {subcategory.subcategoryName}
//                               </Typography>
//                               <Chip
//                                 label={subcategory.totalDocuments}
//                                 size="small"
//                                 sx={{
//                                   height: 14,
//                                   fontSize: '0.5625rem',
//                                   bgcolor: `${getCategoryColor(category.categoryName)}10`,
//                                   color: getCategoryColor(category.categoryName)
//                                 }}
//                               />
//                             </Stack>
//                           </Box>
//                         ))}
//                       </Box>
//                     )}
//                   </MenuItem>
//                 </Box>
//               ))}
//             </Menu>
//           </>
//         )}

//         {/* Action Menu */}
//         <Menu
//           anchorEl={actionMenuAnchor}
//           open={Boolean(actionMenuAnchor)}
//           onClose={handleActionMenuClose}
//         >
//           {/* Only show admin actions if user is admin */}
//           {isAdminLogin && (
//             <>
//               <MenuItem
//                 onClick={() =>
//                   currentActionDoc && handleDocumentAction(currentActionDoc, 'approve')
//                 }
//                 disabled={acceptDeleteReassignLoading}
//               >
//                 <MdCheckCircle style={{ marginRight: 8, fontSize: 16, color: green[600] }} />
//                 <Typography sx={{ ...typography.bodyText, color: green[600] }}>
//                   Approve Document
//                 </Typography>
//               </MenuItem>
//               <MenuItem
//                 onClick={() =>
//                   currentActionDoc && handleDocumentAction(currentActionDoc, 'reassign')
//                 }
//                 disabled={acceptDeleteReassignLoading}
//               >
//                 <MdRestore style={{ marginRight: 8, fontSize: 16, color: orange[600] }} />
//                 <Typography sx={{ ...typography.bodyText, color: orange[600] }}>
//                   Reassign Document
//                 </Typography>
//               </MenuItem>
//             </>
//           )}

//           {/* <MenuItem
//             onClick={() => {
//               if (currentActionDoc) {
//                 const isImageDoc = currentActionDoc.uploadedFile?.fileType !== 'pdf';
//                 if (isImageDoc) {
//                   handleDownloadImageDocument(currentActionDoc);
//                 } else {
//                   handleDownloadDocument(currentActionDoc);
//                 }
//                 handleActionMenuClose();
//               }
//             }}
//           >
//             <MdDownload style={{ marginRight: 8, fontSize: 16 }} />
//             <Typography sx={{ ...typography.bodyText }}>Download</Typography>
//           </MenuItem> */}

//           {/* Only show delete if user is admin */}
//           {isAdminLogin && (
//             <MenuItem
//               onClick={() => currentActionDoc && handleDocumentAction(currentActionDoc, 'delete')}
//               disabled={acceptDeleteReassignLoading}
//             >
//               <MdDelete style={{ marginRight: 8, fontSize: 16, color: red[600] }} />
//               <Typography sx={{ ...typography.bodyText, color: red[600] }}>Delete</Typography>
//             </MenuItem>
//           )}
//         </Menu>

//         {/* Fixed: Updated Confirmation Dialog */}
//         <ConfirmationDialog
//           open={confirmDialogOpen}
//           title={getDialogTitle()}
//           message={getDialogMessage()}
//           confirmButtonText={getDialogButtonText()}
//           confirmButtonColor={getDialogButtonColor()}
//           onConfirm={handleConfirmAction}
//           onCancel={handleCloseConfirmDialog}
//           loading={acceptDeleteReassignLoading}
//         />

//         {/* Preview Modal */}
//         <Dialog
//           open={previewModalOpen}
//           onClose={handleClosePreview}
//           maxWidth="xl"
//           fullWidth
//           fullScreen={isMobile}
//           PaperProps={{
//             sx: {
//               maxHeight: '95vh',
//               height: isMobile ? '100vh' : '90vh'
//             }
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center'
//             }}
//           >
//             <Box>
//               <Typography sx={{ ...typography.sectionTitle, fontWeight: 600 }}>
//                 {selectedDocument?.documentName}
//               </Typography>
//               <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
//                 {selectedDocument?.assignedEmpName} • {selectedCategory} → {selectedSubcategory}
//                 {(selectedDocument?.isApproved || selectedDocument?.isAccepted) &&
//                   ' • Approved (Read Only)'}
//               </Typography>
//             </Box>
//             <IconButton onClick={handleClosePreview}>
//               <MdClose />
//             </IconButton>
//           </DialogTitle>

//           <DialogContent sx={{ p: 1 }}>
//             {previewLoading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               renderPdfPreviewWithTags()
//             )}
//           </DialogContent>

//           {renderDialogActions()}
//         </Dialog>

//         {/* Enhanced Edit Dialog */}
//         <Dialog
//           open={showEditDialog}
//           onClose={() => setShowEditDialog(false)}
//           maxWidth="xs"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 1.5,
//               minHeight:
//                 selectedField?.type.toLowerCase() === 'signature'
//                   ? isMobile
//                     ? 320
//                     : 380
//                   : isMobile
//                   ? 180
//                   : 220,
//               width:
//                 selectedField?.type.toLowerCase() === 'signature' ? undefined : isMobile ? 280 : 320
//             }
//           }}
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               pb: 1,
//               fontSize: isMobile ? '1rem' : '1.1rem'
//             }}
//           >
//             {selectedField?.type.toLowerCase() === 'signature'
//               ? 'Add Signature'
//               : `Edit ${selectedField?.type || 'Field'}`}
//             <IconButton
//               onClick={() => setShowEditDialog(false)}
//               size="small"
//               sx={{ color: 'text.secondary' }}
//             >
//               <MdClose size={16} />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent sx={{ p: isMobile ? 1.5 : 2 }}>
//             {selectedField?.type.toLowerCase() === 'signature' ? (
//               <>
//                 <Tabs
//                   value={signatureMode}
//                   onChange={(_, newValue) => setSignatureMode(newValue)}
//                   variant="fullWidth"
//                   sx={{
//                     mb: 2,
//                     '& .MuiTab-root': {
//                       minHeight: 32,
//                       fontSize: '0.75rem',
//                       textTransform: 'none',
//                       fontWeight: 500,
//                       px: 1
//                     },
//                     '& .MuiTabs-indicator': { height: 2 }
//                   }}
//                 >
//                   <Tab
//                     icon={<MdGesture size={14} />}
//                     label="Draw"
//                     value="pad"
//                     iconPosition="start"
//                   />
//                   <Tab
//                     icon={<MdTextFields size={14} />}
//                     label="Type"
//                     value="name"
//                     iconPosition="start"
//                   />
//                   <Tab
//                     icon={<MdCheckBox size={14} />}
//                     label="Check"
//                     value="standard"
//                     iconPosition="start"
//                   />
//                 </Tabs>
//                 <Box
//                   sx={{
//                     minHeight: isMobile ? 140 : 180,
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                 >
//                   {signatureMode === 'pad' && (
//                     <Paper
//                       elevation={2}
//                       sx={{
//                         p: 1,
//                         borderRadius: 1,
//                         border: (theme) => `1px solid ${theme.palette.primary.main}20`
//                       }}
//                     >
//                       <SignatureCanvas
//                         ref={signatureCanvasRef}
//                         canvasProps={{
//                           width: isMobile ? 260 : 340,
//                           height: isMobile ? 100 : 140,
//                           style: {
//                             backgroundColor: '#fff',
//                             borderRadius: '4px',
//                             cursor: 'crosshair'
//                           }
//                         }}
//                         penColor="black"
//                         minWidth={1}
//                         maxWidth={2.5}
//                       />
//                     </Paper>
//                   )}
//                   {signatureMode === 'name' && (
//                     <Box sx={{ width: '100%', maxWidth: 320 }}>
//                       <TextField
//                         fullWidth
//                         size="small"
//                         label="Your Full Name"
//                         value={typedName}
//                         onChange={(e) => setTypedName(e.target.value)}
//                         placeholder="Enter your full name"
//                         variant="outlined"
//                         sx={{
//                           mb: 2,
//                           '& .MuiInputBase-input': {
//                             fontSize: '0.9rem',
//                             textAlign: 'center',
//                             fontFamily: 'cursive'
//                           }
//                         }}
//                       />
//                       {typedName && (
//                         <Paper
//                           elevation={1}
//                           sx={{
//                             p: 2,
//                             bgcolor: '#f8f9fa',
//                             border: (theme) => `1px solid ${theme.palette.primary.main}20`,
//                             textAlign: 'center'
//                           }}
//                         >
//                           <Typography
//                             sx={{
//                               fontFamily: 'cursive',
//                               color: 'text.primary',
//                               fontSize: '1.1rem'
//                             }}
//                           >
//                             {typedName}
//                           </Typography>
//                         </Paper>
//                       )}
//                     </Box>
//                   )}
//                   {signatureMode === 'standard' && (
//                     <Paper
//                       elevation={1}
//                       sx={{
//                         p: 2,
//                         bgcolor: '#f8f9fa',
//                         border: (theme) => `1px solid ${theme.palette.primary.main}20`,
//                         minWidth: 160
//                       }}
//                     >
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             checked={isStandardChecked}
//                             onChange={(e) => setIsStandardChecked(e.target.checked)}
//                             sx={{
//                               transform: 'scale(1.5)',
//                               color: 'success.main',
//                               '&.Mui-checked': { color: 'success.main' }
//                             }}
//                           />
//                         }
//                         label={
//                           <Typography sx={{ ml: 1, fontSize: '0.9rem' }}>
//                             Standard Checkmark
//                           </Typography>
//                         }
//                       />
//                     </Paper>
//                   )}
//                 </Box>
//               </>
//             ) : (
//               <Box sx={{ py: 1 }}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   value={tempFieldValue}
//                   onChange={(e) => setTempFieldValue(e.target.value)}
//                   type={
//                     selectedField?.type === 'date'
//                       ? 'date'
//                       : selectedField?.type === 'email'
//                       ? 'email'
//                       : 'text'
//                   }
//                   autoFocus
//                   placeholder={`Enter ${selectedField?.type}`}
//                   sx={{
//                     mb: 1.5,
//                     '& .MuiInputBase-input': { fontSize: '0.8rem' }
//                   }}
//                   InputLabelProps={selectedField?.type === 'date' ? { shrink: true } : {}}
//                   helperText={
//                     selectedField?.type === 'email'
//                       ? 'Valid email address'
//                       : selectedField?.type === 'date'
//                       ? 'Select date'
//                       : `Enter ${selectedField?.type} information`
//                   }
//                   FormHelperTextProps={{ sx: { fontSize: '0.65rem', mt: 0.5 } }}
//                 />
//               </Box>
//             )}
//           </DialogContent>
//           <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
//             <Button
//               onClick={() => {
//                 if (selectedField?.type.toLowerCase() === 'signature') {
//                   if (signatureMode === 'pad' && signatureCanvasRef.current)
//                     signatureCanvasRef.current.clear();
//                   else if (signatureMode === 'name') setTypedName('');
//                   else setIsStandardChecked(false);
//                 } else {
//                   setTempFieldValue('');
//                 }
//               }}
//               color="secondary"
//               size="small"
//               variant="outlined"
//               sx={{ fontSize: '0.75rem' }}
//             >
//               Clear
//             </Button>
//             <Stack direction="row" spacing={1}>
//               <Button
//                 onClick={() => setShowEditDialog(false)}
//                 color="primary"
//                 size="small"
//                 variant="outlined"
//                 sx={{ fontSize: '0.75rem' }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 onClick={
//                   selectedField?.type.toLowerCase() === 'signature'
//                     ? handleSignatureSave
//                     : handleFieldSaveDialog
//                 }
//                 color="primary"
//                 size="small"
//                 variant="contained"
//                 disabled={
//                   selectedField?.type.toLowerCase() === 'signature'
//                     ? (signatureMode === 'pad' && signatureCanvasRef.current?.isEmpty()) ||
//                       (signatureMode === 'name' && !typedName.trim()) ||
//                       (signatureMode === 'standard' && !isStandardChecked)
//                     : !tempFieldValue.trim()
//                 }
//                 sx={{ fontSize: '0.75rem' }}
//               >
//                 Save
//               </Button>
//             </Stack>
//           </DialogActions>
//         </Dialog>

//         {/* Legacy Signature Pad Dialog */}
//         <Dialog
//           open={signaturePadOpen}
//           onClose={handleCloseSignaturePad}
//           maxWidth="sm"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 1.5
//             }
//           }}
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Digital Signature
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               Please sign in the area below
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box
//               sx={{
//                 border: '2px dashed #ccc',
//                 borderRadius: 1,
//                 p: 1,
//                 bgcolor: '#fafafa'
//               }}
//             >
//               <SignatureCanvas
//                 ref={sigPadRef}
//                 canvasProps={{
//                   width: 400,
//                   height: 200,
//                   style: {
//                     width: '100%',
//                     height: '200px',
//                     border: 'none',
//                     borderRadius: '4px',
//                     backgroundColor: 'white'
//                   }
//                 }}
//                 backgroundColor="white"
//                 penColor="black"
//               />
//             </Box>
//           </DialogContent>
//           <DialogActions sx={{ p: 2, gap: 1 }}>
//             <Button onClick={handleCloseSignaturePad} color="inherit">
//               Cancel
//             </Button>
//             <Button onClick={handleClearSignature} color="warning" variant="outlined">
//               Clear
//             </Button>
//             <Button onClick={handleSaveSignature} variant="contained" color="primary">
//               Save Signature
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* Date Picker Dialog */}
//         <Dialog
//           open={datePickerOpen}
//           onClose={handleCloseDatePicker}
//           maxWidth="xs"
//           fullWidth
//           PaperProps={{
//             sx: {
//               borderRadius: 1.5
//             }
//           }}
//         >
//           <DialogTitle>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Select Date
//             </Typography>
//           </DialogTitle>
//           <DialogContent sx={{ p: 3 }}>
//             <DatePicker
//               value={tempDate}
//               onChange={(newValue) => setTempDate(newValue)}
//               slotProps={{
//                 textField: {
//                   fullWidth: true,
//                   size: 'small',
//                   sx: { mt: 1 }
//                 },
//                 openPickerButton: {
//                   sx: {
//                     color: 'primary.main'
//                   }
//                 }
//               }}
//             />
//           </DialogContent>
//           <DialogActions sx={{ p: 2, gap: 1 }}>
//             <Button onClick={handleCloseDatePicker} color="inherit">
//               Cancel
//             </Button>
//             <Button onClick={handleSaveDate} variant="contained" color="primary">
//               Save Date
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default AssignedDocumentsList;






import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  Paper,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { blue, green, grey, orange, purple, red } from '@mui/material/colors';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useAppSelector } from 'app/hooks';
import { AppDispatch, RootState } from 'app/store';
import ConfirmationDialog from 'commonComponents/ConfirmationDialog';
import { useWindowSize } from 'hooks/useWindowSize';
import {
  MdAssignment,
  MdCategory,
  MdCheckCircle,
  MdClose,
  MdDelete,
  MdDownload,
  MdPendingActions,
  MdRestore,
  MdSend,
  MdThumbUp,
  MdGesture,
  MdTextFields,
  MdCheckBox,
  MdFolder,
  MdCloudUpload,
  MdDescription,
  MdLock
} from 'react-icons/md';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useDispatch, useSelector } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import {
  acceptDeleteReassignDoc,
  clearAcceptDeleteReassignError,
  clearAcceptDeleteReassignSuccess,
  getAllAssignedDocuments,
  submitESignDoc
} from 'slices/payrolslices/documentTemplateSlice';
import AssignedDocumentCategoriesList from './assignedList/AssignedDocumentCategoriesList';
import AssignedInputFieldOverlay from './assignedList/AssignedInputFieldOverlay';
import AssignedList from './assignedList/AssignedList';
import {
  buttonStyles,
  getCategoryColor,
  getCategoryIcon,
  typography
} from './documentHelper/DocumentHelperFunctions';
import {
  AcceptDeleteReassignDocPayload,
  AssignedDocument,
  AssignedDocumentCategory,
  InputField
} from './types';
import axiosInstance from 'Services/APIService';
import { useDocumentManagement } from './DocumentManagementContext';

// Import download utilities
import {
  handleDownloadFilledDocument,
  handleDownloadOriginalDocument,
  handleDownloadImageDocument
} from './assignedList/DownloadUtils';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

type DocumentStatus = 'pending_fill' | 'filled_submitted' | 'approved' | 'rejected';
type ConfirmActionType = 'approve' | 'delete' | 'reassign';
type SignatureMode = 'pad' | 'name' | 'standard';

const statusColors: Record<DocumentStatus, string> = {
  pending_fill: orange[500],
  filled_submitted: blue[500],
  approved: green[500],
  rejected: red[500]
};

const statusIcons = {
  pending_fill: <MdPendingActions />,
  filled_submitted: <MdAssignment />,
  approved: <MdCheckCircle />,
  rejected: <MdClose />
};

const statusLabels = {
  pending_fill: 'Fill Required',
  filled_submitted: 'Submitted',
  approved: 'Approved',
  rejected: 'Rejected'
};

const AssignedDocumentsList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const windowSize = useWindowSize();

  // Redux state
  const {
    assignedDocumentsLoading: loading,
    assignedDocumentsError: error,
    assignedDocumentCategories: categories,
    totalAssignedDocuments: totalDocuments,
    acceptDeleteReassignLoading,
    acceptDeleteReassignError,
    acceptDeleteReassignSuccess,
    acceptDeleteReassignMessage
  } = useSelector((state: RootState) => state.documentTemplate);

  // Local state for new nested structure
  const [categoryData, setCategoryData] = useState<AssignedDocumentCategory[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [selectedSubcategory, setSelectedSubcategory] = useState<string>('');
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set());

  // Fixed: Add states to track selected IDs
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const [selectedSubcategoryId, setSelectedSubcategoryId] = useState<string>('');

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [filteredDocuments, setFilteredDocuments] = useState<AssignedDocument[]>([]);

  // Preview modal state
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<AssignedDocument | null>(null);
  const [documentPreviewUrl, setDocumentPreviewUrl] = useState<string | null>(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [pdfNumPages, setPdfNumPages] = useState<number>(0);
  const [currentPdfPage, setCurrentPdfPage] = useState<number>(1);
  const [scale, setScale] = useState<number>(1.0);

  // Field editing states
  const [editingFieldId, setEditingFieldId] = useState<string | null>(null);
  const [fieldEditValue, setFieldEditValue] = useState<string>('');
  const [fieldEditAnchor, setFieldEditAnchor] = useState<HTMLElement | null>(null);
  const [documentModified, setDocumentModified] = useState(false);

  // Enhanced edit dialog states
  const [selectedField, setSelectedField] = useState<InputField | null>(null);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [signatureMode, setSignatureMode] = useState<SignatureMode>('pad');
  const [tempFieldValue, setTempFieldValue] = useState<string>('');
  const [typedName, setTypedName] = useState<string>('');
  const [isStandardChecked, setIsStandardChecked] = useState<boolean>(false);
  const signatureCanvasRef = useRef<SignatureCanvas>(null);
  const [thumbnailsLoaded, setThumbnailsLoaded] = useState<Set<number>>(new Set());

  // NEW: Upload states for empty templates
  const [uploadedFileData, setUploadedFileData] = useState<{
    fileName: string;
    fileSize: number;
    fileType: string;
    base64Data: string;
    originalFileName: string;
  } | null>(null);
  const [uploadLoading, setUploadLoading] = useState(false);

  // NEW: Download states
  const [downloadLoading, setDownloadLoading] = useState<string | null>(null);

  // Legacy states for compatibility
  const [signaturePadOpen, setSignaturePadOpen] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [signatureFieldId, setSignatureFieldId] = useState<string | null>(null);
  const [dateFieldId, setDateFieldId] = useState<string | null>(null);
  const [tempDate, setTempDate] = useState<Date | null>(null);
  const sigPadRef = useRef<SignatureCanvas>(null);

  // Action states
  const [actionLoading, setActionLoading] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  // Confirmation dialog state
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDocument, setConfirmDocument] = useState<AssignedDocument | null>(null);
  const [confirmAction, setConfirmAction] = useState<ConfirmActionType | null>(null);

  // Mobile menu states
  const [categoryMenuAnchor, setCategoryMenuAnchor] = useState<null | HTMLElement>(null);
  const [actionMenuAnchor, setActionMenuAnchor] = useState<null | HTMLElement>(null);
  const [currentActionDoc, setCurrentActionDoc] = useState<AssignedDocument | null>(null);

  // PDF container reference
  const pdfContainerRef = useRef<HTMLDivElement>(null);
  const [pdfRenderTrigger, setPdfRenderTrigger] = useState(0);

  const loginInfo = localStorage.getItem('user-details');
  const userEmail = loginInfo ? JSON.parse(loginInfo).email : '';

  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const selectedServiceTitle = useAppSelector(
    (state) => state.serviceSelected.selectedServiceTitle
  );

  const { isAdminLogin } = useDocumentManagement();

  // Helper function to show messages
  const showMessage = useCallback((message: string, isError: boolean = false) => {
    if (isError) {
      setErrorMessage(message);
      setSuccessMessage(null);
    } else {
      setSuccessMessage(message);
      setErrorMessage(null);
    }
  }, []);

  // ✅ FIXED: Pass pdfContainerRef for coordinate mapping
  const handleDownloadDocument = async (document: AssignedDocument) => {
    if (!document) {
      showMessage('No document to download', true);
      return;
    }

    const hasFilledData = document.inputFields?.some((field) => field.value);

    if (hasFilledData) {
      // ✅ CRITICAL FIX: Pass pdfContainerRef parameter
      await handleDownloadFilledDocument(
        document,
        { showMessage, setDownloadLoading },
        pdfContainerRef as React.RefObject<HTMLDivElement>
      );
    } else {
      await handleDownloadOriginalDocument(document, { showMessage, setDownloadLoading });
    }
  };

  // For image documents
  const handleDownloadImageDoc = async (document: AssignedDocument) => {
    await handleDownloadImageDocument(document, pdfContainerRef as React.RefObject<HTMLDivElement>, {
      showMessage,
      setDownloadLoading
    });
  };

  // Effect to handle success/error messages from Redux
  useEffect(() => {
    if (acceptDeleteReassignSuccess && acceptDeleteReassignMessage) {
      showMessage(acceptDeleteReassignMessage);
      dispatch(clearAcceptDeleteReassignSuccess());
    }

    if (acceptDeleteReassignError) {
      showMessage(acceptDeleteReassignError, true);
      dispatch(clearAcceptDeleteReassignError());
    }
  }, [
    acceptDeleteReassignSuccess,
    acceptDeleteReassignMessage,
    acceptDeleteReassignError,
    dispatch,
    showMessage
  ]);

  // Calculate PDF width dynamically
  const calculatePdfWidth = () => {
    const padding = isMobile ? 32 : 48;
    const availableWidth = windowSize.width - padding;
    return Math.max(Math.min(availableWidth * 0.95, isMobile ? 350 : 700), 280);
  };

  // Enhanced validation function
  const validateRequiredFields = (): {
    isValid: boolean;
    missingFields: string[];
    missingFieldLabels: string[];
  } => {
    if (!selectedDocument?.inputFields) {
      return { isValid: true, missingFields: [], missingFieldLabels: [] };
    }

    const missingFields: string[] = [];
    const missingFieldLabels: string[] = [];

    selectedDocument.inputFields.forEach((field) => {
      if (field.isRequired) {
        const hasValue = field.value && field.value.toString().trim() !== '';
        if (!hasValue) {
          missingFields.push(field.type);
          missingFieldLabels.push(field.fieldLabel || field.type);
        }
      }
    });

    return {
      isValid: missingFields.length === 0,
      missingFields,
      missingFieldLabels
    };
  };

  // Main update field value function
  const updateFieldValue = useCallback(
    (fieldId: string, value: string) => {
      if (!selectedDocument) return;

      const updatedDocument = {
        ...selectedDocument,
        inputFields: selectedDocument.inputFields.map((field) =>
          field.id === fieldId ? { ...field, value } : field
        )
      };

      setSelectedDocument(updatedDocument);
      setDocumentModified(true);
      setPdfRenderTrigger((prev) => prev + 1);
      setSuccessMessage('Field updated successfully');
    },
    [selectedDocument]
  );

  // NEW: File upload handler for empty templates
  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

    if (file.size > maxSize) {
      setErrorMessage('File size must be less than 10MB');
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      setErrorMessage('Only PDF, JPG, and PNG files are allowed');
      return;
    }

    setUploadLoading(true);
    try {
      // Convert file to base64
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        const base64Data = base64String.split(',')[1]; // Remove data:image/jpeg;base64, prefix

        // Get the exact file extension from the file name or MIME type
        const getFileExtension = (fileName: string, mimeType: string): string => {
          // First try to get extension from filename
          const extensionFromName = fileName.split('.').pop()?.toLowerCase();

          if (extensionFromName) {
            return extensionFromName;
          }

          // Fallback: map MIME type to extension
          const mimeToExtension: { [key: string]: string } = {
            'application/pdf': 'pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
            'application/msword': 'doc',
            'image/png': 'png',
            'image/jpeg': 'jpg',
            'image/jpg': 'jpg'
          };

          return mimeToExtension[mimeType] || 'unknown';
        };

        const fileExtension = getFileExtension(file.name, file.type);

        const fileData = {
          fileName: file.name,
          fileSize: file.size,
          fileType: fileExtension, // Use exact file extension instead of generic 'image' or 'pdf'
          base64Data: base64Data,
          originalFileName: file.name
        };

        setUploadedFileData(fileData);

        // Create blob URL for preview
        const blobUrl = URL.createObjectURL(file);
        setDocumentPreviewUrl(blobUrl);

        // Update selected document for consistent state
        if (selectedDocument) {
          const updatedDocument = {
            ...selectedDocument,
            uploadedFile: {
              fileName: file.name,
              fileSize: file.size,
              fileType: fileExtension, // Use exact extension here too
              originalFileName: file.name,
              storedFilePath: base64Data // Store base64 temporarily
            }
          };
          setSelectedDocument(updatedDocument);
        }

        // Reset PDF pages for new document
        if (file.type.includes('pdf')) {
          setPdfNumPages(0);
          setCurrentPdfPage(1);
          setPdfRenderTrigger(0);
        } else {
          setPdfRenderTrigger((prev) => prev + 1);
        }

        setSuccessMessage('Document uploaded successfully');
        setUploadLoading(false);
      };

      reader.onerror = () => {
        setErrorMessage('Failed to read file');
        setUploadLoading(false);
      };

      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Upload failed:', error);
      setErrorMessage('Failed to process document. Please try again.');
      setUploadLoading(false);
    }
  };

  // Load assigned documents on component mount
  useEffect(() => {
    const loadAssignedDocuments = async () => {
      if (selectedProjectId && selectedServiceTitle) {
        try {
          await dispatch(
            getAllAssignedDocuments({
              group_id: selectedProjectId,
              service_id: selectedServiceTitle,
              isAdmin: isAdminLogin,
              userEmail: userEmail
            })
          ).unwrap();
        } catch (error) {
          console.error('Failed to load assigned documents:', error);
        }
      }
    };

    loadAssignedDocuments();
  }, [dispatch, selectedProjectId, selectedServiceTitle, isAdminLogin]);

  // Process new nested categories structure
  useEffect(() => {
    if (categories.length > 0) {
      setCategoryData(categories);

      // Auto-select first category and subcategory
      console.log('Categories loaded:', categories);
      if (!selectedCategory) {
        const firstCategory = categories[0];
        setSelectedCategory(firstCategory?.categoryName);
        setSelectedCategoryId(firstCategory?.categoryId);
        setExpandedCategories(new Set([firstCategory?.categoryName]));

        if (
          firstCategory?.subcategories &&
          firstCategory.subcategories.length > 0 &&
          !selectedSubcategory
        ) {
          setSelectedSubcategory(firstCategory?.subcategories[0]?.subcategoryName);
          setSelectedSubcategoryId(firstCategory?.subcategories[0]?.subcategoryId);
        }
      }
    }
  }, [categories, loading, selectedCategory, selectedSubcategory]);

  // Filter documents by selected category and subcategory
  useEffect(() => {
    let docs: AssignedDocument[] = [];

    if (selectedCategory && selectedSubcategory) {
      const categoryItem = categoryData.find((cat) => cat.categoryName === selectedCategory);
      if (categoryItem) {
        const subcategoryItem = categoryItem.subcategories.find(
          (sub) => sub.subcategoryName === selectedSubcategory
        );
        if (subcategoryItem) {
          docs = [...subcategoryItem.assignedDocuments];
        }
      }
    }

    // Apply search filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      docs = docs.filter(
        (doc) =>
          doc.documentName.toLowerCase().includes(term) ||
          doc.assignedEmpName.toLowerCase().includes(term) ||
          doc.assignedEmployeeMailId.toLowerCase().includes(term)
      );
    }

    // Apply status filter
    if (statusFilter !== 'all') {
      if (statusFilter === 'not_submitted') {
        docs = docs.filter((doc) => !doc.isSubmitted);
      } else if (statusFilter === 'submitted') {
        docs = docs.filter((doc) => doc.isSubmitted && !doc.isAccepted);
      } else if (statusFilter === 'approved') {
        docs = docs.filter((doc) => doc.isAccepted);
      }
    }

    setFilteredDocuments(docs);
  }, [selectedCategory, selectedSubcategory, categoryData, searchTerm, statusFilter]);

  // Effect to handle PDF loading and overlay rendering
  useEffect(() => {
    if (documentPreviewUrl && pdfNumPages > 0) {
      const timer = setTimeout(() => {
        setPdfRenderTrigger((prev) => prev + 1);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [documentPreviewUrl, pdfNumPages, currentPdfPage, scale]);

  // Category handlers for new nested structure
  const handleCategoryToggle = useCallback((categoryName: string) => {
    setExpandedCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(categoryName)) {
        newSet.delete(categoryName);
      } else {
        newSet.add(categoryName);
      }
      return newSet;
    });
  }, []);

  // Fixed: Update subcategory selection to include IDs
  const handleSubcategorySelect = useCallback(
    (categoryName: string, subcategoryName: string) => {
      // Find the category and subcategory to get their IDs
      const categoryItem = categoryData.find((cat) => cat.categoryName === categoryName);
      const subcategoryItem = categoryItem?.subcategories.find(
        (sub) => sub.subcategoryName === subcategoryName
      );

      setSelectedCategory(categoryName);
      setSelectedSubcategory(subcategoryName);
      setSelectedCategoryId(categoryItem?.categoryId || '');
      setSelectedSubcategoryId(subcategoryItem?.subcategoryId || '');
      setCategoryMenuAnchor(null);
    },
    [categoryData]
  );

  const getDocumentStatus = (document: AssignedDocument): DocumentStatus => {
    if (document.isAccepted || document.isApproved) {
      return 'approved';
    }
    if (document.isSubmitted) {
      return 'filled_submitted';
    }
    return 'pending_fill';
  };

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  // Event handlers
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilterChange = (e: any) => {
    setStatusFilter(e.target.value);
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setStatusFilter('all');
  };

  // Document preview functions
  const fetchDocumentPreview = async (document: AssignedDocument) => {
    if (!document.uploadedFile?.storedFilePath) {
      return null;
    }

    try {
      setPreviewLoading(true);
      const encodedPath = encodeURIComponent(document.uploadedFile.storedFilePath);
      const response = await axiosInstance.get(`/avatar/get-avatar?path=${encodedPath}`, {
        responseType: 'blob'
      });

      const blobUrl = URL.createObjectURL(response.data);
      setDocumentPreviewUrl(blobUrl);
      return blobUrl;
    } catch (error) {
      console.error('Error fetching document preview:', error);
      return null;
    } finally {
      setPreviewLoading(false);
    }
  };

  const handlePreviewDocument = async (document: AssignedDocument) => {
    setSelectedDocument(document);
    setPreviewModalOpen(true);
    setCurrentPdfPage(1);
    setDocumentModified(false);
    setPdfRenderTrigger(0);
    setUploadedFileData(null); // Reset upload state
    await fetchDocumentPreview(document);
  };

  const handleClosePreview = () => {
    setPreviewModalOpen(false);
    setSelectedDocument(null);
    setDocumentModified(false);
    setEditingFieldId(null);
    setFieldEditAnchor(null);
    setSignaturePadOpen(false);
    setDatePickerOpen(false);
    setSignatureFieldId(null);
    setDateFieldId(null);
    setShowEditDialog(false);
    setSelectedField(null);
    setPdfRenderTrigger(0);
    setUploadedFileData(null); // Reset upload state
    if (documentPreviewUrl) {
      URL.revokeObjectURL(documentPreviewUrl);
      setDocumentPreviewUrl(null);
    }
    setPdfNumPages(0);
  };

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPdfNumPages(numPages);
    setTimeout(() => {
      setPdfRenderTrigger((prev) => prev + 1);
    }, 100);
  };

  // Enhanced field click handler
  const handleFieldClick = useCallback(
    (field: InputField, mode?: 'sign' | 'type') => {
      if (!field.isEmpEdit || selectedDocument?.isApproved || selectedDocument?.isAccepted) {
        return;
      }

      setSelectedField(field);
      setTempFieldValue(field.value?.toString() || '');

      if (field.type.toLowerCase() === 'signature') {
        setSignatureMode('pad');
        setShowEditDialog(true);
      } else if (field.type.toLowerCase() === 'date' || field.type.toLowerCase() === 'expiry') {
        setDateFieldId(field.id);
        const currentValue = field.value?.toString();
        setTempDate(currentValue ? new Date(currentValue) : null);
        setDatePickerOpen(true);
      } else {
        setShowEditDialog(true);
      }
    },
    [selectedDocument]
  );

  // Enhanced signature save handler
  const handleSignatureSave = () => {
    if (!selectedField) return;

    let signatureValue = '';

    switch (signatureMode) {
      case 'pad':
        if (signatureCanvasRef.current && !signatureCanvasRef.current.isEmpty()) {
          signatureValue = signatureCanvasRef.current.toDataURL();
        }
        break;
      case 'name':
        signatureValue = typedName.trim();
        break;
      case 'standard':
        signatureValue = isStandardChecked ? 'checked' : '';
        break;
    }

    if (signatureValue) {
      updateFieldValue(selectedField.id, signatureValue);
      setShowEditDialog(false);
      setTypedName('');
      setIsStandardChecked(false);
      if (signatureCanvasRef.current) {
        signatureCanvasRef.current.clear();
      }
    } else {
      setErrorMessage('Please provide a signature before saving.');
    }
  };

  // Enhanced field save handler
  const handleFieldSaveDialog = () => {
    if (!selectedField || !tempFieldValue.trim()) return;

    updateFieldValue(selectedField.id, tempFieldValue.trim());
    setShowEditDialog(false);
    setTempFieldValue('');
  };

  // Legacy signature pad handlers
  const handleSaveSignature = () => {
    if (!sigPadRef.current || !signatureFieldId) return;

    if (sigPadRef.current.isEmpty()) {
      setErrorMessage('Please provide a signature first.');
      return;
    }

    const dataURL = sigPadRef.current.toDataURL();
    updateFieldValue(signatureFieldId, dataURL);
    setSignaturePadOpen(false);
    setSignatureFieldId(null);
  };

  const handleClearSignature = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
    }
  };

  const handleCloseSignaturePad = () => {
    setSignaturePadOpen(false);
    setSignatureFieldId(null);
  };

  // Date picker handlers
  const handleSaveDate = () => {
    if (!dateFieldId) return;

    const dateValue = tempDate ? tempDate.toISOString().split('T')[0] : '';
    updateFieldValue(dateFieldId, dateValue);

    setDatePickerOpen(false);
    setDateFieldId(null);
    setTempDate(null);
  };

  const handleCloseDatePicker = () => {
    setDatePickerOpen(false);
    setDateFieldId(null);
    setTempDate(null);
  };

  // UPDATED: Enhanced submit function with proper file handling and approval check
  const handleSubmitDocument = async () => {
    if (!selectedDocument || !selectedProjectId || !selectedServiceTitle) return;

    // Prevent submission if already approved
    if (selectedDocument.isApproved || selectedDocument.isAccepted) {
      setErrorMessage('Cannot submit an already approved document');
      return;
    }

    const validation = validateRequiredFields();
    const editableValidation = selectedDocument.inputFields.filter(
      (field) =>
        field.isRequired &&
        field.isEmpEdit &&
        (!field.value || field.value.toString().trim() === '')
    );

    if (!validation.isValid) {
      const fieldsList = validation.missingFieldLabels.join(', ');
      setErrorMessage(`Please fill in all required fields before submitting: ${fieldsList}`);
      return;
    }

    if (editableValidation.length > 0) {
      const editableFields = editableValidation.map((f) => f.fieldLabel || f.type).join(', ');
      setErrorMessage(`Please fill in all required editable fields: ${editableFields}`);
      return;
    }

    // Check if document upload is required for empty template
    const isEmptyTemplate =
      !selectedDocument.uploadedFile?.storedFilePath ||
      selectedDocument.uploadedFile?.storedFilePath === '';
    const hasUploadedFile = uploadedFileData !== null;

    if (isEmptyTemplate && !hasUploadedFile) {
      setErrorMessage('Please upload a document before submitting');
      return;
    }

    setActionLoading('submit');

    try {
      const processedInputFields = selectedDocument.inputFields.map((field) => ({
        ...field,
        value: field.value || '',
        ...(field.isRequired &&
          !field.value && {
            value: field.type === 'signature' ? '' : field.fieldLabel || ''
          })
      }));

      // Handle file path based on template type
      let uploadedFileForPayload;

      if (isEmptyTemplate && hasUploadedFile) {
        // For empty templates, send base64 data as storedFilePath
        uploadedFileForPayload = {
          fileName: uploadedFileData.fileName,
          fileSize: uploadedFileData.fileSize,
          fileType: uploadedFileData.fileType,
          originalFileName: uploadedFileData.originalFileName,
          storedFilePath: uploadedFileData.base64Data // Send base64 as path
        };
      } else {
        // For existing templates, use existing file data as is
        uploadedFileForPayload = selectedDocument.uploadedFile;
      }

      const payload = {
        group_id: selectedProjectId,
        assignedId: selectedDocument.assignedId,
        service_id: selectedServiceTitle,
        documentId: selectedDocument.documentId,
        documentName: selectedDocument.documentName,
        documentDate: selectedDocument.documentDate,
        categoryId: selectedCategoryId,
        subCategoryId: selectedSubcategoryId,
        inputFields: processedInputFields,
        uploadedFile: uploadedFileForPayload,
        assignedEmployeeMailId: selectedDocument.assignedEmployeeMailId,
        assignedEmpName: selectedDocument.assignedEmpName
      };

      await dispatch(submitESignDoc(payload)).unwrap();
      setSuccessMessage('Document submitted successfully');
      handleClosePreview();

      // Reload documents
      await dispatch(
        getAllAssignedDocuments({
          group_id: selectedProjectId,
          service_id: selectedServiceTitle,
          isAdmin: isAdminLogin
        })
      ).unwrap();
    } catch (error: any) {
      if (error.includes('Missing values for required fields')) {
        const backendError = error.split(': ')[1] || 'unknown fields';
        setErrorMessage(
          `Backend validation failed. Missing required fields: ${backendError}. Please check all required fields are properly filled.`
        );
      } else {
        setErrorMessage(error || 'Failed to submit document');
      }
    } finally {
      setActionLoading(null);
    }
  };

  // Confirmation dialog handlers
  const handleOpenConfirmDialog = (document: AssignedDocument, action: ConfirmActionType) => {
    // Admin permission check
    if (!isAdminLogin) {
      showMessage('Only administrators can perform this action', true);
      return;
    }

    setConfirmDocument(document);
    setConfirmAction(action);
    setConfirmDialogOpen(true);
    setActionMenuAnchor(null);
    setCurrentActionDoc(null);
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setConfirmDocument(null);
    setConfirmAction(null);
  };

  // Fixed: Updated to use correct categoryId and subcategoryId
  const handleConfirmAction = async () => {
    if (!confirmDocument || !confirmAction || !selectedProjectId || !selectedServiceTitle) return;

    try {
      const mappedAction: 'accept' | 'delete' | 'reassign' =
        confirmAction === 'approve' ? 'accept' : (confirmAction as 'delete' | 'reassign');

      const payload: AcceptDeleteReassignDocPayload = {
        group_id: selectedProjectId,
        service_id: selectedServiceTitle,
        employeeMailId: confirmDocument.assignedEmployeeMailId,
        assignedId: confirmDocument.assignedId!,
        action: mappedAction,
        categoryId: selectedCategoryId,
        subcategoryId: selectedSubcategoryId
      };

      await dispatch(acceptDeleteReassignDoc(payload)).unwrap();
      handleCloseConfirmDialog();

      // Reload documents
      await dispatch(
        getAllAssignedDocuments({
          group_id: selectedProjectId,
          service_id: selectedServiceTitle,
          isAdmin: isAdminLogin,
          userEmail: userEmail
        })
      ).unwrap();
    } catch (error: any) {
      console.error('Action failed:', error);
    }
  };

  const handleDocumentAction = async (
    document: AssignedDocument,
    action: 'approve' | 'delete' | 'reassign'
  ) => {
    handleOpenConfirmDialog(document, action);
  };

  const handleActionMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    document: AssignedDocument
  ) => {
    event.stopPropagation();
    setActionMenuAnchor(event.currentTarget);
    setCurrentActionDoc(document);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchor(null);
    setCurrentActionDoc(null);
  };

  // Helper functions for ConfirmationDialog
  const getDialogTitle = () => {
    if (!confirmAction) return 'Confirm Action';
    switch (confirmAction) {
      case 'approve':
        return 'Confirm Approval';
      case 'delete':
        return 'Confirm Deletion';
      case 'reassign':
        return 'Confirm Reassignment';
      default:
        return 'Confirm Action';
    }
  };

  const getDialogMessage = () => {
    if (!confirmAction || !confirmDocument) return '';

    switch (confirmAction) {
      case 'approve':
        return `Are you sure you want to approve the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}?`;
      case 'delete':
        return `Are you sure you want to delete the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}? This action cannot be undone.`;
      case 'reassign':
        return `Are you sure you want to reassign the document "${confirmDocument.documentName}" assigned to ${confirmDocument.assignedEmpName}?`;
      default:
        return '';
    }
  };

  const getDialogButtonText = () => {
    if (!confirmAction) return 'Confirm';
    switch (confirmAction) {
      case 'approve':
        return 'Approve';
      case 'delete':
        return 'Delete';
      case 'reassign':
        return 'Reassign';
      default:
        return 'Confirm';
    }
  };

  const getDialogButtonColor = (): 'primary' | 'error' | 'success' => {
    if (!confirmAction) return 'primary';
    switch (confirmAction) {
      case 'approve':
        return 'success';
      case 'delete':
        return 'error';
      case 'reassign':
        return 'primary';
      default:
        return 'primary';
    }
  };

  // UPDATED: Empty template canvas renderer
  const renderEmptyTemplateCanvas = () => {
    return (
      <Box
        ref={pdfContainerRef}
        sx={{
          position: 'relative',
          width: '100%',
          height: 'calc(60vh - 80px)',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1.5,
          bgcolor: '#fafafa',
          overflow: 'auto',
          backgroundImage: `
            linear-gradient(rgba(156, 163, 175, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(156, 163, 175, 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '20px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Empty state message */}
        {(!selectedDocument?.inputFields || selectedDocument.inputFields.length === 0) && (
          <Box sx={{ textAlign: 'center', opacity: 0.6, zIndex: 1 }}>
            <MdDescription
              style={{ fontSize: isMobile ? 36 : 48, color: grey[400], marginBottom: 8 }}
            />
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: '0.75rem', mb: 0.5 }}
            >
              Empty Template Canvas
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.675rem' }}>
              Field overlays will appear here when positioned
            </Typography>
          </Box>
        )}

        {/* Upload area - only show when no document is uploaded */}
        {!documentPreviewUrl && (
          <Box
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              zIndex: 2
            }}
          >
            <Tooltip title="Upload Document">
              <IconButton
                onClick={() => window.document.getElementById('file-upload-input')?.click()}
                sx={{
                  bgcolor: theme.palette.primary.main,
                  color: 'white',
                  '&:hover': {
                    bgcolor: theme.palette.primary.dark
                  },
                  boxShadow: 2
                }}
                disabled={uploadLoading}
              >
                {uploadLoading ? (
                  <CircularProgress size={20} sx={{ color: 'white' }} />
                ) : (
                  <MdCloudUpload />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        )}

        {/* Render field overlays for empty template */}
        {selectedDocument?.inputFields &&
          selectedDocument.inputFields.length > 0 &&
          selectedDocument.inputFields
            .filter((field) => field.pageNumber === 1)
            .map((field) => (
              <AssignedInputFieldOverlay
                key={field.id}
                field={field}
                selectedDocument={selectedDocument}
                pdfContainerRef={pdfContainerRef as React.RefObject<HTMLDivElement>}
                handleFieldClick={handleFieldClick}
                updateFieldValue={updateFieldValue}
                isMobile={isMobile}
              />
            ))}
      </Box>
    );
  };

  // Enhanced thumbnail rendering function
  const renderThumbnail = (pageNumber: number) => {
    const isSelected = currentPdfPage === pageNumber;
    const fieldsOnPage =
      selectedDocument?.inputFields?.filter((field) => field.pageNumber === pageNumber) ?? [];

    return (
      <Box
        key={`thumbnail-${pageNumber}`}
        onClick={() => setCurrentPdfPage(pageNumber)}
        sx={{
          position: 'relative',
          cursor: 'pointer',
          border: isSelected ? '2px solid #1976d2' : '1px solid #ddd',
          borderRadius: 1,
          bgcolor: isSelected ? '#e3f2fd' : 'white',
          overflow: 'hidden',
          transition: 'all 0.2s ease',
          '&:hover': {
            borderColor: '#1976d2',
            transform: 'scale(1.02)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          },
          width: isMobile ? 60 : 80,
          height: isMobile ? 84 : 112,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 1,
          flexShrink: 0
        }}
      >
        <Document file={documentPreviewUrl} loading={null} error={null}>
          <Page
            pageNumber={pageNumber}
            width={isMobile ? 50 : 70}
            height={isMobile ? 70 : 98}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            loading={
              <Box
                sx={{
                  width: isMobile ? 50 : 70,
                  height: isMobile ? 70 : 98,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: grey[50]
                }}
              >
                <CircularProgress size={16} />
              </Box>
            }
            onRenderSuccess={() => {
              setThumbnailsLoaded((prev) => new Set([...Array.from(prev), pageNumber]));
            }}
          />
        </Document>

        <Box
          sx={{
            position: 'absolute',
            bottom: 2,
            left: 2,
            bgcolor: isSelected ? '#1976d2' : 'rgba(0,0,0,0.7)',
            color: 'white',
            px: 0.5,
            py: 0.25,
            borderRadius: 0.5,
            fontSize: isMobile ? '8px' : '10px',
            fontWeight: 600,
            lineHeight: 1,
            minWidth: 16,
            textAlign: 'center'
          }}
        >
          {pageNumber}
        </Box>

        {fieldsOnPage.length > 0 && (
          <Box
            sx={{
              position: 'absolute',
              top: 2,
              right: 2,
              bgcolor: '#ff9800',
              color: 'white',
              minWidth: 16,
              height: 16,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '8px' : '9px',
              fontWeight: 600,
              lineHeight: 1
            }}
          >
            {fieldsOnPage.length}
          </Box>
        )}
      </Box>
    );
  };

  // UPDATED: Enhanced PDF and Image preview with upload support and field tags
  const renderPdfPreviewWithTags = () => {
    const validation = validateRequiredFields();
    const requiredFieldsCount =
      selectedDocument?.inputFields?.filter((f) => f.isRequired && f.isEmpEdit).length || 0;
    const filledRequiredFieldsCount =
      selectedDocument?.inputFields?.filter(
        (f) => f.isRequired && f.isEmpEdit && f.value && f.value.toString().trim() !== ''
      ).length || 0;

    if (!selectedDocument) {
      return (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography color="text.secondary">No document selected</Typography>
        </Box>
      );
    }

    const isImageDocument = selectedDocument.uploadedFile?.fileType !== 'pdf';
    const isEmptyTemplate = !documentPreviewUrl;
    const isApproved = selectedDocument.isApproved || selectedDocument.isAccepted;

    return (
      <Box
        sx={{
          height: '70vh',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1.5,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Toolbar */}
        <Box
          sx={{
            borderBottom: `1px solid ${theme.palette.divider}`,
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: grey[50],
            flexShrink: 0
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {isEmptyTemplate ? (
              <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
                Empty Template - Upload document required
              </Typography>
            ) : isImageDocument ? (
              <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
                Image Document
              </Typography>
            ) : (
              <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
                Page {currentPdfPage} of {pdfNumPages}
              </Typography>
            )}

            {uploadedFileData && (
              <Chip
                label="Uploaded"
                size="small"
                sx={{
                  height: 20,
                  fontSize: '0.65rem',
                  bgcolor: `${blue[500]}15`,
                  color: blue[500]
                }}
              />
            )}

            {isApproved && (
              <Chip
                icon={<MdLock style={{ fontSize: 12 }} />}
                label="Approved (Read Only)"
                size="small"
                sx={{
                  height: 20,
                  fontSize: '0.65rem',
                  bgcolor: `${green[500]}15`,
                  color: green[500]
                }}
              />
            )}

            {selectedDocument?.inputFields && (
              <>
                <Chip
                  label={`${selectedDocument.inputFields.length} fields`}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: '0.65rem',
                    bgcolor: `${purple[500]}15`,
                    color: purple[500]
                  }}
                />
                <Chip
                  label={`${selectedDocument.inputFields.filter((f) => f.value).length} filled`}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: '0.65rem',
                    bgcolor: `${green[500]}15`,
                    color: green[500]
                  }}
                />
                {requiredFieldsCount > 0 && (
                  <Chip
                    label={`${filledRequiredFieldsCount}/${requiredFieldsCount} required`}
                    size="small"
                    sx={{
                      height: 20,
                      fontSize: '0.65rem',
                      bgcolor: validation.isValid ? `${green[500]}15` : `${red[500]}15`,
                      color: validation.isValid ? green[600] : red[600],
                      animation: !validation.isValid ? 'pulse 2s infinite' : 'none'
                    }}
                  />
                )}
              </>
            )}

            {documentModified && (
              <Chip
                label="Modified"
                size="small"
                sx={{
                  height: 20,
                  fontSize: '0.65rem',
                  bgcolor: `${orange[500]}15`,
                  color: orange[500]
                }}
              />
            )}

            {/* Upload button - only show for empty templates */}
            {isEmptyTemplate && !isApproved && (
              <Tooltip title="Upload Document">
                <IconButton
                  size="small"
                  onClick={() => window.document.getElementById('file-upload-input')?.click()}
                  disabled={uploadLoading}
                  sx={{
                    bgcolor: theme.palette.primary.main,
                    color: 'white',
                    width: 28,
                    height: 28,
                    '&:hover': {
                      bgcolor: theme.palette.primary.dark
                    }
                  }}
                >
                  {uploadLoading ? (
                    <CircularProgress size={16} sx={{ color: 'white' }} />
                  ) : (
                    <MdCloudUpload style={{ fontSize: 16 }} />
                  )}
                </IconButton>
              </Tooltip>
            )}

            {/* Download button */}
            {documentPreviewUrl && (
              <Tooltip title="Download Document">
                <IconButton
                  size="small"
                  onClick={() => {
                    if (isImageDocument) {
                      handleDownloadImageDoc(selectedDocument);
                    } else {
                      handleDownloadDocument(selectedDocument);
                    }
                  }}
                  disabled={downloadLoading === `download-${selectedDocument.documentId}`}
                  sx={{
                    bgcolor: purple[500],
                    color: 'white',
                    width: 28,
                    height: 28,
                    '&:hover': {
                      bgcolor: purple[600]
                    }
                  }}
                >
                  {downloadLoading === `download-${selectedDocument.documentId}` ? (
                    <CircularProgress size={16} sx={{ color: 'white' }} />
                  ) : (
                    <MdDownload style={{ fontSize: 16 }} />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </Box>

          {!isImageDocument && !isEmptyTemplate && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {/* Zoom controls */}
              <IconButton
                onClick={() => setScale(Math.max(0.5, scale - 0.1))}
                disabled={scale <= 0.5}
                size="small"
                sx={{ bgcolor: 'white', border: '1px solid #e0e0e0' }}
              >
                -
              </IconButton>
              <Typography
                variant="caption"
                sx={{
                  minWidth: '40px',
                  textAlign: 'center',
                  fontSize: '10px'
                }}
              >
                {Math.round(scale * 100)}%
              </Typography>
              <IconButton
                onClick={() => setScale(Math.min(2.0, scale + 0.1))}
                disabled={scale >= 2.0}
                size="small"
                sx={{ bgcolor: 'white', border: '1px solid #e0e0e0' }}
              >
                +
              </IconButton>

              {/* Page navigation */}
              {pdfNumPages > 1 && (
                <Box sx={{ display: 'flex', gap: 0.5, ml: 1 }}>
                  <Button
                    onClick={() => setCurrentPdfPage(Math.max(1, currentPdfPage - 1))}
                    disabled={currentPdfPage <= 1}
                    size="small"
                    sx={{
                      ...buttonStyles.base,
                      ...buttonStyles.sizes.small,
                      ...buttonStyles.variants.outlined,
                      minWidth: 40
                    }}
                  >
                    ←
                  </Button>
                  <Button
                    onClick={() => setCurrentPdfPage(Math.min(pdfNumPages, currentPdfPage + 1))}
                    disabled={currentPdfPage >= pdfNumPages}
                    size="small"
                    sx={{
                      ...buttonStyles.base,
                      ...buttonStyles.sizes.small,
                      ...buttonStyles.variants.outlined,
                      minWidth: 40
                    }}
                  >
                    →
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </Box>

        {/* Main Display Area with Thumbnails */}
        <Box
          sx={{
            flex: 1,
            overflow: 'hidden',
            position: 'relative',
            display: 'flex'
          }}
        >
          {/* Thumbnails Panel - Only show for PDF documents with multiple pages */}
          {!isEmptyTemplate && !isImageDocument && pdfNumPages > 1 && (
            <Box
              sx={{
                width: isMobile ? 80 : 100,
                borderRight: `1px solid ${theme.palette.divider}`,
                overflowY: 'auto',
                overflowX: 'hidden',
                p: 1,
                flexShrink: 0
              }}
            >
              <Typography
                sx={{
                  fontSize: '0.65rem',
                  fontWeight: 600,
                  color: 'text.secondary',
                  textAlign: 'center',
                  mb: 1
                }}
              >
                Pages ({pdfNumPages})
              </Typography>
              {Array.from({ length: pdfNumPages }, (_, i) => i + 1).map((pageNum) =>
                renderThumbnail(pageNum)
              )}
            </Box>
          )}

          {/* Document Display Area */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              position: 'relative'
            }}
          >
            {isEmptyTemplate ? (
              renderEmptyTemplateCanvas()
            ) : (
              // Document display with field overlays
              <Box
                ref={pdfContainerRef}
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  overflowX: 'auto',
                  p: 1,
                  bgcolor: grey[50],
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  minHeight: 0,
                  position: 'relative'
                }}
              >
                <Box sx={{ position: 'relative', width: 'fit-content', isolation: 'isolate' }}>
                  {isImageDocument ? (
                    <img
                      src={documentPreviewUrl || ''}
                      alt={selectedDocument.documentName}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                      onLoad={() => {
                        setPreviewLoading(false);
                        setPdfRenderTrigger((prev) => prev + 1);
                      }}
                    />
                  ) : (
                    <Document
                      file={documentPreviewUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      onLoadError={() => console.error('PDF load error')}
                      loading={
                        <Box sx={{ p: 4, textAlign: 'center' }}>
                          <CircularProgress size={24} />
                          <Typography sx={{ mt: 1 }}>Loading PDF...</Typography>
                        </Box>
                      }
                      error={
                        <Box sx={{ p: 4, textAlign: 'center' }}>
                          <Typography color="error">
                            Failed to load PDF. Please try again.
                          </Typography>
                        </Box>
                      }
                    >
                      <Page
                        pageNumber={currentPdfPage}
                        scale={scale}
                        width={calculatePdfWidth()}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        loading={<CircularProgress size={20} />}
                        onRenderSuccess={() => {
                          setTimeout(() => {
                            setPdfRenderTrigger((prev) => prev + 1);
                          }, 100);
                        }}
                      />
                    </Document>
                  )}

                  {/* Field Overlays - Show on uploaded documents too */}
                  {selectedDocument?.inputFields
                    ?.filter((field) => field.pageNumber === (isImageDocument ? 1 : currentPdfPage))
                    .map((field) => (
                      <AssignedInputFieldOverlay
                        key={field.id}
                        field={field}
                        selectedDocument={selectedDocument}
                        pdfContainerRef={pdfContainerRef as React.RefObject<HTMLDivElement>}
                        handleFieldClick={handleFieldClick}
                        updateFieldValue={updateFieldValue}
                        isMobile={isMobile}
                      />
                    ))}
                </Box>
              </Box>
            )}
          </Box>
        </Box>

        {/* Hidden file input */}
        <input
          id="file-upload-input"
          type="file"
          accept=".pdf,.jpg,.jpeg,.png"
          style={{ display: 'none' }}
          onChange={handleFileUpload}
          disabled={uploadLoading || isApproved || false}
        />
      </Box>
    );
  };

  // UPDATED: Enhanced Dialog Actions with upload validation and approval check
  const renderDialogActions = () => {
    const validation = validateRequiredFields();
    const editableRequiredFields =
      selectedDocument?.inputFields?.filter((f) => f.isRequired && f.isEmpEdit) || [];
    const editableRequiredFieldsEmpty = editableRequiredFields.filter(
      (f) => !f.value || f.value.toString().trim() === ''
    );

    // Check if document upload is required
    const isEmptyTemplate =
      !selectedDocument?.uploadedFile?.storedFilePath ||
      selectedDocument?.uploadedFile?.storedFilePath === '';
    const uploadRequired = isEmptyTemplate && !uploadedFileData;
    const isApproved = selectedDocument?.isApproved || selectedDocument?.isAccepted;

    const canSubmit =
      selectedDocument &&
      !isApproved &&
      validation.isValid &&
      editableRequiredFieldsEmpty.length === 0 &&
      !uploadRequired;

    return (
      <DialogActions sx={{ justifyContent: 'space-between', px: 2 }}>
        <Button onClick={handleClosePreview}>Close</Button>

        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {/* Enhanced validation warnings */}
          {selectedDocument && !isApproved && (
            <>
              {uploadRequired && (
                <Alert
                  severity="error"
                  sx={{
                    py: 0.5,
                    px: 1,
                    fontSize: '0.75rem',
                    '& .MuiAlert-message': { py: 0 }
                  }}
                >
                  Document upload required
                </Alert>
              )}

              {!validation.isValid && (
                <Alert
                  severity="error"
                  sx={{
                    py: 0.5,
                    px: 1,
                    fontSize: '0.75rem',
                    '& .MuiAlert-message': { py: 0 }
                  }}
                >
                  Missing required fields: {validation.missingFieldLabels.join(', ')}
                </Alert>
              )}

              {validation.isValid && editableRequiredFieldsEmpty.length > 0 && (
                <Alert
                  severity="warning"
                  sx={{
                    py: 0.5,
                    px: 1,
                    fontSize: '0.75rem',
                    '& .MuiAlert-message': { py: 0 }
                  }}
                >
                  Please fill: {editableRequiredFieldsEmpty.map((f) => f.fieldLabel).join(', ')}
                </Alert>
              )}
            </>
          )}

          {/* Approve button - only show to admin if submitted but not yet approved */}
          {isAdminLogin &&
            selectedDocument &&
            getDocumentStatus(selectedDocument) === 'filled_submitted' &&
            !isApproved && (
              <Button
                variant="contained"
                color="success"
                onClick={() => handleDocumentAction(selectedDocument, 'approve')}
                disabled={actionLoading?.includes(selectedDocument.documentId)}
                startIcon={<MdThumbUp />}
                sx={buttonStyles.base}
              >
                Approve
              </Button>
            )}

          {/* Submit button - only show if not approved */}
          {selectedDocument && !isApproved && (
            <Tooltip
              title={
                !canSubmit
                  ? uploadRequired
                    ? 'Please upload a document first'
                    : !validation.isValid
                    ? `Missing required fields: ${validation.missingFieldLabels.join(', ')}`
                    : editableRequiredFieldsEmpty.length > 0
                    ? `Please fill: ${editableRequiredFieldsEmpty
                        .map((f) => f.fieldLabel)
                        .join(', ')}`
                    : 'Unknown validation error'
                  : 'Submit document for review'
              }
            >
              <span>
                <Button
                  variant="contained"
                  onClick={handleSubmitDocument}
                  disabled={actionLoading === 'submit' || !canSubmit}
                  startIcon={
                    actionLoading === 'submit' ? <CircularProgress size={16} /> : <MdSend />
                  }
                  sx={{
                    ...buttonStyles.base,
                    ...buttonStyles.variants.contained,
                    ...(!canSubmit && {
                      bgcolor: red[500],
                      '&:hover': {
                        bgcolor: red[600]
                      }
                    })
                  }}
                >
                  {actionLoading === 'submit' ? 'Submitting...' : 'Submit Document'}
                </Button>
              </span>
            </Tooltip>
          )}

          {/* Read only indicator for approved documents */}
          {isApproved && (
            <Chip
              icon={<MdLock />}
              label="Document Approved - Read Only"
              sx={{
                bgcolor: `${green[500]}15`,
                color: green[600],
                fontWeight: 500
              }}
            />
          )}
        </Box>
      </DialogActions>
    );
  };

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
        <Stack
          direction="row"
          spacing={1.5}
          justifyContent="center"
          alignItems="center"
          sx={{ minHeight: '30vh' }}
        >
          <CircularProgress size={24} />
          <Typography sx={{ ...typography.bodyText }} color="text.secondary">
            Loading assigned documents...
          </Typography>
        </Stack>
      </Container>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ position: 'relative' }}>
        {/* Success Snackbar */}
        <Snackbar
          open={Boolean(successMessage)}
          autoHideDuration={4000}
          onClose={() => setSuccessMessage(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccessMessage(null)} severity="success" sx={{ width: '100%' }}>
            {successMessage}
          </Alert>
        </Snackbar>

        {/* Error Snackbar */}
        <Snackbar
          open={Boolean(errorMessage)}
          autoHideDuration={6000}
          onClose={() => setErrorMessage(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setErrorMessage(null)} severity="error" sx={{ width: '100%' }}>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Container maxWidth="xl" sx={{ px: { xs: 0.5, md: 1 }, py: { xs: 0.5, md: 1 } }}>
          {/* Page Header */}
          <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
            <Typography
              sx={{
                ...typography.mainTitle,
                fontWeight: 'bold',
                color: 'primary.main',
                mb: 0.5
              }}
            >
              Assigned Documents Review
            </Typography>
            <Typography
              sx={{
                ...typography.smallText,
                color: 'text.secondary'
              }}
            >
              Review and manage document assignments by category • {totalDocuments} total documents
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: { xs: 1.5, md: 2 }, borderRadius: 1.5 }}>
              <Typography sx={{ ...typography.smallText }}>Error: {error}</Typography>
            </Alert>
          )}

          {/* Two Column Layout */}
          <Grid container spacing={isMobile ? 1 : 1.5}>
            {/* Categories Panel (Left) */}
            {!isMobile && categoryData.length > 0 && (
              <Grid item sm={3}>
                <AssignedDocumentCategoriesList
                  categoryData={categoryData}
                  selectedCategory={selectedCategory}
                  selectedSubcategory={selectedSubcategory}
                  expandedCategories={expandedCategories}
                  getCategoryColor={getCategoryColor}
                  getCategoryIcon={getCategoryIcon}
                  handleCategoryToggle={handleCategoryToggle}
                  handleSubcategorySelect={handleSubcategorySelect}
                  typography={typography}
                />
              </Grid>
            )}

            {/* Documents Panel (Right) */}
            <Grid item xs={12} sm={isMobile ? 12 : 9}>
              <AssignedList
                filteredDocuments={filteredDocuments}
                selectedCategory={selectedCategory}
                selectedSubcategory={selectedSubcategory}
                searchTerm={searchTerm}
                statusFilter={statusFilter}
                isMobile={isMobile}
                actionLoading={actionLoading}
                acceptDeleteReassignLoading={acceptDeleteReassignLoading ?? false}
                getCategoryColor={getCategoryColor}
                getDocumentStatus={getDocumentStatus}
                formatDate={formatDate}
                handleSearch={handleSearch}
                handleStatusFilterChange={handleStatusFilterChange}
                handleClearFilters={handleClearFilters}
                handlePreviewDocument={handlePreviewDocument}
                handleDocumentAction={handleDocumentAction}
                handleActionMenuOpen={handleActionMenuOpen}
                statusColors={statusColors}
                statusIcons={statusIcons}
                statusLabels={statusLabels}
                typography={typography}
              />
            </Grid>
          </Grid>
        </Container>

        {/* Mobile Category Selector */}
        {isMobile && categoryData.length > 0 && (
          <>
            <Fab
              onClick={(e) => setCategoryMenuAnchor(e.currentTarget)}
              sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
                bgcolor: purple[500],
                color: 'white',
                width: 44,
                height: 44,
                '&:hover': {
                  bgcolor: purple[600]
                }
              }}
            >
              <MdCategory style={{ fontSize: 18 }} />
            </Fab>

            {/* Enhanced Category Menu with Subcategories */}
            <Menu
              anchorEl={categoryMenuAnchor}
              open={Boolean(categoryMenuAnchor)}
              onClose={() => setCategoryMenuAnchor(null)}
              transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              PaperProps={{
                sx: {
                  maxHeight: '70vh',
                  width: '280px',
                  borderRadius: 1.5
                }
              }}
            >
              {categoryData.map((category) => (
                <Box key={category.categoryId}>
                  <MenuItem
                    sx={{
                      flexDirection: 'column',
                      alignItems: 'stretch',
                      p: 0
                    }}
                  >
                    {/* Category Header */}
                    <Box
                      sx={{
                        p: 1.5,
                        width: '100%',
                        bgcolor:
                          selectedCategory === category.categoryName
                            ? `${getCategoryColor(category.categoryName)}08`
                            : 'transparent'
                      }}
                      onClick={() => handleCategoryToggle(category.categoryName)}
                    >
                      <Stack direction="row" alignItems="center" spacing={1}>
                        {React.cloneElement(getCategoryIcon(category.categoryName) as React.ReactElement<any>, {
                          style: { fontSize: 16, color: getCategoryColor(category.categoryName) }
                        })}
                        <Typography sx={{ ...typography.bodyText, fontWeight: 600 }}>
                          {category.categoryName}
                        </Typography>
                        <Chip
                          label={category.totalDocuments}
                          size="small"
                          sx={{
                            height: 16,
                            fontSize: '0.625rem',
                            bgcolor: `${getCategoryColor(category.categoryName)}15`,
                            color: getCategoryColor(category.categoryName)
                          }}
                        />
                      </Stack>
                    </Box>

                    {/* Subcategories */}
                    {expandedCategories.has(category.categoryName) && (
                      <Box sx={{ pl: 2, pb: 1 }}>
                        {category.subcategories.map((subcategory) => (
                          <Box
                            key={subcategory.subcategoryId}
                            sx={{
                              p: 1,
                              cursor: 'pointer',
                              borderRadius: 1,
                              bgcolor:
                                selectedCategory === category.categoryName &&
                                selectedSubcategory === subcategory.subcategoryName
                                  ? `${getCategoryColor(category.categoryName)}12`
                                  : 'transparent',
                              '&:hover': {
                                bgcolor: `${getCategoryColor(category.categoryName)}08`
                              }
                            }}
                            onClick={() =>
                              handleSubcategorySelect(
                                category.categoryName,
                                subcategory.subcategoryName
                              )
                            }
                          >
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <MdFolder
                                style={{
                                  fontSize: 12,
                                  color: getCategoryColor(category.categoryName)
                                }}
                              />
                              <Typography sx={{ ...typography.bodyText }}>
                                {subcategory.subcategoryName}
                              </Typography>
                              <Chip
                                label={subcategory.totalDocuments}
                                size="small"
                                sx={{
                                  height: 14,
                                  fontSize: '0.5625rem',
                                  bgcolor: `${getCategoryColor(category.categoryName)}10`,
                                  color: getCategoryColor(category.categoryName)
                                }}
                              />
                            </Stack>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </MenuItem>
                </Box>
              ))}
            </Menu>
          </>
        )}

        {/* Action Menu */}
        <Menu
          anchorEl={actionMenuAnchor}
          open={Boolean(actionMenuAnchor)}
          onClose={handleActionMenuClose}
        >
          {/* Only show admin actions if user is admin */}
          {isAdminLogin && (
            <>
              <MenuItem
                onClick={() =>
                  currentActionDoc && handleDocumentAction(currentActionDoc, 'approve')
                }
                disabled={acceptDeleteReassignLoading}
              >
                <MdCheckCircle style={{ marginRight: 8, fontSize: 16, color: green[600] }} />
                <Typography sx={{ ...typography.bodyText, color: green[600] }}>
                  Approve Document
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() =>
                  currentActionDoc && handleDocumentAction(currentActionDoc, 'reassign')
                }
                disabled={acceptDeleteReassignLoading}
              >
                <MdRestore style={{ marginRight: 8, fontSize: 16, color: orange[600] }} />
                <Typography sx={{ ...typography.bodyText, color: orange[600] }}>
                  Reassign Document
                </Typography>
              </MenuItem>
            </>
          )}

          {/* Only show delete if user is admin */}
          {isAdminLogin && (
            <MenuItem
              onClick={() => currentActionDoc && handleDocumentAction(currentActionDoc, 'delete')}
              disabled={acceptDeleteReassignLoading}
            >
              <MdDelete style={{ marginRight: 8, fontSize: 16, color: red[600] }} />
              <Typography sx={{ ...typography.bodyText, color: red[600] }}>Delete</Typography>
            </MenuItem>
          )}
        </Menu>

        {/* Fixed: Updated Confirmation Dialog */}
        <ConfirmationDialog
          open={confirmDialogOpen}
          title={getDialogTitle()}
          message={getDialogMessage()}
          confirmButtonText={getDialogButtonText()}
          confirmButtonColor={getDialogButtonColor()}
          onConfirm={handleConfirmAction}
          onCancel={handleCloseConfirmDialog}
          loading={acceptDeleteReassignLoading}
        />

        {/* Preview Modal */}
        <Dialog
          open={previewModalOpen}
          onClose={handleClosePreview}
          maxWidth="xl"
          fullWidth
          fullScreen={isMobile}
          PaperProps={{
            sx: {
              maxHeight: '95vh',
              height: isMobile ? '100vh' : '90vh'
            }
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Box>
              <Typography sx={{ ...typography.sectionTitle, fontWeight: 600 }}>
                {selectedDocument?.documentName}
              </Typography>
              <Typography sx={{ ...typography.smallText, color: 'text.secondary' }}>
                {selectedDocument?.assignedEmpName} • {selectedCategory} → {selectedSubcategory}
                {(selectedDocument?.isApproved || selectedDocument?.isAccepted) &&
                  ' • Approved (Read Only)'}
              </Typography>
            </Box>
            <IconButton onClick={handleClosePreview}>
              <MdClose />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 1 }}>
            {previewLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              renderPdfPreviewWithTags()
            )}
          </DialogContent>

          {renderDialogActions()}
        </Dialog>

        {/* Enhanced Edit Dialog */}
        <Dialog
          open={showEditDialog}
          onClose={() => setShowEditDialog(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 1.5,
              minHeight:
                selectedField?.type.toLowerCase() === 'signature'
                  ? isMobile
                    ? 320
                    : 380
                  : isMobile
                  ? 180
                  : 220,
              width:
                selectedField?.type.toLowerCase() === 'signature' ? undefined : isMobile ? 280 : 320
            }
          }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pb: 1,
              fontSize: isMobile ? '1rem' : '1.1rem'
            }}
          >
            {selectedField?.type.toLowerCase() === 'signature'
              ? 'Add Signature'
              : `Edit ${selectedField?.type || 'Field'}`}
            <IconButton
              onClick={() => setShowEditDialog(false)}
              size="small"
              sx={{ color: 'text.secondary' }}
            >
              <MdClose size={16} />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: isMobile ? 1.5 : 2 }}>
            {selectedField?.type.toLowerCase() === 'signature' ? (
              <>
                <Tabs
                  value={signatureMode}
                  onChange={(_, newValue) => setSignatureMode(newValue)}
                  variant="fullWidth"
                  sx={{
                    mb: 2,
                    '& .MuiTab-root': {
                      minHeight: 32,
                      fontSize: '0.75rem',
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 1
                    },
                    '& .MuiTabs-indicator': { height: 2 }
                  }}
                >
                  <Tab
                    icon={<MdGesture size={14} />}
                    label="Draw"
                    value="pad"
                    iconPosition="start"
                  />
                  <Tab
                    icon={<MdTextFields size={14} />}
                    label="Type"
                    value="name"
                    iconPosition="start"
                  />
                  <Tab
                    icon={<MdCheckBox size={14} />}
                    label="Check"
                    value="standard"
                    iconPosition="start"
                  />
                </Tabs>
                <Box
                  sx={{
                    minHeight: isMobile ? 140 : 180,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {signatureMode === 'pad' && (
                    <Paper
                      elevation={2}
                      sx={{
                        p: 1,
                        borderRadius: 1,
                        border: (theme) => `1px solid ${theme.palette.primary.main}20`
                      }}
                    >
                      <SignatureCanvas
                        ref={signatureCanvasRef}
                        canvasProps={{
                          width: isMobile ? 260 : 340,
                          height: isMobile ? 100 : 140,
                          style: {
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                            cursor: 'crosshair'
                          }
                        }}
                        penColor="black"
                        minWidth={1}
                        maxWidth={2.5}
                      />
                    </Paper>
                  )}
                  {signatureMode === 'name' && (
                    <Box sx={{ width: '100%', maxWidth: 320 }}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Your Full Name"
                        value={typedName}
                        onChange={(e) => setTypedName(e.target.value)}
                        placeholder="Enter your full name"
                        variant="outlined"
                        sx={{
                          mb: 2,
                          '& .MuiInputBase-input': {
                            fontSize: '0.9rem',
                            textAlign: 'center',
                            fontFamily: 'cursive'
                          }
                        }}
                      />
                      {typedName && (
                        <Paper
                          elevation={1}
                          sx={{
                            p: 2,
                            bgcolor: '#f8f9fa',
                            border: (theme) => `1px solid ${theme.palette.primary.main}20`,
                            textAlign: 'center'
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'cursive',
                              color: 'text.primary',
                              fontSize: '1.1rem'
                            }}
                          >
                            {typedName}
                          </Typography>
                        </Paper>
                      )}
                    </Box>
                  )}
                  {signatureMode === 'standard' && (
                    <Paper
                      elevation={1}
                      sx={{
                        p: 2,
                        bgcolor: '#f8f9fa',
                        border: (theme) => `1px solid ${theme.palette.primary.main}20`,
                        minWidth: 160
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isStandardChecked}
                            onChange={(e) => setIsStandardChecked(e.target.checked)}
                            sx={{
                              transform: 'scale(1.5)',
                              color: 'success.main',
                              '&.Mui-checked': { color: 'success.main' }
                            }}
                          />
                        }
                        label={
                          <Typography sx={{ ml: 1, fontSize: '0.9rem' }}>
                            Standard Checkmark
                          </Typography>
                        }
                      />
                    </Paper>
                  )}
                </Box>
              </>
            ) : (
              <Box sx={{ py: 1 }}>
                <TextField
                  fullWidth
                  size="small"
                  value={tempFieldValue}
                  onChange={(e) => setTempFieldValue(e.target.value)}
                  type={
                    selectedField?.type === 'date'
                      ? 'date'
                      : selectedField?.type === 'email'
                      ? 'email'
                      : 'text'
                  }
                  autoFocus
                  placeholder={`Enter ${selectedField?.type}`}
                  sx={{
                    mb: 1.5,
                    '& .MuiInputBase-input': { fontSize: '0.8rem' }
                  }}
                  InputLabelProps={selectedField?.type === 'date' ? { shrink: true } : {}}
                  helperText={
                    selectedField?.type === 'email'
                      ? 'Valid email address'
                      : selectedField?.type === 'date'
                      ? 'Select date'
                      : `Enter ${selectedField?.type} information`
                  }
                  FormHelperTextProps={{ sx: { fontSize: '0.65rem', mt: 0.5 } }}
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
            <Button
              onClick={() => {
                if (selectedField?.type.toLowerCase() === 'signature') {
                  if (signatureMode === 'pad' && signatureCanvasRef.current)
                    signatureCanvasRef.current.clear();
                  else if (signatureMode === 'name') setTypedName('');
                  else setIsStandardChecked(false);
                } else {
                  setTempFieldValue('');
                }
              }}
              color="secondary"
              size="small"
              variant="outlined"
              sx={{ fontSize: '0.75rem' }}
            >
              Clear
            </Button>
            <Stack direction="row" spacing={1}>
              <Button
                onClick={() => setShowEditDialog(false)}
                color="primary"
                size="small"
                variant="outlined"
                sx={{ fontSize: '0.75rem' }}
              >
                Cancel
              </Button>
              <Button
                onClick={
                  selectedField?.type.toLowerCase() === 'signature'
                    ? handleSignatureSave
                    : handleFieldSaveDialog
                }
                color="primary"
                size="small"
                variant="contained"
                disabled={
                  selectedField?.type.toLowerCase() === 'signature'
                    ? (signatureMode === 'pad' && signatureCanvasRef.current?.isEmpty()) ||
                      (signatureMode === 'name' && !typedName.trim()) ||
                      (signatureMode === 'standard' && !isStandardChecked)
                    : !tempFieldValue.trim()
                }
                sx={{ fontSize: '0.75rem' }}
              >
                Save
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>

        {/* Legacy Signature Pad Dialog */}
        <Dialog
          open={signaturePadOpen}
          onClose={handleCloseSignaturePad}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 1.5
            }
          }}
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Digital Signature
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please sign in the area below
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                border: '2px dashed #ccc',
                borderRadius: 1,
                p: 1,
                bgcolor: '#fafafa'
              }}
            >
              <SignatureCanvas
                ref={sigPadRef}
                canvasProps={{
                  width: 400,
                  height: 200,
                  style: {
                    width: '100%',
                    height: '200px',
                    border: 'none',
                    borderRadius: '4px',
                    backgroundColor: 'white'
                  }
                }}
                backgroundColor="white"
                penColor="black"
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button onClick={handleCloseSignaturePad} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleClearSignature} color="warning" variant="outlined">
              Clear
            </Button>
            <Button onClick={handleSaveSignature} variant="contained" color="primary">
              Save Signature
            </Button>
          </DialogActions>
        </Dialog>

        {/* Date Picker Dialog */}
        <Dialog
          open={datePickerOpen}
          onClose={handleCloseDatePicker}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 1.5
            }
          }}
        >
          <DialogTitle>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Select Date
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            <DatePicker
              value={tempDate}
              onChange={(newValue) => setTempDate(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                  sx: { mt: 1 }
                },
                openPickerButton: {
                  sx: {
                    color: 'primary.main'
                  }
                }
              }}
            />
          </DialogContent>
          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button onClick={handleCloseDatePicker} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleSaveDate} variant="contained" color="primary">
              Save Date
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </LocalizationProvider>
  );
};

export default AssignedDocumentsList;
